const stores_json= {
    "020634": {
        "Stato": "IT",
        "CAP": "64100",
        "Localit\u00e0": "SAN NICOLO' A TORDINO",
        "Indirizzo": "VIA G. GALILEI, 18",
        "N.ri Tel.": "0861 229124",
        "Insegna": "SOTTOSOPRA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03357-007294,25WBLDC11163-007110,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01134-007131,26SBLDC02175-007119,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC04268-007475,26SBLDC04269-007475,26SBLDC11099-007462,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDP01059-007441,26SBLDP01395-007524,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04109-007473,26SBLUC04201-007124,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03035-007441,26SBLUH02237-007439,26SBLUH02299-007439,26SBLUM01477-006233,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "021429": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02066-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02306-007440,26SBLUH02311-007132,26SBLUL02435-007520,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02298-007440",
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA XX SETTEMBRE, 62",
        "Insegna": "CONTAINER UOMO",
        "PRODUCT CODE KOOOMO": "26SBLUC11231-006787"
    },
    "015449": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA DEI MILLE II TRAVERSA",
        "N.ri Tel.": "0968/750121",
        "Insegna": "AMERICAN JEANS"
    },
    "017499": {
        "Stato": "IT",
        "CAP": "70010",
        "Localit\u00e0": "CAPURSO",
        "Indirizzo": "LARGO SAN FRANCESCO 5",
        "N.ri Tel.": "080 4559692",
        "Insegna": "KATERINA PI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047"
    },
    "005699": {
        "Stato": "IT",
        "CAP": "25036",
        "Localit\u00e0": "URGNANO",
        "Indirizzo": "VIALE EUROPA, 6",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958,25WBLUC03090-006719,26SBLDC01219-007108,26SBLUC02180-007104,26SBLUC04131-007449,26SBLUC11027-007462,26SBLUS01358-007499",
        "PRODUCT CODE KOOOMO": "26SBLUC02180-007104"
    },
    "022078": {
        "Stato": "PL",
        "CAP": "72-500",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "795 137 494",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02073-006648"
    },
    "000638": {
        "Stato": "IT",
        "CAP": "31050",
        "Localit\u00e0": "CASTRETTE DI VILLORBA",
        "Indirizzo": "VIA ROMA, 182/D",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLGC02391-006648,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,26SBLDX03166-007455,26SBLGC02380-006648,26SBLGC03410-007455,26SBLKC03373-006719,26SBLKX02365-005958",
        "PRODUCT CODE KOOOMO": "26SBLDX03166-007455"
    },
    "014348": {
        "Stato": "IT",
        "CAP": "96010",
        "Localit\u00e0": "SORTINO",
        "Indirizzo": "VIA LIBERTA' 101",
        "Insegna": "ELVIRA BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDK04249-007474,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "016589": {
        "Stato": "ES",
        "CAP": "17520",
        "Localit\u00e0": "PUIGCERDA ( GIRONA)",
        "Indirizzo": "C/ MAYOR N. 7",
        "N.ri Tel.": "0034 667367575",
        "Insegna": "BOUTIQUE ASPEN",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958"
    },
    "021244": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "97100",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PROVINCIALE 51",
        "N.ri Tel.": "0932 255194",
        "Insegna": "- "
    },
    "000679": {
        "Stato": "IT",
        "CAP": "30027",
        "Localit\u00e0": "SAN DONA' DI PIAVE",
        "Indirizzo": "VIA VANONI, 8",
        "N.ri Tel.": "0421 221515",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK11162-007110,25WBLKC02427-005958,25WBLUX02081-005958,26SBLGC01402-007111,26SBLGC01406-007462,26SBLKC01376-007108,26SBLUC03197-006719,26SBLUF01132-007448,26SBLUF08140-007448,26SBLUH02283-007480,26SBLUH02347-007495,26SBLUP01133-007448,26SBLUT02294-006801,26SBLUT02296-006801",
        "PRODUCT CODE KOOOMO": "26SBLUC03197-006719"
    },
    "000754": {
        "Stato": "IT",
        "CAP": "70010",
        "Localit\u00e0": "CASAMASSIMA",
        "Indirizzo": "SS100 KM 18 C/O IL BARICENTRO LOT. 20/B MOD. 4-5-6",
        "N.ri Tel.": "080 6970050",
        "Insegna": "TOP SPORT SRL - DEST. CASAMASSIMA",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDF08248-006948,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC03169-007455,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDH02211-007439,26SBLDH02412-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDH02418-006845,26SBLDP03351-007496,26SBLDP03352-007496,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUH02068-007439,26SBLUH02236-007439,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUT02290-006803,26SBLUT02297-006801,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "008414": {
        "Stato": "IT",
        "CAP": "75024",
        "Localit\u00e0": "MONTESCAGLIOSO",
        "Indirizzo": "CORSO REPUBBLICA 39",
        "N.ri Tel.": "0835 207526",
        "Insegna": "TOP TEN",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03097-006047,25WBLDK02192-006648,25WBLDK03098-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02173-007104,26SBLUB01024-007111,26SBLUC01106-007101,26SBLUH02302-007439,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "000858": {
        "Stato": "IT",
        "CAP": "10142",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO PESCHIERA, 291",
        "N.ri Tel.": "011 727449",
        "Insegna": "FORNASIERI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "014422": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA NAZIONALE DELLE PUGLIE 21",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308"
    },
    "015644": {
        "Stato": "IT",
        "CAP": "07044",
        "Localit\u00e0": "ITTIRI",
        "Indirizzo": "VIA GUGLIELMO MARCONI, 47/49",
        "N.ri Tel.": "3475339168",
        "Insegna": "TAVERNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "015808": {
        "Stato": "IT",
        "CAP": "00143",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "c/o C-C- MAXIMO (da confermare) - Quartiere Laurentino",
        "N.ri Tel.": "06 87074325",
        "Insegna": "NEGOZI PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03092-006719,25WBLDC03099-006047,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUX02081-005958"
    },
    "009810": {
        "Stato": "IT",
        "CAP": "10057",
        "Localit\u00e0": "S. AMBROGIO DI TORINO",
        "Indirizzo": "VIA CADUTI PER LA PATRIA, 14",
        "N.ri Tel.": "011 939123",
        "Insegna": "BOETTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUX02081-005958"
    },
    "020551": {
        "Stato": "IT",
        "CAP": "84050",
        "Localit\u00e0": "POLLA",
        "Indirizzo": "VIA LUISA SPAGNOLI, 40",
        "N.ri Tel.": "0974-980236",
        "Insegna": "IANNUZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "013693": {
        "Stato": "IT",
        "CAP": "84085",
        "Localit\u00e0": "MERCATO SAN SEVERINO",
        "Indirizzo": "CORSO DIAZ, 107-109",
        "N.ri Tel.": "089825519",
        "Insegna": "LA GIOVANE IDEA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "016281": {
        "Stato": "IT",
        "CAP": "56031",
        "Localit\u00e0": "BIANTINA",
        "Indirizzo": "VIA DEL MONTE EST, 91",
        "N.ri Tel.": "0587 398155",
        "Insegna": "DIVO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355"
    },
    "008659": {
        "Stato": "IT",
        "CAP": "74017",
        "Localit\u00e0": "MOTTOLA",
        "Indirizzo": "VIA RISORGIMENTO, 1",
        "N.ri Tel.": "099 8861621",
        "Insegna": "VERTICE DONNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK11162-007110,26SBLDC01219-007108,26SBLDC02173-007104,26SBLDC11099-007462,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "013796": {
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIA MIRTO, 11",
        "N.ri Tel.": "349-6753489",
        "Insegna": "LE VETRINE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC03177-006719"
    },
    "008381": {
        "Stato": "ES",
        "CAP": "08221",
        "Localit\u00e0": "TARRASA - BARCELONA",
        "Indirizzo": "C/FONT VELLA 54",
        "N.ri Tel.": "937830462",
        "Insegna": "NURIA PENINA",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05301-006434,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "007462": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "GROTTE",
        "Indirizzo": "VIA DON LUIGI STURZO, 11",
        "N.ri Tel.": "0922 945637",
        "Insegna": "PILATO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK01376-007378,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,26SBLDC01098-007111,26SBLDC01217-007108,26SBLDC02174-006648,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC04192-007474,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC01107-007101,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11019-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02065-006526,26SBLUH02238-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUH02541-007608,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "017190": {
        "Stato": "IT",
        "CAP": "88811",
        "Localit\u00e0": "CIRO' MARINA",
        "Indirizzo": "VIALE DELLA LIBERTA', 79",
        "N.ri Tel.": "0962 1905259",
        "Insegna": "GENTILE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC02175-007119,26SBLDC11099-007462,26SBLUC03177-006719,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02237-007439,26SBLUH02306-007440,26SBLUH02317-005695,26SBLUL02441-007515,26SBLUL02443-007514,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "021082": {
        "Stato": "ES",
        "CAP": "63741",
        "Localit\u00e0": "PRAHA 10",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047"
    },
    "010059": {
        "Stato": "IT",
        "CAP": "30126",
        "Localit\u00e0": "VENEZIA Loc. LIDO",
        "Indirizzo": "VIA LEPANTO, 8",
        "N.ri Tel.": "041 5265030",
        "Insegna": "ARBOR STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLDK11162-007110,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDF01114-006804,26SBLDK11147-007111,26SBLDP05117-006804,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "013392": {
        "Stato": "ES",
        "CAP": "17002",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "JOAN MARAGALL 15",
        "N.ri Tel.": "+34 620022344",
        "Insegna": "WHITE ICE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05300-006434,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUC01107-007101,26SBLUC11231-006787,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUT02288-007479,26SBLUT02291-006803",
        "PRODUCT CODE KOOOMO": "26SBLUC01107-007101"
    },
    "002392": {
        "Stato": "IT",
        "CAP": "20019",
        "Localit\u00e0": "SETTIMO MILANESE",
        "Indirizzo": "VIA D'ADDA, 20",
        "N.ri Tel.": "02 33500036",
        "Insegna": "PROGETTO MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUA05298-006127,25WBLUC03233-007308,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02173-007104,26SBLDH02211-007439,26SBLUC02179-007104,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02313-005695,26SBLUM06472-007529,26SBLUP02037-007441,26SBLUP03329-007496,26SBLUP04334-007493,26SBLUS01126-007453,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "017504": {
        "Stato": "IT",
        "CAP": "75014",
        "Localit\u00e0": "GRASSANO",
        "Indirizzo": "VIA MERIDIONALE 122",
        "N.ri Tel.": "0835721025",
        "Insegna": "BOUTIQUE ANNECCA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC02281-007476,26SBLDC11099-007462,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDP05326-007484,26SBLDV02341-007526,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11071-007462,26SBLUH02348-007495,26SBLUL02441-007515,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02295-006801,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "021077": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA GIOVANNI GIOLITTI,  7/A",
        "N.ri Tel.": "081-7580386",
        "Insegna": "FALDEA STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUF03119-007121,25WBLUX02081-005958"
    },
    "011139": {
        "Stato": "IT",
        "CAP": "00173",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA TUSCOLANA, 1243",
        "N.ri Tel.": "06-45509193",
        "Insegna": "BCL GROUP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUS02271-007502,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02293-006801,26SBLUT02298-007440,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "008123": {
        "CODICE PRODOTTO KOOOMO": "26SBLUN02129-007447",
        "Stato": "IT",
        "CAP": "19100",
        "Localit\u00e0": "LA SPEZIA",
        "Indirizzo": "VIA FONTEVIVO - BOX 1  C/o  C.C. LE TERRAZZE",
        "Insegna": "NUVOLARI",
        "PRODUCT CODE KOOOMO": "26SBLUN02129-007447"
    },
    "009008": {
        "Stato": "IT",
        "CAP": "80010",
        "Localit\u00e0": "QUARTO",
        "Indirizzo": "VIA MASULLO, 37",
        "N.ri Tel.": "081 8762000",
        "Insegna": "GALLERY 66",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110"
    },
    "016746": {
        "Stato": "IT",
        "CAP": "89013",
        "Localit\u00e0": "GIOIA TAURO",
        "Indirizzo": "VIA ROMA, 48",
        "N.ri Tel.": "331 4938824",
        "Insegna": "IL MONDO DELLE COCCINELLE",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBLGC02382-006648,26SBLGC02385-007459,26SBLGC03410-007455,26SBLKC01403-007462,26SBLKC03373-006719,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02525-007558,26SBLKN02491-007542,26SBLKP05519-007557,26SBLKT02514-007559,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC02382-006648"
    },
    "015729": {
        "CODICE PRODOTTO KOOOMO": "26SBLUA04468-007527,26SBLUA04470-007525,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUH02233-007457,26SBLUH02234-007457,26SBLUH02302-007439,26SBLUH02312-007132,26SBLUH02313-005695,26SBLUH02314-005695,26SBLUM06472-007529,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP03329-007494,26SBLUP04036-007441,26SBLUP04334-007493,26SBLUP05150-007448,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUT02297-006801,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04004-007493",
        "Stato": "RU",
        "CAP": "-",
        "Localit\u00e0": "YAROSLAV",
        "Indirizzo": "RESPUBLICANSKAYA, 84",
        "Insegna": "OOO UNIQUE",
        "PRODUCT CODE KOOOMO": "26SBLUA04468-007527"
    },
    "015080": {
        "Stato": "IT",
        "CAP": "04023",
        "Localit\u00e0": "FORMIA",
        "Indirizzo": "Via Mamurrano loc. S. Croce",
        "N.ri Tel.": "0776/310774",
        "Insegna": "TREND STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355"
    },
    "018556": {
        "Stato": "IT",
        "CAP": "09040",
        "Localit\u00e0": "SENORBI",
        "Indirizzo": "VIA CARLO SANNA, 148",
        "N.ri Tel.": "3202723015",
        "Insegna": "TENEREZZE",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKA05458-006127,26SBLKH02511-007558,26SBLKH02513-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLKH02511-007558"
    },
    "000344": {
        "Stato": "IT",
        "CAP": "13866",
        "Localit\u00e0": "MASSERANO",
        "Indirizzo": "VIA REPUBBLICA, 26 FRAZ. S.GIACOMO",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDK03102-006047,25WBLGC02391-006648,26SBLDC02206-007459,26SBLUB04119-007449,26SBLUC03178-006719,26SBLUF02240-006804,26SBLUH02068-007439,26SBLUH02284-007480",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "023311": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "937960308",
        "Insegna": "- "
    },
    "014421": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480,26SBLDC02206-007459,26SBLDH02411-005707,26SBLDH02414-005707,26SBLDP03351-007496,26SBLUA04463-007525,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUH02068-007439,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUP03329-007496,26SBLUP04332-007493,26SBLUS01358-007499,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "73049",
        "Localit\u00e0": "RUFFANO",
        "Indirizzo": "VIA POMPONIO D'URSO 85",
        "N.ri Tel.": "0833/693501",
        "Insegna": "TERZO MILLENIO FASHION JEANS",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "004572": {
        "Stato": "IT",
        "CAP": "21016",
        "Localit\u00e0": "LUINO",
        "Indirizzo": "VIA XV AGOSTO, 20/22",
        "N.ri Tel.": "0332 537689",
        "Insegna": "CRESPI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "014095": {
        "Stato": "IT",
        "CAP": "84012",
        "Localit\u00e0": "ANGRI",
        "Indirizzo": "VIA ZURLO 13 15",
        "Insegna": "FAST FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUP05244-006804,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02296-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "001936": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "LECCE",
        "Indirizzo": "VIA ZANARDELLI, 28",
        "N.ri Tel.": "0832 458566",
        "Insegna": "CRAZY SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDF08248-006948,25WBLDK03103-006047,25WBLDK11162-007110,25WBLDM01463-007330,25WBLDP01295-007323,25WBLUA05297-006127,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,25WBLUK11140-007286,26SBLDC02281-007476,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDP03351-007496,26SBLDS01345-007506,26SBLDS04343-007506,26SBLDS04392-007506,26SBLUB04119-007449,26SBLUC02179-007104,26SBLUC11005-007123,26SBLUC11113-006787,26SBLUH02068-007439,26SBLUH02238-007439,26SBLUH02302-007439,26SBLUH02347-007495,26SBLUH02541-007608,26SBLUH04349-007495,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02297-006801,26SBLUT02309-007132,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02281-007476"
    },
    "018999": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "S.G.GEMINI",
        "Indirizzo": "CORSO F. CRISPI, 200",
        "N.ri Tel.": "0922 900997",
        "Insegna": "REINOLDS",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP01494-007570,26SBLGC02380-006648,26SBLGC02385-007459,26SBLGF02507-007557,26SBLGF03506-007557,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKA04464-007525,26SBLKC02364-005958,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKH02513-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXF03497-007570"
    },
    "000359": {
        "CODICE PRODOTTO KOOOMO": "25WBLUL01314-007012",
        "Stato": "IT",
        "CAP": "20035",
        "Localit\u00e0": "LISSONE",
        "Indirizzo": "VIA NUOVA VALASSINA, 346",
        "N.ri Tel.": "039 9908685",
        "Insegna": "- "
    },
    "022459": {
        "Stato": "PL",
        "CAP": "77933",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK05019-007298,25WBLGC02391-006648,25WBLUC02151-007287,25WBLUK11140-007286"
    },
    "015127": {
        "Stato": "IT",
        "CAP": "22040",
        "Localit\u00e0": "ANZANO DEL PARCO",
        "Indirizzo": "VIA PROVINCIALE, 4",
        "N.ri Tel.": "031/630080",
        "Insegna": "COITER",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLKC02364-005958,26SBLKX02365-005958,26SBLUC01108-007101,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUH02299-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01108-007101"
    },
    "019444": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287",
        "Stato": "DE",
        "CAP": "96264",
        "Localit\u00e0": "ALTENKUNSTADT",
        "Indirizzo": "GEWERBEGEBIET 1",
        "Insegna": "- "
    },
    "009760": {
        "Stato": "IT",
        "CAP": "09128",
        "Localit\u00e0": "CAGLIARI",
        "Indirizzo": "VIA G.B. PERGOLESI, 25",
        "N.ri Tel.": "070 497714",
        "Insegna": "IL CLUB SPORTIVO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUL01316-007012,26SBLUB04119-007449,26SBLUC01106-007101,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02068-007439,26SBLUH02314-005695,26SBLUP01245-006804,26SBLUP05244-006804,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "001007": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "CORSO MAZZINI, 220/222",
        "N.ri Tel.": "0984 25843",
        "Insegna": "NEW LINE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,26SBLDC02176-006648,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDV05282-007475,26SBLUA04463-007525,26SBLUC02179-007104,26SBLUF02240-006804,26SBLUH02299-007439,26SBLUL02434-007520,26SBLUL02441-007515,26SBLUP05244-006804,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "018415": {
        "Stato": "IT",
        "CAP": "25037",
        "Localit\u00e0": "TIRANO",
        "Indirizzo": "VIALE ITALIA, 163C",
        "N.ri Tel.": "3931552251",
        "Insegna": "MODARTE",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958,26SBLGC01390-007131,26SBLGF02507-007557,26SBLGF03506-007557,26SBLGH02502-007558,26SBLGP01509-007557,26SBLGP05508-007557,26SBLKC01403-007462,26SBLKF02527-007557,26SBLKF03517-007557,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01390-007131"
    },
    "013285": {
        "Stato": "ES",
        "CAP": "09004",
        "Localit\u00e0": "BURGOS",
        "Indirizzo": "CALLE VICTORIA 13",
        "N.ri Tel.": "620994026",
        "Insegna": "BURWEAR",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUA05298-006127,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUF02118-007121,25WBLUK03142-005480,25WBLUK11140-007286,26SBLDK11147-007111,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUB04226-007124,26SBLUC01022-007110,26SBLUC01200-007108,26SBLUC02207-007459,26SBLUC03178-006719,26SBLUC11020-007110,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02246-007457,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUM06481-007167,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02321-007481,99CBLDA09007-007795",
        "PRODUCT CODE KOOOMO": "26SBLDK11147-007111"
    },
    "018169": {
        "Stato": "IT",
        "CAP": "07026",
        "Localit\u00e0": "OLBIA",
        "Indirizzo": "S.S. 125 ORIENTALE SARDA",
        "N.ri Tel.": "078958344",
        "Insegna": "GENTRY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480,26SBLDC03168-007455,26SBLDC04077-007474,26SBLDC04460-007475,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH03328-007483,26SBLDP01395-007524,26SBLDP05058-007441,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03168-007455"
    },
    "023512": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLUC06082-005480,25WBLUC08078-006355",
        "Stato": "ES",
        "CAP": "73951",
        "Localit\u00e0": "Sitges",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "977345643",
        "Insegna": "- "
    },
    "020871": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "58015",
        "Localit\u00e0": "ORBETELLO",
        "Indirizzo": "CORSO ITALIA, 44",
        "N.ri Tel.": "0564 9167692",
        "Insegna": "VOO MOOD"
    },
    "013410": {
        "Stato": "IT",
        "CAP": "73014",
        "Localit\u00e0": "GALLIPOLI",
        "Indirizzo": "VIA SAN LAZZARO 15",
        "N.ri Tel.": "0833/835235",
        "Insegna": "GOGGI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,26SBLUC11018-007110,26SBLUH02237-007439,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUT02293-006801,26SBLUT02295-006801",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "018555": {
        "Stato": "IT",
        "CAP": "61032",
        "Localit\u00e0": "BELLOCCHI DI FANO",
        "Indirizzo": "VIA LUIGI EINAUDI, 90",
        "N.ri Tel.": "0717950215",
        "Insegna": "FEDERICO GIOMMI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC02172-007104,26SBLDC02228-007119,26SBLUC02207-007459,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUH02302-007439,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "004804": {
        "Stato": "ES",
        "CAP": "33002",
        "Localit\u00e0": "OVIEDO",
        "Indirizzo": "CALLE PALACIO VALDES, 9 4 K",
        "N.ri Tel.": "985207544",
        "Insegna": "KOPA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03161-006719,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK11140-007286,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDF01104-007441,26SBLDK11147-007111,26SBLDV01339-007526,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUS04360-007499",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "018831": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03527-006047,25WBLDK05019-007298,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "60121",
        "Localit\u00e0": "ANCONA",
        "Indirizzo": "CORSO GARIBALDI 115",
        "N.ri Tel.": "3205672142",
        "Insegna": "+39"
    },
    "021973": {
        "Stato": "GB",
        "CAP": "S11 8QF",
        "Localit\u00e0": "Sheffield",
        "Indirizzo": "10 Hickmott Road",
        "N.ri Tel.": "+44 7583 130736",
        "Insegna": "Partners Menswear",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02153-007300,25WBLUC03090-006719,25WBLUF02118-007121,25WBLUX02081-005958"
    },
    "021088": {
        "Stato": "IT",
        "CAP": "84128",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA SCOPARI, 5",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110"
    },
    "019254": {
        "Stato": "ES",
        "CAP": "39300",
        "Localit\u00e0": "TORRELAVEGA - CANTABRIA",
        "Indirizzo": "CALLE JOSE FELIPE QUIJANO (ANCHA) 2",
        "N.ri Tel.": "942880840",
        "Insegna": "ADRIANA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDK03101-006047,26SBLDC01262-007101,26SBLDC04077-007474,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02327-007483,26SBLDH03328-007483,26SBLDP01059-007441,26SBLDP02278-007475,26SBLDS04392-007506,26SBLDV02341-007526,26SBLDV03258-007464",
        "PRODUCT CODE KOOOMO": "26SBLDC01262-007101"
    },
    "014211": {
        "Stato": "IT",
        "CAP": "66034",
        "Localit\u00e0": "LANCIANO",
        "Indirizzo": "VIA SANTO SPIRITO , 119",
        "N.ri Tel.": "0872712288",
        "Insegna": "OT STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03527-006047,25WBLDK05019-007298,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC11099-007462,26SBLUA04463-007525,26SBLUC02179-007104,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUH02069-007439,26SBLUH02284-007480,26SBLUH02314-005695,26SBLUT02290-006803,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "000417": {
        "Stato": "IT",
        "CAP": "22071",
        "Localit\u00e0": "CADORAGO",
        "Indirizzo": "VIA MAMELI, 16",
        "N.ri Tel.": "031 904542",
        "Insegna": "MAGDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,26SBLDC01130-007101,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDK11147-007111,26SBLDP01059-007441,26SBLUC01022-007110,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11018-007110,26SBLUF01032-007441,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUM01477-006233,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01130-007101"
    },
    "023335": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDK11162-007110,25WBLUC02132-007284",
        "Stato": "IT",
        "CAP": "95463",
        "Localit\u00e0": "ZEVIO",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "973249885",
        "Insegna": "- "
    },
    "016842": {
        "Stato": "DE",
        "CAP": "33330",
        "Localit\u00e0": "Paderborn",
        "Indirizzo": "Westernstrasse 22-24",
        "N.ri Tel.": "+4952512860",
        "Insegna": "Klingenthal (Guetersloh)",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK02073-006648,25WBLDK02192-006648,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC02228-007119,26SBLDC03168-007455,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "021586": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIALE TRICESIMO, 187",
        "N.ri Tel.": "660988497",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047"
    },
    "001074": {
        "Stato": "IT",
        "CAP": "20137",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIALE CORSICA, 33",
        "N.ri Tel.": "02 715006",
        "Insegna": "V&V",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02151-007287,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUK03142-005480"
    },
    "018336": {
        "Stato": "IT",
        "CAP": "09028",
        "Localit\u00e0": "SESTU",
        "Indirizzo": "EX STRADA STATALE 131 KM 10,800",
        "N.ri Tel.": "070 22056",
        "Insegna": "ANTUOFERMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC11083-007110,25WBLUL01316-007012,26SBLUC01106-007101,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUP04142-007448,26SBLUS01358-007499,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "011352": {
        "Stato": "IT",
        "CAP": "80022",
        "Localit\u00e0": "ARZANO",
        "Indirizzo": "VIA ATELLANA, 46",
        "N.ri Tel.": "081/5730383",
        "Insegna": "MIDA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLKC02427-005958,25WBLKC03400-007308,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLGC01402-007111,26SBLKC11423-007110,26SBLKH02511-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKT02431-007440,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02295-006801,26SBLUT02298-007440,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "018898": {
        "Stato": "IT",
        "CAP": "96100",
        "Localit\u00e0": "SIRACUSA",
        "Indirizzo": "VIA TISIA, 35",
        "N.ri Tel.": "0931 464505",
        "Insegna": "POP OFF",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01136-007110,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDX02171-006648,26SBLUC02179-007104,26SBLUC02182-005958,26SBLUC02185-005958,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02306-007440,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "017456": {
        "Stato": "IT",
        "CAP": "73042",
        "Localit\u00e0": "CASARANO",
        "Indirizzo": "ZONA INDUSTRIALE TRONCO A 5/6",
        "N.ri Tel.": "0833 502452",
        "Insegna": "MAXIMUS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03173-007307,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355"
    },
    "015253": {
        "Stato": "IT",
        "CAP": "00178",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA LUCREZIA ROMANA, 126",
        "N.ri Tel.": "0672670347",
        "Insegna": "SIR STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL02318-007340,26SBLDC01218-007108,26SBLDC03169-007455,26SBLGC03410-007455,26SBLKC03373-006719,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUT02307-007132,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "014293": {
        "Stato": "IT",
        "CAP": "98071",
        "Localit\u00e0": "CAPO D'ORLANDO",
        "Indirizzo": "VIA CRISPI 41/43",
        "N.ri Tel.": "0941-912488",
        "Insegna": "MANGANO",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,26SBLKF02516-007557,26SBLKF03529-007557,26SBLKH02511-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUF03243-006804,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUH02541-007608,26SBLUP02336-007493,26SBLUP04334-007493,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02294-006801,26SBLUT02298-007440,26SBLUT02309-007132,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUF01239-006804"
    },
    "021678": {
        "Stato": "RU",
        "CAP": "97-306",
        "Localit\u00e0": "Tallinn",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "02/8321103",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355"
    },
    "000329": {
        "Stato": "IT",
        "CAP": "10034",
        "Localit\u00e0": "CHIVASSO",
        "Indirizzo": "VIA TORINO, 24/B",
        "N.ri Tel.": "011 8971766",
        "Insegna": "ULTIMO IMPERO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03165-007455,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUT02294-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "017595": {
        "Stato": "IT",
        "CAP": "92100",
        "Localit\u00e0": "AGRIGENTO",
        "Indirizzo": "VIA ATENEA 159",
        "N.ri Tel.": "092222230",
        "Insegna": "CALABRO'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUX02081-005958"
    },
    "004888": {
        "Stato": "ES",
        "CAP": "08242",
        "Localit\u00e0": "MANRESA (BARCELONA)",
        "Indirizzo": "CALLE CARRIO 37",
        "N.ri Tel.": "93 742 21 98",
        "Insegna": "SEVEN PAM I PIPA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK03103-006047,25WBLUA05299-006127,25WBLUC03074-006355,26SBLDC01098-007111,26SBLDC04077-007474,26SBLDF01104-007441,26SBLDH03413-005707,26SBLDT02086-006526,26SBLDV03258-007464,26SBLUA04468-007527,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUT02064-006526,26SBLUT02296-006801,26SBLUT02303-007440",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "019199": {
        "Stato": "IT",
        "CAP": "19038",
        "Localit\u00e0": "SARZANA",
        "Indirizzo": "PIAZZA GARIBALDI, 19",
        "N.ri Tel.": "0187 621890",
        "Insegna": "QUASAR",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,26SBLDC03169-007455,26SBLUC04139-007449,26SBLUF02240-006804,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02347-007495,26SBLUP02336-007493,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02296-006801,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "020682": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC08078-006355,26SBLDC04192-007474,26SBLDC11095-007110,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDP01059-007441,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUP02037-007441,26SBLUT02064-006526,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "95024",
        "Localit\u00e0": "ACIREALE",
        "Indirizzo": "CORSO SAVOIA, 72/74",
        "N.ri Tel.": "3717602413",
        "Insegna": "MAP",
        "PRODUCT CODE KOOOMO": "26SBLDC04192-007474"
    },
    "023644": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBBXC02456-005958,25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDA05338-006127,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC02506-007254,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDC03357-007294,25WBLDC11163-007110,25WBLDF08236-007301,25WBLDF08248-006948,25WBLDK01375-007378,25WBLDK01376-007378,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLDK03182-006985,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDK05019-007298,25WBLDK11162-007110,25WBLDL01340-007355,25WBLDL01346-007354,25WBLDM01463-007330,25WBLDP01295-007323,25WBLDX03181-006985,25WBLGA05461-007349,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308,25WBLKC11416-007110,25WBLUA05297-006127,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUA05300-006434,25WBLUA05301-006434,25WBLUB05126-007283,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02151-007287,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUF02118-007121,25WBLUF03119-007121,25WBLUK03142-005480,25WBLUK11140-007286,25WBLUL01314-007012,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "65100",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "VIA MESTRINO 47/L",
        "N.ri Tel.": "041 5731819",
        "Insegna": "- "
    },
    "001781": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIA LUIGI EINAUDI, 56",
        "N.ri Tel.": "081 7741809",
        "Insegna": "JOICE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC01134-007131,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP02037-007441,26SBLUP04016-007121,26SBLUS02271-007502,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "016481": {
        "Stato": "IT",
        "CAP": "55045",
        "Localit\u00e0": "MARINA DI PIETRASANTA",
        "Indirizzo": "VIA VERSILIA, 35",
        "N.ri Tel.": "3355913041",
        "Insegna": "MARESIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC08078-006355"
    },
    "016123": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01218-007108,26SBLDC02206-007459,26SBLUC01107-007101,26SBLUC01199-007108",
        "Stato": "DE",
        "CAP": "45131",
        "Localit\u00e0": "ESSEN",
        "Indirizzo": "RUETTENSCHEIDER STR. 261",
        "N.ri Tel.": "0049 1725306001",
        "Insegna": "Pfeffers",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "001259": {
        "Stato": "IT",
        "CAP": "58043",
        "Localit\u00e0": "CASTIGLIONE DELLA PESCAIA",
        "Indirizzo": "VIA PONTE GIORGINI, 43",
        "N.ri Tel.": "0564 934217",
        "Insegna": "NAUTALA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK11140-007286,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC02175-007119,26SBLDC02194-007476,26SBLDC02228-007119,26SBLDC02281-007476,26SBLDK11147-007111,26SBLDL02450-007523,26SBLDL02533-007564,26SBLDX02171-006648,26SBLUB04119-007449,26SBLUC02180-007104,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUF08049-007465,26SBLUH01476-007478,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH04349-007495,26SBLUT02067-006526,26SBLUX02181-007104,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "022026": {
        "Stato": "IT",
        "CAP": "71018",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "915220722",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047"
    },
    "001923": {
        "Stato": "IT",
        "CAP": "14100",
        "Localit\u00e0": "ASTI",
        "Indirizzo": "CORSO VITTORIO ALFIERI, 233",
        "N.ri Tel.": "0141 451205",
        "Insegna": "TUTTI FRUTTI",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02427-005958,26SBBXC01420-007111,26SBLKC06372-007101,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXC01420-007111"
    },
    "008319": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "SAN SEBASTIANO AL VESUVIO",
        "Indirizzo": "VIA PLINIO IL VECCHIO, 2",
        "N.ri Tel.": "081-5745499",
        "Insegna": "2EFFE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUT02298-007440,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "018124": {
        "Stato": "ES",
        "CAP": "48993",
        "Localit\u00e0": "GETXO",
        "Indirizzo": "C/ LAS MERCEDES ( BAJO AREETA) , 20",
        "N.ri Tel.": "946640379",
        "Insegna": "ZABALA JOVEN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308,25WBLUK11140-007286,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUT02290-006803",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "018674": {
        "Stato": "IT",
        "CAP": "10093",
        "Localit\u00e0": "COLLEGNO",
        "Indirizzo": "VIA OBERDAN, 14",
        "N.ri Tel.": "011-4053827",
        "Insegna": "APOTEMA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC11099-007462,26SBLUC02207-007459,26SBLUC11027-007462,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "013995": {
        "Stato": "IT",
        "CAP": "81030",
        "Localit\u00e0": "CANCELLO ED ARNONE",
        "Indirizzo": "STR. PROV X CAPPELLA REALE",
        "N.ri Tel.": "0823-859008",
        "Insegna": "STRADA FACENDO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUT02293-006801,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "020044": {
        "Stato": "IT",
        "CAP": "92017",
        "Localit\u00e0": "SAMBUCA IN SICILIA",
        "Indirizzo": "VIA DISCESA CAPPUCCINI N\u00b020",
        "N.ri Tel.": "081-8425474",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480"
    },
    "011243": {
        "Stato": "IT",
        "CAP": "80022",
        "Localit\u00e0": "ARZANO",
        "Indirizzo": "VIA VI ALFREDO PECCHIA 125-127,",
        "N.ri Tel.": "081 5732570",
        "Insegna": "IT GLAM",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC11083-007110,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02301-007439,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02295-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUH02065-006526"
    },
    "014165": {
        "Stato": "IT",
        "CAP": "10092",
        "Localit\u00e0": "BEINASCO",
        "Indirizzo": "STRADA TORINO, 34/36  C/o C.C. LE FORNACI",
        "N.ri Tel.": "366-3007180",
        "Insegna": "MAKAKO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLGA05461-007349,25WBLKC11416-007110,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK11140-007286,25WBLUX02081-005958,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC11095-007110,26SBLDX02171-006648,26SBLGC01402-007111,26SBLGC03410-007455,26SBLGH02501-007558,26SBLKC03373-006719,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKX02365-005958,26SBLUA04463-007525,26SBLUA04467-007527,26SBLUC02179-007104,26SBLUC03178-006719,26SBLUC11018-007110,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02286-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP01245-006804,26SBLUP03350-007496,26SBLUP05244-006804,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "020801": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "88068",
        "Localit\u00e0": "SOVERATO",
        "Indirizzo": "CORSO UMBERTO I, 80/82",
        "N.ri Tel.": "347 6620964",
        "Insegna": "MAGIA JUNIOR"
    },
    "019196": {
        "Stato": "IT",
        "CAP": "10071",
        "Localit\u00e0": "BORGARO TORINESE",
        "Indirizzo": "VIA PRIMO MAGGIO, 14",
        "N.ri Tel.": "011 4501885",
        "Insegna": "ITALIAN GRIFFE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUC01042-007120,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUT02293-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01042-007120"
    },
    "021221": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "00123",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ANTON GIULIO BRAGAGLIA, 19/E",
        "N.ri Tel.": "06 30889840",
        "Insegna": "PAROLIN"
    },
    "019912": {
        "Stato": "IT",
        "CAP": "87029",
        "Localit\u00e0": "SCALEA",
        "Indirizzo": "CORSO MEDITERRANEO, 343",
        "N.ri Tel.": "0973 876351",
        "Insegna": "MICHELE ESPOSITO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK11140-007286,26SBLDC01219-007108,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDK04249-007474,26SBLUA04463-007525,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUS01358-007499,26SBLUS02271-007502,26SBLUT02067-006526,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000571": {
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "ERBUSCO",
        "Indirizzo": "VIA PER ROVATO, 44",
        "N.ri Tel.": "030 7704917",
        "Insegna": "BAGLIONI JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK03102-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC04268-007475,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDK11147-007111,26SBLDP01059-007441,26SBLDV05282-007475,26SBLUB01024-007111,26SBLUC01106-007101,26SBLUC03177-006719,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02299-007439,26SBLUN02490-007542,26SBLUP04036-007441,26SBLUS02271-007502,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "023914": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05338-006127,25WBLDF08248-006948,25WBLDP01291-007324,25WBLDP04294-007324,25WBLUA05301-006434",
        "Stato": "PL",
        "CAP": "84-120",
        "Localit\u00e0": "Wladyslawowo",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- "
    },
    "013925": {
        "Stato": "IT",
        "CAP": "52025",
        "Localit\u00e0": "MONTEVARCHI",
        "Indirizzo": "VIA ROMA 149/151,",
        "N.ri Tel.": "055 980073",
        "Insegna": "BECATTINI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "018874": {
        "Stato": "IT",
        "CAP": "43126",
        "Localit\u00e0": "PARMA",
        "Indirizzo": "VIA BUFFOLARA 92/A",
        "N.ri Tel.": "335 711 6528",
        "Insegna": "WINNER",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC03074-006355,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUS01356-007500,26SBLUS02271-007501,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "000735": {
        "Stato": "IT",
        "CAP": "20092",
        "Localit\u00e0": "CINISELLO BALSAMO",
        "Indirizzo": "VIA GIOSUE' CARDUCCI, 11",
        "N.ri Tel.": "02 36585337",
        "Insegna": "DEVIS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUC11018-007110,26SBLUH02068-007439,26SBLUP02037-007441,26SBLUT02295-006801,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "012095": {
        "Stato": "ES",
        "CAP": "15003",
        "Localit\u00e0": "LA CORUNA",
        "Indirizzo": "CALLE JUANA DE VEGA, 8",
        "N.ri Tel.": "667122676",
        "Insegna": "2 R STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDC03169-007455,26SBLDK11147-007111,26SBLUA04465-007525,26SBLUC01107-007101,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUN02129-007447,26SBLUT02289-007479,26SBLUT02290-006803",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000257": {
        "Stato": "IT",
        "CAP": "70121",
        "Localit\u00e0": "BARI",
        "Indirizzo": "VIA BEATILLO, 13-15",
        "N.ri Tel.": "080 5214022",
        "Insegna": "1513",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "016510": {
        "Stato": "IT",
        "CAP": "17011",
        "Localit\u00e0": "ALBISOLA SUPERIORE",
        "Indirizzo": "VIA COLOMBO, 48",
        "N.ri Tel.": "019-488277",
        "Insegna": "L'OSTRICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,26SBLDC01217-007108,26SBLDC04192-007474,26SBLUC04139-007449,26SBLUF08140-007448,26SBLUL02442-007515,26SBLUP04142-007448,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02298-007440,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "015051": {
        "Stato": "IT",
        "CAP": "89029",
        "Localit\u00e0": "TAURIANOVA",
        "Indirizzo": "VIALE PROFESSOR VINCENZO RICCI, 84",
        "N.ri Tel.": "0966/612417",
        "Insegna": "CORICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02073-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958"
    },
    "000791": {
        "Stato": "IT",
        "CAP": "62029",
        "Localit\u00e0": "TOLENTINO",
        "Indirizzo": "VIA C. COLOMBO, 108",
        "N.ri Tel.": "0733 966356",
        "Insegna": "BARNY'S",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUX02081-005958,26SBLUC02180-007104,26SBLUC11028-007462,26SBLUS01358-007499,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02180-007104"
    },
    "007030": {
        "Stato": "IT",
        "CAP": "74017",
        "Localit\u00e0": "MOTTOLA",
        "Indirizzo": "VIA RISORGIMENTO, 8-10",
        "N.ri Tel.": "0998 863767",
        "Insegna": "VERTICE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,26SBLUB04093-007461,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUL02445-007516,26SBLUP03329-007496,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02290-006803,26SBLUT02297-006801,26SBLUX02184-005958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04093-007461"
    },
    "018268": {
        "Stato": "IT",
        "CAP": "18038",
        "Localit\u00e0": "SANREMO",
        "Indirizzo": "VIA VOLTURNO, 9/11",
        "N.ri Tel.": "0184/506093",
        "Insegna": "FREE ZONE",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC02176-006648,26SBLDC04192-007474,26SBLDC11095-007110,26SBLDH02411-005707,26SBLDH02415-007507,26SBLUB04119-007449,26SBLUC01108-007101,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP03350-007496,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02293-006801,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "014626": {
        "Stato": "IT",
        "CAP": "70043",
        "Localit\u00e0": "MONOPOLI",
        "Indirizzo": "CORSO UMBERTO I, 34",
        "Insegna": "RINASCENTE SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,26SBLUC04201-007124,26SBLUN01432-006581,26SBLUN02129-007447,26SBLUP02336-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS02271-007501,26SBLUT02288-007479,26SBLUX02184-005958,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04201-007124"
    },
    "004835": {
        "Stato": "ES",
        "CAP": "09200",
        "Localit\u00e0": "MIRANDA DE EBRO",
        "Indirizzo": "CALLE ANTONIO MACHADO, 5/7",
        "N.ri Tel.": "0034 947322862",
        "Insegna": "L\u00faa Miranda de Ebro",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,26SBLDK11145-007110,26SBLDP01398-007526,26SBLDV01339-007526,26SBLDV02341-007526",
        "PRODUCT CODE KOOOMO": "26SBLDK11145-007110"
    },
    "023189": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047",
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIALE VENEZIA , 52",
        "N.ri Tel.": "943811088",
        "Insegna": "- "
    },
    "001891": {
        "Stato": "IT",
        "CAP": "00155",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DI TOR SAPIENZA, 35 B/C/D",
        "N.ri Tel.": "06 2284544",
        "Insegna": "WALCOR",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03527-006047,25WBLDL01346-007354,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUA05298-006127,25WBLUB05126-007283,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01218-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDL02534-007521,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUH02306-007440,26SBLUL02434-007520,26SBLUL02445-007516,26SBLUP05244-006804,26SBLUT02298-007440,26SBLUX02184-005958,99CBLDA09007-007795,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "019501": {
        "Stato": "IT",
        "CAP": "09028",
        "Localit\u00e0": "SESTU",
        "Indirizzo": "MORE CORRAXE STRADA STATALE 131 EX SNC KM 10800",
        "N.ri Tel.": "346 6062004",
        "Insegna": "PULCKRA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUX02081-005958,26SBLDX02171-006648,26SBLUC01106-007101,26SBLUC02180-007104,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUX02181-007104,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDX02171-006648"
    },
    "000123": {
        "Stato": "IT",
        "CAP": "36075",
        "Localit\u00e0": "ALTE DI MONTECCHIO MAGGIORE",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03100-006047,25WBLDC03357-007294,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK05019-007298,25WBLDK11162-007110,25WBLUA05297-006127,25WBLUA05299-006127,25WBLUL01316-007012,26SBBXC02421-007104,26SBLDC01215-007131,26SBLDC01262-007101,26SBLDC02175-007119,26SBLDC02194-007476,26SBLDC02228-007119,26SBLDC02281-007476,26SBLDF01322-007484,26SBLDH02411-005707,26SBLDH02418-006845,26SBLDH02425-007495,26SBLDK11147-007111,26SBLDL02536-007515,26SBLDP04500-007526,26SBLDP05326-007484,26SBLDV01339-007526,26SBLDX03166-007455,26SBLUB03198-006719,26SBLUC01042-007120,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04131-007449,26SBLUC11003-007123,26SBLUC11005-007123,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUC11113-006787,26SBLUF03149-007448,26SBLUH02121-007451,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUP05150-007448,26SBLUS01128-007453,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02304-007481",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "017293": {
        "Stato": "IT",
        "CAP": "45014",
        "Localit\u00e0": "PORTO VIRO",
        "Indirizzo": "VIA PO VECCHIO 5",
        "N.ri Tel.": "3392686972",
        "Insegna": "BRANDS FACTORY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03100-006047,25WBLDK02192-006648,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01262-007101,26SBLDC02194-007476,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDK11147-007111,26SBLUC01199-007108,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUF01132-007448,26SBLUF03149-007448,26SBLUH02121-007451,26SBLUH02302-007439,26SBLUP01133-007448,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLDC01262-007101"
    },
    "019599": {
        "Stato": "CZ",
        "CAP": "602 00",
        "Localit\u00e0": "Brno",
        "Indirizzo": "PLAZA FASHION store, HERSPCKA 1009/11c",
        "N.ri Tel.": "+ 42 0774555888",
        "Insegna": "Plaza Fashion store",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK11140-007286"
    },
    "023184": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "VINAZOR ES CASTELLON",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "972 21 21 10",
        "Insegna": "- "
    },
    "019469": {
        "Stato": "ES",
        "CAP": "24402",
        "Localit\u00e0": "PONFERRADA (LEON)",
        "Indirizzo": "C/ DOCTOR FLEMING 2",
        "N.ri Tel.": "0034 987405187",
        "Insegna": "CHERIE 1961",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC03168-007455,26SBLDK11147-007111,26SBLUA04470-007525,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUL02436-007520,26SBLUT02290-006803,26SBLUT02296-006801",
        "PRODUCT CODE KOOOMO": "26SBLDC03168-007455"
    },
    "000350": {
        "CODICE PRODOTTO KOOOMO": "26SBLGC01406-007462,26SBLKC01403-007462,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUF02240-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP05244-006804",
        "Stato": "IT",
        "CAP": "25036",
        "Localit\u00e0": "PALAZZOLO SULL'OLIO",
        "Indirizzo": "VIALE EUROPA, 6",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "016860": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDK03495-006047",
        "Stato": "IT",
        "CAP": "80138",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA A. SCIALOIA, 9",
        "N.ri Tel.": "081 204741",
        "Insegna": "- "
    },
    "007159": {
        "Stato": "IT",
        "CAP": "71036",
        "Localit\u00e0": "LUCERA",
        "Indirizzo": "VIA ZUPPETTA, 48-50",
        "N.ri Tel.": "0881 530513",
        "Insegna": "REBECCA FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03167-007455,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUC03178-006719,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUM01482-007167,26SBLUP02037-007441,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "015725": {
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480",
        "Stato": "FR",
        "CAP": "51100",
        "Localit\u00e0": "REIMS",
        "Indirizzo": "16 RUE DU CADRAN SAINT PIERRE",
        "N.ri Tel.": "0661961717",
        "Insegna": "CAVIAR"
    },
    "015703": {
        "Stato": "IT",
        "CAP": "71013",
        "Localit\u00e0": "SAN GIOVANNI ROTONDO",
        "Indirizzo": "VIALE ALDO MORO, 71",
        "N.ri Tel.": "0882454529",
        "Insegna": "CANISTRO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02281-007476,26SBLDC04077-007474,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDK04249-007474,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11113-006787,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02302-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02281-007476"
    },
    "000598": {
        "Stato": "IT",
        "CAP": "16035",
        "Localit\u00e0": "RAPALLO",
        "Indirizzo": "PIAZZA CAVOUR, 11",
        "N.ri Tel.": "0185 51218",
        "Insegna": "EQUIPE 84",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719"
    },
    "015398": {
        "Stato": "IT",
        "CAP": "76121",
        "Localit\u00e0": "BARLETTA",
        "Indirizzo": "VIA BACCARINI  , 2",
        "N.ri Tel.": "3288085675",
        "Insegna": "BROADWAY",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC02170-006648,26SBLDC02175-007119,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDF08057-007441,26SBLDH02327-007483,26SBLDH02411-005707,26SBLDH02412-005707,26SBLDH02415-007507,26SBLDK11147-007111,26SBLDL02448-007521,26SBLDM01488-007532,26SBLDM02484-007531,26SBLDP01059-007441,26SBLDP05058-007441,26SBLDP05326-007484,26SBLDV03258-007464,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUF03242-006804,26SBLUH02121-007451,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUH02310-007132,26SBLUH02348-007495,26SBLUP02254-007464,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUS01270-007502,26SBLUS02250-007464,26SBLUT02289-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "016595": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,26SBLUC01022-007110,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUF03149-007448,26SBLUP01133-007448,26SBLUP05150-007448,26SBLUP05244-006804,26SBLUT02298-007440",
        "Stato": "DE",
        "CAP": "72147",
        "Localit\u00e0": "Nehren",
        "Indirizzo": "Reutlinger Strasse 23",
        "N.ri Tel.": "07473-94280",
        "Insegna": "SKI NILL",
        "PRODUCT CODE KOOOMO": "26SBLUC01022-007110"
    },
    "017700": {
        "Stato": "IT",
        "CAP": "20831",
        "Localit\u00e0": "SEREGNO",
        "Indirizzo": "VIA MILANO 46",
        "N.ri Tel.": "0362-265780",
        "Insegna": "SPORTIT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUX02081-005958"
    },
    "017033": {
        "Stato": "IT",
        "CAP": "18038",
        "Localit\u00e0": "SANREMO",
        "Indirizzo": "VIA FERALDI 9",
        "N.ri Tel.": "0184- 540048",
        "Insegna": "DENIM",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308"
    },
    "010467": {
        "CODICE PRODOTTO KOOOMO": "26SBLUC01106-007101,26SBLUH02234-007457,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUP05244-006804,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02297-006801,26SBLUT02307-007132,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "10024",
        "Localit\u00e0": "MONCALIERI",
        "Indirizzo": "CORSO SAVONA, N. 69",
        "N.ri Tel.": "011-8953288",
        "Insegna": "MOMI PLANET",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "014178": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC11095-007110,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "81020",
        "Localit\u00e0": "SAN MARCO EVANGELISTA",
        "Indirizzo": "STRADA STATALE 265 KM 26.200",
        "Insegna": "MASSARO",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "000244": {
        "Stato": "IT",
        "CAP": "52013",
        "Localit\u00e0": "PONTE A POPPI",
        "Indirizzo": "VIA ROMA, 83/85",
        "N.ri Tel.": "0575 529704",
        "Insegna": "BAZAAR",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05297-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "021396": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBBXC01420-007111,26SBBXH02498-007558,26SBBXH02499-007558,26SBLGC01402-007111,26SBLGH02502-007558,26SBLGH03504-007561,26SBLKC11423-007110,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKT02431-007440,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "80055",
        "Localit\u00e0": "PORTICI",
        "Indirizzo": "VIA LIBERTA', 55",
        "N.ri Tel.": "081-7763815",
        "Insegna": "SNEAKERS PORTICI",
        "PRODUCT CODE KOOOMO": "26SBBXC01420-007111"
    },
    "019037": {
        "Stato": "IT",
        "CAP": "89044",
        "Localit\u00e0": "LOCRI",
        "Indirizzo": "TRAVERSA I DI VIA MARCONI",
        "N.ri Tel.": "393-9698041",
        "Insegna": "WANTED",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUL01316-007012,25WBLUX02081-005958,26SBLDC02170-006648,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02414-005707,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02238-007439,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02296-006801,26SBLUT02321-007481,26SBLUX02181-007104,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02170-006648"
    },
    "010125": {
        "Stato": "IT",
        "CAP": "01100",
        "Localit\u00e0": "VITERBO",
        "Indirizzo": "VIA I.GARBINI 29 H/I/L",
        "N.ri Tel.": "0761 307107",
        "Insegna": "BRUBAKER STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK05019-007298,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUC11083-007110,25WBLUL02318-007340,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDL02450-007523,26SBLDX03166-007455,26SBLUB04119-007449,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUH02068-007439,26SBLUH02312-007132,26SBLUH02347-007495,26SBLUL02442-007515,26SBLUL02445-007516,26SBLUM01477-006233,26SBLUM01482-007167,26SBLUM06472-007529,26SBLUM08479-006233,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUT02293-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "000963": {
        "Stato": "IT",
        "CAP": "89015",
        "Localit\u00e0": "PALMI",
        "Indirizzo": "VIA CONCORDATO, 9",
        "N.ri Tel.": "0966 21170",
        "Insegna": "PRESTIGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01314-007012,25WBLUL01316-007012,25WBLUX02081-005958,26SBLUC02207-007459,26SBLUC11019-007110,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUL02441-007515,26SBLUT02064-006526,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "009683": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC04460-007475,26SBLDC11099-007462,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUH02065-006526,26SBLUH02347-007495,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "33081",
        "Localit\u00e0": "AVIANO",
        "Indirizzo": "VIALE SAN GIORGIO, 9",
        "N.ri Tel.": "0434 651728",
        "Insegna": "INTROINI",
        "PRODUCT CODE KOOOMO": "26SBLDC04460-007475"
    },
    "015414": {
        "Stato": "IT",
        "CAP": "80131",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA EDUARDO NICOLARDI 254",
        "N.ri Tel.": "081-7411171",
        "Insegna": "MONACO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUK03142-005480,26SBLDC04077-007474,26SBLDC04460-007475,26SBLDF01104-007441,26SBLDP01059-007441,26SBLUA04463-007525,26SBLUA04468-007527,26SBLUC04139-007449,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02317-005695,26SBLUP05244-006804,26SBLUS04360-007499,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02298-007440,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04077-007474"
    },
    "009616": {
        "Stato": "IT",
        "CAP": "30126",
        "Localit\u00e0": "VENEZIA Loc. LIDO",
        "Indirizzo": "GRANVIALE S.M. ELISABETTA, 2",
        "N.ri Tel.": "041 5265030",
        "Insegna": "ARBOR STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUB04119-007449,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF03013-007121,26SBLUF03035-007441,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUH02121-007451,26SBLUH02287-007480,26SBLUK11225-007110,26SBLUP01133-007448,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP05150-007448,26SBLUS01358-007499,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "000539": {
        "Stato": "IT",
        "CAP": "23023",
        "Localit\u00e0": "CHIESA IN VALMALENCO",
        "Indirizzo": "VIA ROMA, 150",
        "Insegna": "PIRCHER SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC01219-007108,26SBLDC02173-007104,26SBLDC03165-007455,26SBLDC11099-007462,26SBLDF08057-007441,26SBLDP05058-007441,26SBLDT02087-006526,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUT02290-006803,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "003370": {
        "Stato": "IT",
        "CAP": "73057",
        "Localit\u00e0": "TAVIANO",
        "Indirizzo": "CORSO VITTORIO EMANUELE II, 2",
        "N.ri Tel.": "0833 914180",
        "Insegna": "BOVE ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC04460-007475,26SBLDC11099-007462,26SBLUC04118-007452,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP02037-007441,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "019414": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBLGC01378-007108,26SBLGF08505-007557,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05503-007560,26SBLGP05508-007557,26SBLKF02527-007557,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "50019",
        "Localit\u00e0": "SESTO FIORENTINO",
        "Indirizzo": "VIA GIUSEPPE VERDI, 32",
        "N.ri Tel.": "3298535073",
        "Insegna": "BOOM",
        "PRODUCT CODE KOOOMO": "26SBLGC01378-007108"
    },
    "009696": {
        "Stato": "IT",
        "CAP": "91026",
        "Localit\u00e0": "MAZARA DEL VALLO",
        "Indirizzo": "CORSO V. VENETO, 70",
        "N.ri Tel.": "0923 906453",
        "Insegna": "FUORI STRADA",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUL01316-007012,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02541-007608,26SBLUN01432-006581,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11028-007462"
    },
    "018104": {
        "Stato": "IT",
        "CAP": "16121",
        "Localit\u00e0": "SESTRI PONENTE",
        "Indirizzo": "VIA SESTRI 105 -107 R",
        "N.ri Tel.": "010 6531528",
        "Insegna": "BEBO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01136-007110,26SBLDC04192-007474,26SBLDC11099-007462,26SBLDK11147-007111,26SBLUA04463-007525,26SBLUC01108-007101,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "004945": {
        "CODICE PRODOTTO KOOOMO": "26SBLUC01108-007101,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUT02067-006526,26SBLUT02293-006801,26SBLUT02296-006801",
        "Stato": "ES",
        "CAP": "17480",
        "Localit\u00e0": "ROSES",
        "Indirizzo": "CALLE MAIRO, 10",
        "N.ri Tel.": "+34972254531",
        "Insegna": "BLAU FOSC",
        "PRODUCT CODE KOOOMO": "26SBLUC01108-007101"
    },
    "021414": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIA ZAMENHOF, 98",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "021080": {
        "Stato": "IT",
        "CAP": "97019",
        "Localit\u00e0": "VITTORIA",
        "Indirizzo": "VIA ROMA 338",
        "N.ri Tel.": "0932 802490",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958"
    },
    "000379": {
        "Stato": "IT",
        "CAP": "92024",
        "Localit\u00e0": "CANICATTI'",
        "Indirizzo": "VIALE REGINA MARGHERITA, 175/C",
        "N.ri Tel.": "0922 854113",
        "Insegna": "CALABRO' TREND",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02192-006648,25WBLDK03103-006047,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC04192-007474,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC02179-007104,26SBLUC11018-007110,26SBLUF03035-007441,26SBLUH02235-007457,26SBLUH02284-007480,26SBLUN02129-007447,26SBLUS01356-007500,26SBLUT02064-006526,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "019900": {
        "Stato": "IT",
        "CAP": "00177",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE DELLA SERENISSIMA, 26/A",
        "N.ri Tel.": "0621800745",
        "Insegna": "INFANZIA ELEGANTE",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLKC02429-005958"
    },
    "000551": {
        "Stato": "IT",
        "CAP": "07029",
        "Localit\u00e0": "TEMPIO PAUSANIA",
        "Indirizzo": "VIA POERIO, 1",
        "N.ri Tel.": "079 631433",
        "Insegna": "GIUA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUL01316-007012,26SBLDC02172-007104,26SBLDC03168-007455,26SBLDC04077-007474,26SBLDC04460-007475,26SBLDK11147-007111,26SBLUB04119-007449,26SBLUC02180-007104,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "012126": {
        "Stato": "IT",
        "CAP": "80014",
        "Localit\u00e0": "GIUGLIANO IN CAMPANIA",
        "Indirizzo": "VIA MADONNA DEL PANTANO LOC.LAGO PATRIA",
        "N.ri Tel.": "081-7213422",
        "Insegna": "MORALE ZONA NATO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLUC02132-007284,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUL02318-007340,25WBLUX02081-005958"
    },
    "007269": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "10022",
        "Localit\u00e0": "CARMAGNOLA",
        "Indirizzo": "PIAZZA IV MARTIRI, 30",
        "N.ri Tel.": "011 9711763",
        "Insegna": "PUNTO BIMBI"
    },
    "019748": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "83040",
        "Localit\u00e0": "CASTEL SAN GIORGIO",
        "Indirizzo": "VIA TENENTE BRUNO LOMBARDI 122",
        "N.ri Tel.": "3343349234",
        "Insegna": "INSIEME CRESCEREMO"
    },
    "014201": {
        "Stato": "IT",
        "CAP": "87032",
        "Localit\u00e0": "AMANTEA",
        "Indirizzo": "VIA MARGHERITA 62",
        "N.ri Tel.": "0982/424546",
        "Insegna": "KAOS UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC04192-007474,26SBLDH02408-007508,26SBLDH05223-007460,26SBLDM01488-007532,26SBLUA04463-007525,26SBLUB04040-006788,26SBLUB04119-007449,26SBLUC02180-007104,26SBLUC04139-007449,26SBLUC11005-007123,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02121-007451,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02541-007608,26SBLUH04349-007495,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUL02443-007514,26SBLUS01356-007500,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04192-007474"
    },
    "021500": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110",
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "VIAREGGIO",
        "Indirizzo": "ZONA INDUSTRIALE P.I.P. LOTTO, 30",
        "N.ri Tel.": "MAURO",
        "Insegna": "- "
    },
    "019988": {
        "Stato": "ES",
        "CAP": "20008",
        "Localit\u00e0": "SAN SEBASTIAN, GUIPUZCOA",
        "Indirizzo": "ONDARBIDE, 3",
        "N.ri Tel.": "943212109",
        "Insegna": "TOME",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,26SBLDC02173-007104,26SBLDC02175-007119,26SBLDC02228-007119,26SBLDH02417-006845,26SBLDH02425-007495,26SBLDK11147-007111,26SBLDM01488-007532,26SBLDV02341-007526,26SBLDV03258-007464,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUF03320-007482,26SBLUH02283-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02305-007457,26SBLUH02347-007495,26SBLUT02291-006803,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "012584": {
        "Stato": "IT",
        "CAP": "62100",
        "Localit\u00e0": "MACERATA",
        "Indirizzo": "VIA TRENTO , 43/B",
        "N.ri Tel.": "0733 230180",
        "Insegna": "NAUTILUS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480,26SBLDC01134-007131,26SBLDC01220-007108,26SBLDC02175-007119,26SBLDC03165-007455,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDF03056-007441,26SBLDK11145-007110,26SBLDP01059-007441,26SBLUB04119-007449,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02066-006526,26SBLUH02237-007439,26SBLUH02299-007439,26SBLUH02348-007495,26SBLUM01471-007529,26SBLUM01480-007167,26SBLUP01245-006804,26SBLUP04036-007441,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "015034": {
        "Stato": "IT",
        "CAP": "11100",
        "Localit\u00e0": "AOSTA",
        "Indirizzo": "VIA AUBERTI , 26",
        "N.ri Tel.": "0165 363544",
        "Insegna": "NEAPOLIS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047"
    },
    "019967": {
        "CODICE PRODOTTO KOOOMO": "26SBLGC01406-007462,26SBLKF08530-007557,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "36061",
        "Localit\u00e0": "BASSANO DEL GRAPPA",
        "Indirizzo": "VIA G. MATTEOTTI, 58",
        "N.ri Tel.": "0424523049",
        "Insegna": "ELEFANTINO",
        "PRODUCT CODE KOOOMO": "26SBLGC01406-007462"
    },
    "010166": {
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA ASTALONGA, 98",
        "N.ri Tel.": "081 19977792",
        "Insegna": "CIVICO 36 OUTLET",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBBXC02456-005958,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC03400-007308,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC11083-007110"
    },
    "017547": {
        "Stato": "IT",
        "CAP": "67050",
        "Localit\u00e0": "LECCE NEI MARSI",
        "Indirizzo": "CORSO ITALIA 43",
        "N.ri Tel.": "3271761938",
        "Insegna": "LA BELLA VITA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC03169-007455,26SBLDC11099-007462,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01358-007499,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "021286": {
        "Stato": "PL",
        "CAP": "85586",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "049 8669830",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02506-007254,25WBLDC03173-007307,25WBLDK03182-006985,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK11140-007286,25WBLUX02081-005958"
    },
    "015185": {
        "Stato": "IT",
        "CAP": "00060",
        "Localit\u00e0": "CAPENA",
        "Indirizzo": "VIA TIBERINA KM. 16,400",
        "Insegna": "NOI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDF08236-007301,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDP01291-007324,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC11095-007110,26SBLDL02450-007523,26SBLUB04119-007449,26SBLUC01108-007101,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUL02440-007522,26SBLUL02441-007515,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "013441": {
        "Stato": "ES",
        "CAP": "33201",
        "Localit\u00e0": "GIJON",
        "Indirizzo": "CALLE SAN BERNARDO 39",
        "N.ri Tel.": "0034985359245",
        "Insegna": "TRAPPER SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK11140-007286,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC02176-006648,26SBLDC03168-007455,26SBLDK11147-007111,26SBLDL02446-007520,26SBLUC01108-007101,26SBLUC04110-007473,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUT02321-007481,BLAP049-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "009327": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "TERZIGNO",
        "Indirizzo": "CORSO LEONARDO DA VINCI, 219",
        "N.ri Tel.": "081 8271487",
        "Insegna": "STUDIO'S",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUA04463-007525,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11113-006787,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02306-007440,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "021190": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047",
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "TREMP (LLEIDA)",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "0771674366",
        "Insegna": "- "
    },
    "000669": {
        "Stato": "IT",
        "CAP": "37011",
        "Localit\u00e0": "BARDOLINO",
        "Indirizzo": "CORSO UMBERTO I, 18",
        "N.ri Tel.": "045 7210614",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02192-006648"
    },
    "014569": {
        "Stato": "IT",
        "CAP": "55012",
        "Localit\u00e0": "CAPANNORI",
        "Indirizzo": "VIA PESCIATINA 562/BIS,",
        "N.ri Tel.": "0583928073",
        "Insegna": "MENCARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03495-006047,25WBLGC02391-006648,25WBLKA05458-006127,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLKC02364-005958,26SBLKF02527-007557,26SBLKF08530-007557,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC04118-007452,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02068-007439,26SBLUH02306-007440,26SBLUH04349-007495,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04118-007452"
    },
    "014133": {
        "Stato": "IT",
        "CAP": "22100",
        "Localit\u00e0": "COMO",
        "Indirizzo": "VIA BERNARDINO LUINI, 1",
        "N.ri Tel.": "031/265843",
        "Insegna": "BUTTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03527-006047,25WBLUA05297-006127,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110"
    },
    "021028": {
        "Stato": "IT",
        "CAP": "10154",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "S.DA COMUNALE DI ALTESSANO 141",
        "N.ri Tel.": "011212148",
        "Insegna": "ONE'S EASE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03086-006047"
    },
    "008577": {
        "Stato": "IT",
        "CAP": "30015",
        "Localit\u00e0": "CHIOGGIA",
        "Indirizzo": "CORSO DEL POPOLO, 1315",
        "N.ri Tel.": "041 405526",
        "Insegna": "NUVOL AIR",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLUA04463-007525,26SBLUB04226-007124,26SBLUC01043-007120,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUC11027-007462,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUH02233-007457,26SBLUH02283-007480,26SBLUH02285-007480,26SBLUH02302-007439,26SBLUH02305-007457,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUH02315-005695,26SBLUL02434-007520,26SBLUL02439-007521,26SBLUL02440-007522,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUM01480-007167,26SBLUN01432-006581,26SBLUN02129-007447,26SBLUP01133-007448,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP05150-007448,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUS02271-007501,26SBLUS04360-007499,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02292-006803,26SBLUT02296-006801,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "010373": {
        "Stato": "IT",
        "CAP": "00042",
        "Localit\u00e0": "ANZIO",
        "Indirizzo": "VIA B. BUOZZI, 13",
        "N.ri Tel.": "069844841",
        "Insegna": "NUOVA CENTOLIRE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLDK03527-006047,25WBLDL01340-007355,25WBLDL01346-007354,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01314-007012,25WBLUL02318-007340,26SBLDC01218-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDC04269-007475,26SBLDC04460-007475,26SBLDH02407-007508,26SBLDH02411-005707,26SBLDL02449-007522,26SBLDL02450-007523,26SBLDL02536-007515,26SBLDS01345-007506,26SBLDV04396-007526,26SBLUA04463-007525,26SBLUB04119-007449,26SBLUC01199-007108,26SBLUC02207-007459,26SBLUC04092-007461,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02069-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUH02541-007608,26SBLUL02434-007520,26SBLUL02439-007521,26SBLUL02441-007515,26SBLUL02445-007516,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUP01133-007448,26SBLUP03350-007496,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02298-007440,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "015518": {
        "Stato": "IT",
        "CAP": "59013",
        "Localit\u00e0": "MONTEMURLO",
        "Indirizzo": "VIA LABRIOLA, 243",
        "N.ri Tel.": "0574754171",
        "Insegna": "GUARDUCCI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03096-006047,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUB04119-007449,26SBLUB04226-007124,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03149-007448,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02121-007451,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUH02314-005695,26SBLUH02315-005695,26SBLUH02317-005695,26SBLUM01471-007529,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUT02296-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "020760": {
        "Stato": "ES",
        "CAP": "39003",
        "Localit\u00e0": "Santander",
        "Indirizzo": "Plaza Pombo 3",
        "Insegna": "GOLF",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03173-007307,25WBLDK11162-007110,25WBLDL01346-007354"
    },
    "018420": {
        "Stato": "IT",
        "CAP": "26900",
        "Localit\u00e0": "LODI",
        "Indirizzo": "CORSO VITTORIO EMANUELE II N 16",
        "N.ri Tel.": "0371/420163",
        "Insegna": "D&D",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "016807": {
        "Stato": "IT",
        "CAP": "64011",
        "Localit\u00e0": "ALBA ADRIATICA",
        "Indirizzo": "VIA VITTORIO VENETO, 57",
        "Insegna": "FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01220-007108,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC04268-007475,26SBLDF01114-006804,26SBLDF08057-007441,26SBLDH02416-007507,26SBLDP01059-007441,26SBLUA04467-007527,26SBLUC01199-007108,26SBLUC02207-007459,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUF08538-007512,26SBLUH02066-006526,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02315-005695,26SBLUH02348-007495,26SBLUH05070-007439,26SBLUM01471-007529,26SBLUN02490-007542,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUT02321-007481,26SBLUX02181-007104,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "008206": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "PALMA DI MONTECHIARO",
        "Indirizzo": "CSO G.B.ODIERNA, 635",
        "N.ri Tel.": "0922 968598",
        "Insegna": "GULINO MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUX02081-005958,26SBLUC01106-007101,26SBLUC11028-007462,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUT02288-007479,26SBLUT02289-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "019049": {
        "Stato": "IT",
        "CAP": "40128",
        "Localit\u00e0": "BOLOGNA",
        "Indirizzo": "PIAZZA DELL'UNITA', 11/D",
        "N.ri Tel.": "051 353727",
        "Insegna": "AMERICAN DREAM",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02175-007119,26SBLUB04119-007449,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUH02302-007439,26SBLUL02437-007156,26SBLUL02440-007522,26SBLUL02441-007515,26SBLUP05244-006804,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "018915": {
        "Stato": "ES",
        "CAP": "48970",
        "Localit\u00e0": "Basauri",
        "Indirizzo": "Berriochoa, 1",
        "N.ri Tel.": "+34688696406",
        "Insegna": "Modas Pascual",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03099-006047,25WBLDK02069-006648,25WBLUC08078-006355,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03168-007455,26SBLDC04077-007474,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02305-007457,26SBLUH02311-007132,26SBLUT02288-007479,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02295-006801",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000902": {
        "Stato": "IT",
        "CAP": "86170",
        "Localit\u00e0": "ISERNIA",
        "Indirizzo": "VIA UMBRIA C/O CENTRO COMMERCIALE",
        "N.ri Tel.": "0865 451806",
        "Insegna": "SPORT CLUB",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDH02416-007507,26SBLDK11145-007110,26SBLDP01059-007441,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUM01477-006233,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS01126-007453,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02304-007481,26SBLUX02184-005958,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "016023": {
        "Stato": "IT",
        "CAP": "24122",
        "Localit\u00e0": "BERGAMO",
        "Indirizzo": "PIAZZA PONTIDA, 15/G",
        "Insegna": "MR WHITE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUB04119-007449,26SBLUC01229-007108,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02300-007439,26SBLUM01480-007167,26SBLUM08479-006233,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUT02064-006526,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "010724": {
        "Stato": "IT",
        "CAP": "80143",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA GENOVA, 90",
        "N.ri Tel.": "081-5539446",
        "Insegna": "SORECA",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLKC02427-005958,25WBLKC02429-005958,26SBBXH02498-007558,26SBBXP05495-007570,26SBLGC01402-007111,26SBLGH02501-007558,26SBLKC11401-007111,26SBLKF03529-007557,26SBLKF08515-007557,26SBLKH02512-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKT02514-007559",
        "PRODUCT CODE KOOOMO": "26SBBXH02498-007558"
    },
    "010699": {
        "Stato": "IT",
        "CAP": "71011",
        "Localit\u00e0": "APRICENA",
        "Indirizzo": "CORSO ROMA, 97",
        "Insegna": "FASHION STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC02281-007476,26SBLUC02180-007104,26SBLUC04118-007452,26SBLUC11018-007110,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02238-007439,26SBLUH02299-007439,26SBLUH05070-007439,26SBLUP02037-007441,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUT02295-006801,26SBLUT02297-006801,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "012678": {
        "Stato": "IT",
        "CAP": "00030",
        "Localit\u00e0": "SAN CESAREO",
        "Indirizzo": "VIA CASILINA, 82/B",
        "N.ri Tel.": "06 62284140",
        "Insegna": "ETAPE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK01375-007378,25WBLDK03102-006047,25WBLGC02391-006648,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUC06082-005480,26SBLDC01218-007108,26SBLDC03169-007455,26SBLDF01114-006804,26SBLDH02414-005707,26SBLDP01116-006804,26SBLDT02086-006526,26SBLGC03410-007455,26SBLKC03373-006719,26SBLKF03528-007557,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUM01477-006233,26SBLUM01480-007167,26SBLUM01482-007167,26SBLUP01245-006804,26SBLUP03350-007496,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02307-007132,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "008605": {
        "Stato": "IT",
        "CAP": "00028",
        "Localit\u00e0": "SUBIACO",
        "Indirizzo": "PIAZZA U. PELLICCIA, 5",
        "N.ri Tel.": "0774 85677",
        "Insegna": "LIVETTIHECCHI29",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC03074-006355,26SBLDC01217-007108,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDF01114-006804,26SBLDH02414-005707,26SBLDP01116-006804,26SBLDP03351-007496,26SBLUC02207-007459,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02299-007439,26SBLUH05070-007439,26SBLUP01331-007493,26SBLUP03350-007496,26SBLUP04334-007493,26SBLUT02067-006526,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02298-007440,99CBLUP01002-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "000071": {
        "Stato": "IT",
        "CAP": "50053",
        "Localit\u00e0": "EMPOLI",
        "Indirizzo": "PIAZZA DELLA VITTORIA, 60",
        "N.ri Tel.": "0571 73009",
        "Insegna": "CASA DEL BAMBINO",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,26SBLGC02380-006648,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKF02527-007557,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC02380-006648"
    },
    "017610": {
        "Stato": "IT",
        "CAP": "87032",
        "Localit\u00e0": "AMANTEA",
        "Indirizzo": "VIA MARGHERITA 134",
        "N.ri Tel.": "0982 424074",
        "Insegna": "CURCIO FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP01494-007570,26SBBXP05495-007570,26SBLGC01379-007108,26SBLGC02383-007119,26SBLGC02384-007476,26SBLGF02507-007557,26SBLGF03506-007557,26SBLGH02502-007558,26SBLKC01403-007462,26SBLKC02366-007104,26SBLKF03517-007557,26SBLKF03528-007557,26SBLKF03529-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXF03497-007570"
    },
    "001717": {
        "Stato": "IT",
        "CAP": "16146",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA PAOLO BOSELLI, 6R",
        "N.ri Tel.": "010 3626227",
        "Insegna": "POSH",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC06082-005480"
    },
    "011486": {
        "Stato": "IT",
        "CAP": "20081",
        "Localit\u00e0": "ABBIATEGRASSO",
        "Indirizzo": "PIAZZA MARCONI, 11",
        "N.ri Tel.": "0381/90196",
        "Insegna": "BOSTON CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047"
    },
    "014651": {
        "Stato": "IT",
        "CAP": "89063",
        "Localit\u00e0": "MELITO DI PORTO SALVO",
        "Indirizzo": "VIA NAZIONALE",
        "N.ri Tel.": "0965-789911",
        "Insegna": "GIANNI FOTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDL01346-007354,25WBLKC02429-005958,25WBLKC03400-007308,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC11099-007462,26SBLDH02211-007439,26SBLDH02408-007508,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDH02417-006845,26SBLDL02453-007513,26SBLDT02087-006526,26SBLUA04463-007525,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02314-005695,26SBLUP02336-007493,26SBLUT02067-006526,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "001599": {
        "Stato": "IT",
        "CAP": "06083",
        "Localit\u00e0": "BASTIA UMBRA",
        "Indirizzo": "VIA VIVALDI, 71",
        "N.ri Tel.": "075 8001042",
        "Insegna": "FIRENZE MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC03169-007455,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUF02240-006804,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "003513": {
        "Stato": "IT",
        "CAP": "00034",
        "Localit\u00e0": "COLLEFERRO",
        "Indirizzo": "VIA FONTANA  DELL'OSTE , 88",
        "N.ri Tel.": "06 97303809",
        "Insegna": "GULLIVER ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLGC02385-007459,26SBLGC03410-007455,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUC11071-007462,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "023810": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK02192-006648,25WBLDK03161-006719,25WBLUA05299-006127,25WBLUA05300-006434,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUX02081-005958",
        "Stato": "RU",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- "
    },
    "000777": {
        "Stato": "IT",
        "CAP": "51016",
        "Localit\u00e0": "MONTECATINI TERME",
        "Indirizzo": "VIA ANTONIETTA, 3",
        "N.ri Tel.": "0572 79341",
        "Insegna": "BONVICINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDL01346-007354,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC02174-006648,26SBLDC02228-007119,26SBLDF03056-007441,26SBLDH02407-007508,26SBLDK11147-007111,26SBLDP01059-007441,26SBLDP01398-007526,26SBLDP02399-007524,26SBLDP04500-007526,26SBLDS04392-007506,26SBLDV01339-007526,26SBLDX03166-007455,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01045-007465,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUP04334-007493,26SBLUP05150-007448,26SBLUS01126-007453,26SBLUX02184-005958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02174-006648"
    },
    "023528": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284",
        "Stato": "TR",
        "CAP": "98123",
        "Localit\u00e0": "ZIELONA GORA",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- "
    },
    "008003": {
        "Stato": "IT",
        "CAP": "55032",
        "Localit\u00e0": "CASTELNUOVO DI GARFAGNANA",
        "Indirizzo": "VIALE GARIBALDI, 12",
        "N.ri Tel.": "0187 622967",
        "Insegna": "GODANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "020054": {
        "Stato": "RO",
        "CAP": "97015",
        "Localit\u00e0": "WALDBRONN",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "988 60 25 20",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958"
    },
    "019125": {
        "Stato": "ES",
        "CAP": "01005",
        "Localit\u00e0": "VITORIA GASTEIZ, ALAVA",
        "Indirizzo": "PLAZA GENERAL LOMA, 4",
        "N.ri Tel.": "9452333617",
        "Insegna": "EMILIO RUIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK11140-007286,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUF01239-006804,26SBLUT02290-006803",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "004872": {
        "Stato": "ES",
        "CAP": "33202",
        "Localit\u00e0": "GIJON",
        "Indirizzo": "CALLE SAN AGUSTIN ,5 BAJO",
        "N.ri Tel.": "+34 985342933",
        "Insegna": "MARIA JOSE FERNANDEZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02073-006648,25WBLDK02192-006648,25WBLDK11162-007110"
    },
    "018154": {
        "Stato": "IT",
        "CAP": "22032",
        "Localit\u00e0": "ALBESE CON CASSANO",
        "Indirizzo": "VIA MARCONI, 11",
        "N.ri Tel.": "031.422.0507",
        "Insegna": "CERES",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUX02081-005958,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUC11028-007462,26SBLUF01239-006804,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "019479": {
        "Stato": "IT",
        "CAP": "17025",
        "Localit\u00e0": "LOANO",
        "Indirizzo": "VIA CESAREA 27",
        "N.ri Tel.": "019673798",
        "Insegna": "TRE MONELLI",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02429-005958,26SBBXC02422-005958,26SBBXF03497-007570,26SBBXH02499-007558,26SBBXP05495-007570,26SBBXP05496-007570,26SBLGC01378-007108,26SBLGF03506-007557,26SBLGH02501-007558,26SBLGP01510-007557,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKC06372-007101,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKF03529-007557,26SBLKF08530-007557,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXC02422-005958"
    },
    "007265": {
        "Stato": "IT",
        "CAP": "18038",
        "Localit\u00e0": "SANREMO",
        "Indirizzo": "VIA MATTEOTTI, 184",
        "N.ri Tel.": "0184 591273",
        "Insegna": "PLAY FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUT02289-007479,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "015627": {
        "Stato": "IT",
        "CAP": "00148",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ANGELO VESCOVALI, 374",
        "N.ri Tel.": "3358429155",
        "Insegna": "MARCOR",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC03165-007455,26SBLDC04077-007474,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC01199-007108,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "020558": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "CALVI",
        "Indirizzo": "VIA PIANO CASIELLO, 13 - CONTRADA CUBANTE",
        "Insegna": "ZEUS STORE DONNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110"
    },
    "015579": {
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "FAVARA",
        "Indirizzo": "CORSO VITTORIO VENETO, 226",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958,25WBLKC11416-007110"
    },
    "016500": {
        "Stato": "DE",
        "CAP": "59065",
        "Localit\u00e0": "Hamm",
        "Indirizzo": "Weststr. 1-3",
        "N.ri Tel.": "0049 208780340",
        "Insegna": "PRUEMER'S HAUS DER DAME",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK02192-006648,25WBLDK03102-006047,26SBLDC02173-007104,26SBLDC03168-007455,26SBLDC04269-007475,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "018273": {
        "Stato": "IT",
        "CAP": "00019",
        "Localit\u00e0": "TIVOLI",
        "Indirizzo": "VIA PALATINA, 20",
        "N.ri Tel.": "0774 312737",
        "Insegna": "INN OUTLET BIMBI DI SCIARRONE CARLOTTA",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBLKA05458-006127,26SBLGC01378-007108,26SBLGF08505-007557,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05503-007560,26SBLGP05508-007557,26SBLKC01404-007462,26SBLKF03528-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP05519-007557,26SBLKP05531-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01378-007108"
    },
    "013403": {
        "Stato": "IT",
        "CAP": "20020",
        "Localit\u00e0": "ARESE",
        "Indirizzo": "VIA GIUSEPPE EUGENIO LURAGHI, 11 UNITA' 160/161",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC03074-006355,25WBLUK03142-005480,26SBLUC01043-007120,26SBLUC01107-007101,26SBLUC11018-007110,99CBLDA09007-007795",
        "PRODUCT CODE KOOOMO": "26SBLUC01043-007120"
    },
    "018813": {
        "Stato": "IT",
        "CAP": "90036",
        "Localit\u00e0": "MISILMERI",
        "Indirizzo": "CORSO IV APRILE, 272",
        "N.ri Tel.": "3394212008",
        "Insegna": "LITTLES",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,26SBBXC01420-007111,26SBBXC01430-007111,26SBLGC02380-006648,26SBLGC02385-007459,26SBLGC03410-007455,26SBLKC02364-005958,26SBLKC11401-007111,26SBLKF02516-007557,26SBLKF02527-007557,26SBLKF03517-007557,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02513-007558,26SBLKH02523-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXC01420-007111"
    },
    "002050": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP05495-007570,26SBBXP05496-007570,26SBLGC01389-007111,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKC11423-007110,26SBLKF08530-007557,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05531-007557,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "80014",
        "Localit\u00e0": "GIUGLIANO IN CAMPANIA",
        "Indirizzo": "VIA S. M. A CUBITO - C.C. AUCHAN",
        "N.ri Tel.": "081 8187905",
        "Insegna": "YES PELLECCHIA",
        "PRODUCT CODE KOOOMO": "26SBBXH02498-007558"
    },
    "018631": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,26SBLGC01406-007462,26SBLGF02507-007557,26SBLGF03506-007557,26SBLGF08505-007557,26SBLGH02501-007558,26SBLGP01509-007557,26SBLGP05508-007557,26SBLKA04464-007525,26SBLKC11401-007111,26SBLKF03529-007557,26SBLKF08518-007557,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05526-007557,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "30014",
        "Localit\u00e0": "CAVARZERE",
        "Indirizzo": "CORSO ITALIA, 12/bis",
        "N.ri Tel.": "3493697289",
        "Insegna": "L'ARCOBALENO",
        "PRODUCT CODE KOOOMO": "26SBLGC01406-007462"
    },
    "007744": {
        "Stato": "IT",
        "CAP": "20100",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIALE ABRUZZI, 51",
        "N.ri Tel.": "02 29409287",
        "Insegna": "SALINA",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBBXC02456-005958,25WBLKC02429-005958,25WBLKC11416-007110"
    },
    "020478": {
        "CODICE PRODOTTO KOOOMO": "26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUH02069-007439,26SBLUH02287-007480,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUH02311-007132,26SBLUM01477-006233,26SBLUP01331-007493,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP01002-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "00166",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DEI SAMPIERI, 92",
        "N.ri Tel.": "06 5898254",
        "Insegna": "CASTELLA.CASTELLESE",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "009771": {
        "Stato": "IT",
        "CAP": "80128",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA ADOLFO OMODEO, 50",
        "N.ri Tel.": "081 5790589",
        "Insegna": "BRANCACCIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUH02246-007457,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUT02288-007479,26SBLUT02291-006803,26SBLUT02292-006803,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUT02297-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUH02246-007457"
    },
    "023188": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA BONDI, 120",
        "N.ri Tel.": "977345643",
        "Insegna": "- "
    },
    "016071": {
        "Stato": "IT",
        "CAP": "89015",
        "Localit\u00e0": "PALMI",
        "Indirizzo": "CORSO TENENTE  A.BARBARO 42",
        "N.ri Tel.": "0966 421155",
        "Insegna": "YIN",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLGA05461-007349,25WBLGC02391-006648,26SBLDC01219-007108,26SBLDC02175-007119,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC03168-007455,26SBLDK04249-007474,26SBLDK11145-007110,26SBLDK11147-007111,26SBLGC02380-006648,26SBLGC02383-007119,26SBLGC02385-007459,26SBLGF03428-006804,26SBLGH02501-007558,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "021235": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,26SBLGC01389-007111,26SBLGC02385-007459,26SBLGC03410-007455,26SBLKC01369-007101,26SBLKC01403-007462,26SBLKC01404-007462,26SBLKC03373-006719,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "42020",
        "Localit\u00e0": "MONTECAVOLO",
        "Indirizzo": "VIA PALMIRO TOGLIATTI, 26/B",
        "N.ri Tel.": "0522666171",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLGC02385-007459"
    },
    "008849": {
        "Stato": "IT",
        "CAP": "16100",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "PZA DELLA VITTORIA 86/R",
        "N.ri Tel.": "010 580054",
        "Insegna": "BOX 86",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDL01346-007354,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDL02447-007520,26SBLDL02447-007523,26SBLDL02536-007515,26SBLDV01339-007526,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUL02436-007520,26SBLUL02437-007156,26SBLUM01480-007167,26SBLUM06481-007167,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDL02447-007520"
    },
    "017016": {
        "Stato": "IT",
        "CAP": "20025",
        "Localit\u00e0": "LEGNANO",
        "Indirizzo": "VIA CORRIDONI, 3",
        "N.ri Tel.": "0331 453436",
        "Insegna": "BLOCK61",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUX02081-005958"
    },
    "010984": {
        "Stato": "IT",
        "CAP": "28100",
        "Localit\u00e0": "NOVARA - SAN MARTINO",
        "Indirizzo": "VIA UGO PORZIO GIOVANOLA, 7 - UNITA' 63",
        "Insegna": "NUVOLARI STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC11083-007110,26SBLUA04465-007525,26SBLUC03178-006719,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUH02299-007439,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "N.ri Tel.": "06 41734236",
        "PRODUCT CODE KOOOMO": "26SBLUA04465-007525"
    },
    "015912": {
        "Stato": "IT",
        "CAP": "51031",
        "Localit\u00e0": "AGLIANA",
        "Indirizzo": "VIA FRATELLI CERVI, 66",
        "N.ri Tel.": "0574 718234",
        "Insegna": "ABBIGLIAMENTO VARO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC02172-007104,26SBLDC02228-007119,26SBLDF01104-007441,26SBLDH02411-005707,26SBLDH02414-005707,26SBLDH02415-007507,26SBLDL02447-007523,26SBLDP01059-007441,26SBLUA04463-007525,26SBLUC01108-007101,26SBLUC02179-007104,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH04349-007495,26SBLUL02442-007515,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02295-006801,26SBLUT02307-007132,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "018092": {
        "Stato": "IT",
        "CAP": "15011",
        "Localit\u00e0": "ACQUI TERME",
        "Indirizzo": "CORSO ITALIA 95",
        "N.ri Tel.": "0144/55709",
        "Insegna": "Monkey Street",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047"
    },
    "000320": {
        "Stato": "IT",
        "CAP": "21058",
        "Localit\u00e0": "SOLBIATE OLONA",
        "Indirizzo": "VIA PER FAGNANO OLONA, 11",
        "N.ri Tel.": "0331 608362",
        "Insegna": "FACIBA PLANET",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01134-007131,26SBLDC03169-007455,26SBLDC04268-007475,26SBLDK11147-007111,26SBLUB04119-007449,26SBLUC01106-007101,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUS01358-007499,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "000068": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBLKC02429-005958,26SBBXC02421-007104,26SBBXC02422-005958,26SBLGC01389-007111,26SBLGC01402-007111,26SBLKC02364-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "22063",
        "Localit\u00e0": "CANTU'",
        "Indirizzo": "VIA ORESTE GRASSI, 10",
        "N.ri Tel.": "031 715171",
        "Insegna": "MINI MONDO",
        "PRODUCT CODE KOOOMO": "26SBBXC02421-007104"
    },
    "009755": {
        "Stato": "IT",
        "CAP": "10100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO TRAIANO, 60",
        "N.ri Tel.": "011 616051",
        "Insegna": "GEORGE'S SHOP DAL 1976",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03090-006719,25WBLUC06082-005480"
    },
    "017087": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "67051",
        "Localit\u00e0": "GIUSSANO",
        "Indirizzo": "VIA MONSIGNOR BAGNOLI 79",
        "N.ri Tel.": "3938438702",
        "Insegna": "- "
    },
    "018904": {
        "Stato": "IT",
        "CAP": "80045",
        "Localit\u00e0": "POMPEI",
        "Indirizzo": "VIA MACELLO, 22 - C.C. LA CARTIERA",
        "Insegna": "LOUNGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "021793": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "VIA TISIA, 108",
        "N.ri Tel.": "943811088",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480"
    },
    "018399": {
        "Stato": "IT",
        "CAP": "84122",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 184",
        "Insegna": "LAMBERTI FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03527-006047,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC04460-007475,26SBLDC11095-007110,26SBLDF03056-007441,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "000214": {
        "Stato": "IT",
        "CAP": "70032",
        "Localit\u00e0": "BITONTO",
        "Indirizzo": "VIA REP. ITALIANA, 50",
        "N.ri Tel.": "080 3756075",
        "Insegna": "GIALLO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUX02081-005958"
    },
    "001077": {
        "Stato": "IT",
        "CAP": "05022",
        "Localit\u00e0": "AMELIA",
        "Indirizzo": "PIAZZA XXI SETTEMBRE, 6/7",
        "N.ri Tel.": "0744 982217",
        "Insegna": "CONTI STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,26SBLDC01215-007131,26SBLDF01104-007441,26SBLDK11145-007110,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUP02037-007441,26SBLUT02064-006526,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "013821": {
        "Stato": "IT",
        "CAP": "80133",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA GIACOMO LEOPARDI, 63",
        "N.ri Tel.": "081 627664",
        "Insegna": "FREE WAY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC03074-006355,26SBLDC01098-007111,26SBLDC11095-007110,26SBLUC11018-007110,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "017074": {
        "Stato": "IT",
        "CAP": "16036",
        "Localit\u00e0": "RECCO",
        "Indirizzo": "VIA ROMA 36",
        "N.ri Tel.": "334 - 7239205",
        "Insegna": "GIUSE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUH02299-007439,26SBLUP03350-007496,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "019353": {
        "Stato": "IT",
        "CAP": "73048",
        "Localit\u00e0": "NARDO'",
        "Indirizzo": "VIA SARAGAT, SNC",
        "N.ri Tel.": "0833/835235",
        "Insegna": "GOGGI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,26SBLDC11099-007462,26SBLDH02414-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDH02418-006845,26SBLUC01106-007101,26SBLUH02238-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUT02290-006803,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11099-007462"
    },
    "016437": {
        "Stato": "IT",
        "CAP": "20089",
        "Localit\u00e0": "ROZZANO",
        "Indirizzo": "VIA ISONZO , 26",
        "N.ri Tel.": "02 84082569",
        "Insegna": "BROOMLEY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUK03142-005480,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC03169-007455,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02327-007483,26SBLDP01059-007441,26SBLUC01022-007110,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "000348": {
        "CODICE PRODOTTO KOOOMO": "26SBLUP05244-006804",
        "Stato": "IT",
        "CAP": "25036",
        "Localit\u00e0": "PALAZZOLO SULL'OLIO",
        "Indirizzo": "VIALE EUROPA, 6",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLUP05244-006804"
    },
    "017803": {
        "Stato": "IT",
        "CAP": "88836",
        "Localit\u00e0": "VILLAGGIO PALUMBO",
        "Indirizzo": "PIAZZA PALAGHIACCIO",
        "N.ri Tel.": "0962/493042",
        "Insegna": "360 SLIDE SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUX02081-005958"
    },
    "001388": {
        "Stato": "IT",
        "CAP": "90026",
        "Localit\u00e0": "PETRALIA SOPRANA",
        "Indirizzo": "VIA Io MAGGIO, 78",
        "N.ri Tel.": "0921 680208",
        "Insegna": "PAGANO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355"
    },
    "018194": {
        "Stato": "IT",
        "CAP": "10137",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA BOSTON, 73/E",
        "N.ri Tel.": "011  327 9800",
        "Insegna": "DREAM SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDF01104-007441,26SBLDP01059-007441,26SBLDP05058-007441,26SBLDX02171-006648,26SBLUA04463-007525,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02294-006801,26SBLUT02321-007481,26SBLUX02181-007104,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "014674": {
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA ASTALONGA 98",
        "Insegna": "CIVICO 66",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBBXC02456-005958,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC03400-007308,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC11083-007110"
    },
    "017390": {
        "Stato": "IT",
        "CAP": "70017",
        "Localit\u00e0": "PUTIGNANO",
        "Indirizzo": "VIA CRISTOFORO COLOMBO, 23",
        "N.ri Tel.": "3939161185",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC06082-005480"
    },
    "017041": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "10126",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GENOVA 32",
        "N.ri Tel.": "011-6634427",
        "Insegna": "- "
    },
    "015179": {
        "Stato": "IT",
        "CAP": "80011",
        "Localit\u00e0": "ACERRA",
        "Indirizzo": "VIA DEI MILLE 55",
        "N.ri Tel.": "081-8857100",
        "Insegna": "LIFE STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480,25WBLUL01316-007012,26SBLDC04077-007474,26SBLDC11095-007110,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04077-007474"
    },
    "004573": {
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "MACLODIO",
        "Indirizzo": "PIAZZALE EUROPA, 1",
        "N.ri Tel.": "030 3737192",
        "Insegna": "PIER MODE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308"
    },
    "002332": {
        "Stato": "IT",
        "CAP": "63100",
        "Localit\u00e0": "ASCOLI PICENO",
        "Indirizzo": "VIA ERASMO MARI, 10",
        "N.ri Tel.": "0736 43448",
        "Insegna": "MAX",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUA05297-006127,25WBLUC02151-007287,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDF01104-007441,26SBLDP01059-007441,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUT02064-006526,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "004925": {
        "Stato": "ES",
        "CAP": "08500",
        "Localit\u00e0": "VIC",
        "Indirizzo": "PLAZA MAYOR, 14",
        "N.ri Tel.": "+34938867183",
        "Insegna": "INSIGNIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLUA05300-006434,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC01220-007108,26SBLDC01262-007101,26SBLDC02206-007459,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDC04192-007474,26SBLDC04268-007475,26SBLDC04460-007475,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02327-007483,26SBLDH02425-007495,26SBLDH03328-007483,26SBLDP05326-007484,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUC01022-007110,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11021-007111,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03243-006804,26SBLUH01476-007478,26SBLUH02272-007478,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02306-007440,26SBLUH02310-007132,26SBLUH02312-007132,26SBLUN02129-007447,26SBLUP04048-007465,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02304-007481",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "015853": {
        "Stato": "IT",
        "CAP": "03043",
        "Localit\u00e0": "CASSINO",
        "Indirizzo": "CORSO DELLA REPUBBLICA, 62",
        "N.ri Tel.": "0776 310260",
        "Insegna": "NEW COMPANY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL02318-007340,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUL02434-007520,26SBLUP02336-007493,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUX02184-005958,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "021513": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLUC01022-007110,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "20081",
        "Localit\u00e0": "MAGENTA",
        "Indirizzo": "PIAZZA LIBERAZIONE, 17",
        "N.ri Tel.": "02/36738277",
        "Insegna": "AL DIECI",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "023345": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "92024",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "MAURO",
        "Insegna": "- "
    },
    "020415": {
        "Stato": "SK",
        "CAP": "54351",
        "Localit\u00e0": "Zilina",
        "Indirizzo": "Okruzni 116",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDK03101-006047"
    },
    "019423": {
        "Stato": "ES",
        "CAP": "36211",
        "Localit\u00e0": "VIGO, PONTEVEDRA",
        "Indirizzo": "AVDA. CAMELIAS, 130-BAJO",
        "N.ri Tel.": "0034 986235163",
        "Insegna": "BOXER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02284-007480,26SBLUH02286-007480,26SBLUT02296-006801",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "018508": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDL02447-007520,26SBLDL02449-007522,26SBLDL02450-007523,26SBLDL02534-007521,26SBLDL02536-007515,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "00121",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DELLE BALENIERE, 88A",
        "N.ri Tel.": "335-8057991",
        "Insegna": "COOL CULTURE",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "018299": {
        "Stato": "IT",
        "CAP": "84012",
        "Localit\u00e0": "ANGRI",
        "Indirizzo": "VIA NAZIONALE, 178",
        "N.ri Tel.": "081947500",
        "Insegna": "MONTORO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC11095-007110,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02069-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUS04360-007499,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "014649": {
        "Stato": "IT",
        "CAP": "87028",
        "Localit\u00e0": "PRAIA A MARE",
        "Indirizzo": "PIAZZA ITALIA, 19",
        "Insegna": "GIO' YOUR IDENTITY",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDP01291-007324,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01262-007101,26SBLDC02170-006648,26SBLDC03169-007455,26SBLDK11147-007111,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02300-007439,26SBLUH02306-007440,26SBLUL02441-007515,26SBLUP04334-007493,26SBLUS01358-007499,26SBLUS02271-007502,26SBLUT02288-007479,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,26SBLUX03232-006719,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01262-007101"
    },
    "020526": {
        "Stato": "IT",
        "CAP": "36030",
        "Localit\u00e0": "MONTECCHIO PRECALCINO",
        "Indirizzo": "VIA SUMMANO, 5",
        "Insegna": "BE YOU",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03100-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,26SBLDC03165-007455,26SBLDC11095-007110,26SBLUB04119-007449,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF03149-007448,26SBLUF08049-007465,26SBLUH02305-007457,26SBLUH02306-007440,26SBLUM01471-007529,26SBLUM06472-007529,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP05150-007448,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02321-007481,99CBLUP01002-007493,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "N.ri Tel.": "0445-864533",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "007764": {
        "Stato": "IT",
        "CAP": "71014",
        "Localit\u00e0": "SAN MARCO IN LAMIS",
        "Indirizzo": "CORSO G.MATTEOTTI, 115",
        "N.ri Tel.": "0882 816258",
        "Insegna": "TRASPARENZE ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC02281-007476,26SBLDC11099-007462,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "003762": {
        "Stato": "IT",
        "CAP": "84022",
        "Localit\u00e0": "CAMPAGNA",
        "Indirizzo": "VIA PROVINCIALE PER CAMPAGNA, LOC. QUADRIVIO",
        "N.ri Tel.": "333 1792210",
        "Insegna": "ANGEL'S",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP01494-007570,26SBBXP05495-007570,26SBBXP05496-007570,26SBLDC01217-007108,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC04072-007474,26SBLDC04275-007475,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDF03056-007441,26SBLDH02211-007439,26SBLDH02212-007439,26SBLDH02418-006845,26SBLDP01059-007441,26SBLDP03352-007496,26SBLDP05058-007441,26SBLDX03166-007455,26SBLGC01402-007111,26SBLGC01406-007462,26SBLGC02380-006648,26SBLGC03410-007455,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKC01404-007462,26SBLKC02366-007104,26SBLKC03373-006719,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP05519-007557,26SBLKP05531-007557,26SBLUA04463-007525,26SBLUA04467-007527,26SBLUB04119-007449,26SBLUC01107-007101,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04091-007461,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03035-007441,26SBLUF03243-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH05070-007439,26SBLUL02436-007520,26SBLUM01477-006233,26SBLUM01480-007167,26SBLUP01245-006804,26SBLUP01331-007493,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02304-007481,26SBLUT02307-007132,26SBLUT02309-007132,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP01002-007493,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "017215": {
        "Stato": "ES",
        "CAP": "08401",
        "Localit\u00e0": "GRANOLLERS-BARCELONA",
        "Indirizzo": "CALLE ANSELM CLAVE 16",
        "N.ri Tel.": "0034 655984302",
        "Insegna": "AZNAR BROTHERS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC01220-007108,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC04077-007474,26SBLDC04268-007475,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDF08057-007441,26SBLDH03328-007483,26SBLDH05223-007460,26SBLDK11147-007111,26SBLDP01259-007464,26SBLDP01398-007526,26SBLDP02278-007475,26SBLDS02400-007464,26SBLDS04392-007506,26SBLDT02086-006526,26SBLDV01339-007526,26SBLDV03258-007464,26SBLDV05282-007475,26SBLDX02171-006648,26SBLGC01389-007111,26SBLGC02385-007459,26SBLGC03410-007455,26SBLGF08505-007557,26SBLGH02501-007558,26SBLGP05508-007557,26SBLKF03528-007557,26SBLKH02522-007558,26SBLKT02431-007440,26SBLUA04463-007525,26SBLUA04468-007527,26SBLUA04470-007525,26SBLUB04040-006788,26SBLUC01107-007101,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC11231-006787,26SBLUF01045-007465,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02011-007149,26SBLUH02272-007478,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUN02490-007542,26SBLUP04048-007465,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02296-006801,99CBLUP04003-007493,99CBLUP04004-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "000432": {
        "Stato": "IT",
        "CAP": "09028",
        "Localit\u00e0": "SESTU",
        "Indirizzo": "EX STRADA STATALE 131 KM 11,100",
        "N.ri Tel.": "070 22056",
        "Insegna": "ANTUOFERMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC02173-007104,26SBLDX02171-006648,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02294-006801",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "009568": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDF01104-007441,26SBLDF03056-007441,26SBLUC04139-007449,26SBLUF01132-007448,26SBLUF03149-007448,26SBLUH02068-007439,26SBLUH02121-007451,26SBLUP02336-007493,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02294-006801,26SBLUT02321-007481,26SBLUX02184-005958,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "10064",
        "Localit\u00e0": "PINEROLO",
        "Indirizzo": "PIAZZA FACTA 2",
        "N.ri Tel.": "0121 201938",
        "Insegna": "ZEBRA SHOP",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "019209": {
        "Stato": "IT",
        "CAP": "81055",
        "Localit\u00e0": "SANTA MARIA CAPUA VETERE",
        "Indirizzo": "VIA ALDO MORO, 85/89",
        "N.ri Tel.": "0823 840550",
        "Insegna": "DEL RE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047"
    },
    "010507": {
        "Stato": "IT",
        "CAP": "80020",
        "Localit\u00e0": "FRATTAMINORE",
        "Indirizzo": "VIA ROMA 31,",
        "N.ri Tel.": "081-8305621",
        "Insegna": "SARONNI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "006463": {
        "Stato": "IT",
        "CAP": "72018",
        "Localit\u00e0": "SAN MICHELE SALENTINO",
        "Indirizzo": "VIA G. PASCOLI, 19",
        "N.ri Tel.": "0831 964771",
        "Insegna": "LINEA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC11099-007462,26SBLDH02211-007439,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDK11147-007111,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUF01132-007448,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUM01477-006233,26SBLUP01133-007448,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUS01128-007453,26SBLUS02271-007502,26SBLUT02290-006803,26SBLUT02297-006801,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11099-007462"
    },
    "016078": {
        "Stato": "IT",
        "CAP": "10098",
        "Localit\u00e0": "RIVOLI",
        "Indirizzo": "CORSO SUSA 301/307- c/o CC Galleria dei Mercanti n. 34",
        "Insegna": "FREEDOM",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "016315": {
        "Stato": "DE",
        "CAP": "69117",
        "Localit\u00e0": "HEIDELBERG",
        "Indirizzo": "UNTERE NECKARSTRASSE 2",
        "N.ri Tel.": "+49 (0) 6221 - 9116-0",
        "Insegna": "KRAUS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02151-007287,26SBLUC04139-007449,26SBLUC04201-007124",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "019976": {
        "Stato": "ES",
        "CAP": "20004",
        "Localit\u00e0": "SAN SEBASTIAN",
        "Indirizzo": "CHURRUCA, 3",
        "N.ri Tel.": "943441689",
        "Insegna": "NOA & JUDY",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047"
    },
    "019896": {
        "Stato": "IT",
        "CAP": "00156",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DONATO MENICHELLA, 150",
        "Insegna": "CACTUS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDP01059-007441,26SBLDT02086-006526,26SBLDT02087-006526,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUT02288-007479,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "015586": {
        "Stato": "IT",
        "CAP": "63100",
        "Localit\u00e0": "ASCOLI PICENO",
        "Indirizzo": "CORSO GIUSEPPE MAZZINI, 132",
        "N.ri Tel.": "0736258963",
        "Insegna": "DI SABATINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC11083-007110,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "016528": {
        "Stato": "DE",
        "CAP": "51429",
        "Localit\u00e0": "Bensberg",
        "Indirizzo": "Schlossstrasse 43",
        "N.ri Tel.": "0049 1775673548",
        "Insegna": "WERNER STUEMPER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC03233-007308,26SBLUC04139-007449,26SBLUC04201-007124",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "013522": {
        "Stato": "IT",
        "CAP": "53100",
        "Localit\u00e0": "SIENA",
        "Indirizzo": "VIA DI CALZOLERIA, 1- 5",
        "N.ri Tel.": "0577/226045",
        "Insegna": "ACCORDI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03102-006047,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01215-007131,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDX02171-006648,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUF03149-007448,26SBLUH02347-007495,26SBLUL02437-007156,26SBLUP03350-007496,26SBLUT02293-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "004803": {
        "Stato": "ES",
        "CAP": "33003",
        "Localit\u00e0": "OVIEDO",
        "Indirizzo": "CALLE URIA, 3",
        "N.ri Tel.": "985242150",
        "Insegna": "BRIOS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLUC03233-007308,25WBLUK11140-007286,26SBLDC01219-007108,26SBLDK11147-007111,26SBLDV01339-007526,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11021-007111",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000280": {
        "Stato": "IT",
        "CAP": "33019",
        "Localit\u00e0": "REANA DEL ROJALE",
        "Indirizzo": "VIA NAZIONALE, 9",
        "N.ri Tel.": "0432 880154 UD",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLGC02391-006648,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUA05298-006127,26SBLDC01218-007108,26SBLDC03169-007455,26SBLGC01406-007462,26SBLKC01403-007462,26SBLKC01404-007462,26SBLKC06372-007101,26SBLUB04119-007449,26SBLUC01043-007120,26SBLUH02299-007439,26SBLUH02348-007495,26SBLUT02293-006801,26SBLUX03232-006719",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "016955": {
        "Stato": "IT",
        "CAP": "83024",
        "Localit\u00e0": "MONTEFORTE IRPINO",
        "Indirizzo": "VIA VALLE, 20 - C.C. MONTEDORO",
        "N.ri Tel.": "081 7595711",
        "Insegna": "FASHION ITALY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,26SBLDC03169-007455,26SBLDC11095-007110,26SBLUC02179-007104,26SBLUC03177-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "023392": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03357-007294",
        "Stato": "PL",
        "CAP": "71-515",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA VITTORIO VENETO 67",
        "N.ri Tel.": "0771674366",
        "Insegna": "- "
    },
    "000637": {
        "Stato": "IT",
        "CAP": "38068",
        "Localit\u00e0": "ROVERETO",
        "Indirizzo": "VIA MAIOLICHE, 53",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDK03101-006047,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355"
    },
    "004555": {
        "Stato": "IT",
        "CAP": "54037",
        "Localit\u00e0": "MARINA DI MASSA",
        "Indirizzo": "VIA C. COLOMBO, 15",
        "N.ri Tel.": "0585-243882",
        "Insegna": "ETE'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355"
    },
    "016476": {
        "Stato": "DE",
        "CAP": "73525",
        "Localit\u00e0": "DE SCHWAEBISCH GMUEND",
        "Indirizzo": "KALTER MARKT 27",
        "N.ri Tel.": "00497171925920",
        "Insegna": "ROETTELE MAENNERMODE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUK11140-007286"
    },
    "021460": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLDL01340-007355,25WBLDP01291-007324,25WBLUB05126-007283,25WBLUC03090-006719,25WBLUC05125-007283",
        "Stato": "IT",
        "CAP": "70121",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "0775 246015",
        "Insegna": "- "
    },
    "004977": {
        "Stato": "ES",
        "CAP": "17002",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "CALLE DE LA CREU  35",
        "N.ri Tel.": "0034972218804",
        "Insegna": "ELENA ROSSINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03086-006047,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDK11145-007110,26SBLDK11147-007111,26SBLUB01024-007111,BLAP049-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "012067": {
        "Stato": "ES",
        "CAP": "25600",
        "Localit\u00e0": "BALAGUER",
        "Indirizzo": "POLIGONO INDUSTRIAL CAMP LLONG CALLE XALOC, 5",
        "N.ri Tel.": "973450212",
        "Insegna": "CIA CANOA QUEBRADA, S.L",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDF08236-007301,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUA05298-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC01262-007101,26SBLDF01104-007441,26SBLDH02327-007483,26SBLDH02425-007495,26SBLDH03328-007483,26SBLDK11147-007111,26SBLDP01398-007526,26SBLDP05326-007484,26SBLDS02400-007464,26SBLDS04392-007506,26SBLDV02341-007526,26SBLDV03258-007464,26SBLUC04201-007124,26SBLUH02299-007439,26SBLUH02312-007132,26SBLUN02129-007447,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02296-006801",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "020385": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "03043",
        "Localit\u00e0": "GUIDONIA",
        "Indirizzo": "VIA PALOMBARESE, 203",
        "N.ri Tel.": "0776 272500",
        "Insegna": "- "
    },
    "020031": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "Paterna, Valencia",
        "Indirizzo": "VIA SANTA LUCIA, 3",
        "N.ri Tel.": "670675608",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355"
    },
    "002079": {
        "Stato": "IT",
        "CAP": "64025",
        "Localit\u00e0": "PINETO",
        "Indirizzo": "VIA G. D'ANNUNZIO, 71",
        "N.ri Tel.": "085 9492781",
        "Insegna": "ATELIER",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01134-007131,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDF08323-007484,26SBLDH02425-007495,26SBLDH03409-007508,26SBLDP04500-007526,26SBLDP05326-007484,26SBLDV01339-007526,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUF03044-007465,26SBLUH02283-007480,26SBLUH02313-005695,26SBLUH02314-005695,26SBLUH02347-007495,26SBLUM01480-007167,26SBLUN01432-006581,26SBLUN02490-007542,26SBLUP05337-007568,26SBLUS01128-007453,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "018427": {
        "Stato": "IT",
        "CAP": "28883",
        "Localit\u00e0": "GRAVELLONA TOCE",
        "Indirizzo": "VIA GRANEROLO ANG. CORSO MILANO 141",
        "N.ri Tel.": "0323 840351",
        "Insegna": "SPORTWAY KIDS",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648"
    },
    "020885": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "76121",
        "Localit\u00e0": "TRIGGIANO",
        "Indirizzo": "VIA TRANI, 19 c/o C.C.MONGOLFIERA",
        "N.ri Tel.": "080/3210405",
        "Insegna": "REV 73"
    },
    "023435": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284,25WBLUC11083-007110",
        "Stato": "UA",
        "CAP": "34396",
        "Localit\u00e0": "MASLAK",
        "Indirizzo": "UL. SAKSAGANSKOGO, 85",
        "N.ri Tel.": "+90 212 335 75 75",
        "Insegna": "- "
    },
    "001578": {
        "Stato": "IT",
        "CAP": "06034",
        "Localit\u00e0": "FOLIGNO",
        "Indirizzo": "VIA G. DA FOLIGNO, 22-26",
        "N.ri Tel.": "075 8942732",
        "Insegna": "FIRENZE MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC03169-007455,26SBLUC01106-007101,26SBLUC03177-006719",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "020495": {
        "Stato": "IT",
        "CAP": "74121",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA PER SAN GIORGIO",
        "N.ri Tel.": "080 6970050",
        "Insegna": "QUALITY SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDH02418-006845,26SBLDP03351-007496,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC11019-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP03329-007496,26SBLUP04332-007493,26SBLUT02290-006803,26SBLUT02297-006801,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "002374": {
        "Stato": "IT",
        "CAP": "80056",
        "Localit\u00e0": "ERCOLANO",
        "Indirizzo": "CORSO RESINA, 316",
        "N.ri Tel.": "081 7390809",
        "Insegna": "ELEGANZA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047"
    },
    "000922": {
        "Stato": "IT",
        "CAP": "87055",
        "Localit\u00e0": "SAN GIOVANNI IN FIORE",
        "Indirizzo": "VIALE DELLA REPUBBLICA, 313-321",
        "N.ri Tel.": "0984 992945",
        "Insegna": "MYJ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC06082-005480,25WBLUK03142-005480,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUF02034-007441,26SBLUH02237-007439,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUL02441-007515,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "019310": {
        "Stato": "ES",
        "CAP": "08398",
        "Localit\u00e0": "SANTA SUSANNA",
        "Indirizzo": "PLAZA DE LA TORRE S/N",
        "N.ri Tel.": "626049999",
        "Insegna": "SANTA SUSANA ORIGINAL STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "008912": {
        "Stato": "IT",
        "CAP": "75100",
        "Localit\u00e0": "MATERA",
        "Indirizzo": "VIA ROMA, 64",
        "N.ri Tel.": "0835 330483",
        "Insegna": "KEN PARKER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUA04463-007525,26SBLUC04118-007452,26SBLUF03149-007448,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH05070-007439,26SBLUP01133-007448,26SBLUP04141-007448,26SBLUT02297-006801,26SBLUT02304-007481,26SBLUX02181-007104,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "020816": {
        "Stato": "IT",
        "CAP": "00054",
        "Localit\u00e0": "FIUMICINO",
        "Indirizzo": "VIA ALESSANDRO VOLTA, 46 - PARCO DA VINCI",
        "Insegna": "AMORE CONCEPT STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,26SBLDC01215-007131,26SBLDC01218-007108,26SBLDC04268-007475,26SBLDC11099-007462,26SBLDH02417-006845,26SBLDH03224-007460,26SBLDP02278-007475,26SBLDV05282-007475,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02312-007132,26SBLUH02347-007495,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUN02129-007447,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP05244-006804,26SBLUS02271-007502,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02298-007440,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "018649": {
        "Stato": "ES",
        "CAP": "08530",
        "Localit\u00e0": "LA GARRIGA",
        "Indirizzo": "LLTUS BEE FREE, C/CENTRE 13",
        "N.ri Tel.": "617158382",
        "Insegna": "CARLOS ORIOL ARGIMON",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUT02288-007479,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLUF01239-006804"
    },
    "010443": {
        "Stato": "IT",
        "CAP": "71045",
        "Localit\u00e0": "ORTANOVA",
        "Indirizzo": "CORSO UMBERTO I 94",
        "N.ri Tel.": "0885 784315",
        "Insegna": "SCIKKERIE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLUC02077-006943,25WBLUC02080-005958,25WBLUC03074-006355"
    },
    "017450": {
        "Stato": "IT",
        "CAP": "66051",
        "Localit\u00e0": "CUPELLO",
        "Indirizzo": "CORSO DUCA DEGLI ABRUZZI, 50",
        "N.ri Tel.": "0873 319758",
        "Insegna": "MARCHESANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03357-007294,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUH02287-007480,26SBLUH02301-007439,26SBLUH05070-007439,26SBLUP02037-007441,26SBLUP05244-006804,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "001133": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "TITO",
        "Indirizzo": "VIA SANDRO PERTINI, 36",
        "N.ri Tel.": "0971 485309",
        "Insegna": "TROTTA MARCO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK03098-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC02281-007476,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC04460-007475,26SBLUB04093-007461,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUH02065-006526,26SBLUM01471-007529,26SBLUS01128-007453,26SBLUS02271-007501,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02281-007476"
    },
    "012814": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "POGGIOMARINO",
        "Indirizzo": "VIA ROMA, 53",
        "N.ri Tel.": "081/5283168",
        "Insegna": "OFFICINA STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03527-006047,25WBLDK11162-007110,25WBLDL01340-007355,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02238-007439,26SBLUH02541-007608,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "017297": {
        "Stato": "IT",
        "CAP": "10079",
        "Localit\u00e0": "MONCALIERI",
        "Indirizzo": "VIA RIVAROLO , 71",
        "N.ri Tel.": "011-8953288",
        "Insegna": "MOMI PLANET",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480"
    },
    "017931": {
        "Stato": "IT",
        "CAP": "92016",
        "Localit\u00e0": "RIBERA",
        "Indirizzo": "VIA PARLAPIANO 45",
        "N.ri Tel.": "092567939",
        "Insegna": "URSO MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBLGC01402-007111,26SBLGH02501-007558,26SBLKC01369-007101,26SBLKC01370-007101,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKP05526-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01402-007111"
    },
    "018451": {
        "Stato": "ES",
        "CAP": "31001",
        "Localit\u00e0": "PAMPLONA",
        "Indirizzo": "MAYOR, 5",
        "N.ri Tel.": "948222845",
        "Insegna": "ARTAZCOZ PROFESIONAL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUK11140-007286,25WBLUX02081-005958,26SBLUB04119-007449,26SBLUC01106-007101,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUF01032-007441,26SBLUF01132-007448,26SBLUT02064-006526",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "020666": {
        "Stato": "IT",
        "CAP": "90133",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA SAMMUZZO, 13/15",
        "N.ri Tel.": "0942-23151",
        "Insegna": "PARISI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03100-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11095-007110,26SBLDX03166-007455,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUX02084-007454,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "017951": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "45014",
        "Localit\u00e0": "PORTO VIRO LOC. DONADA",
        "Indirizzo": "VIA ROMA 35",
        "N.ri Tel.": "0426 320373",
        "Insegna": "STIL BIMBI"
    },
    "012518": {
        "Stato": "IT",
        "CAP": "88025",
        "Localit\u00e0": "MAIDA",
        "Indirizzo": "LOCALITA' COMUNI CONDOMINI",
        "N.ri Tel.": "0968/750121",
        "Insegna": "AMERICAN JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958,26SBLUC01106-007101,26SBLUC01200-007108,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUP02037-007441,26SBLUT02289-007479,26SBLUT02294-006801,26SBLUT02298-007440,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "015081": {
        "Stato": "IT",
        "CAP": "70019",
        "Localit\u00e0": "TRIGGIANO",
        "Indirizzo": "SP 60, C.C. BARIBLU  Lotto 1-76a",
        "N.ri Tel.": "080/3210405",
        "Insegna": "REV 73",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC11163-007110,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC02173-007104,26SBLDC03169-007455,26SBLUB04093-007461,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02299-007439,26SBLUH05070-007439,26SBLUL02445-007516,26SBLUP01331-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUT02290-006803,26SBLUT02309-007132,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP01002-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "001157": {
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "TORRICELLA",
        "Indirizzo": "VIA ROSARIO, 38",
        "N.ri Tel.": "099 9573024",
        "Insegna": "CAPUTO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02068-007439,26SBLUH02238-007439,26SBLUH02246-007457,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "008793": {
        "Stato": "IT",
        "CAP": "18012",
        "Localit\u00e0": "BORDIGHERA",
        "Indirizzo": "CORSO ITALIA, 42",
        "N.ri Tel.": "0184 262174",
        "Insegna": "TINTA TIENDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01136-007110,26SBLUH02299-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "009687": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "36030",
        "Localit\u00e0": "COSTABISSARA",
        "Indirizzo": "SS PASUBIO, 12/C",
        "N.ri Tel.": "0444 970487",
        "Insegna": "TATO E TATA"
    },
    "001444": {
        "Stato": "IT",
        "CAP": "23816",
        "Localit\u00e0": "BARZIO",
        "Indirizzo": "PIAZZA GARIBALDI, 3/4",
        "N.ri Tel.": "0341 996191",
        "Insegna": "MAROCCO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110"
    },
    "002918": {
        "Stato": "IT",
        "CAP": "25087",
        "Localit\u00e0": "SALO'",
        "Indirizzo": "PIAZZA ZANELLI, 16",
        "N.ri Tel.": "0365 43735",
        "Insegna": "DAY AFTER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC02173-007104,26SBLDC11099-007462,26SBLDP02278-007475,26SBLUB04119-007449,26SBLUC01106-007101,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF03243-006804,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "018553": {
        "Stato": "IT",
        "CAP": "10121",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA XX SETTEMBRE, 54",
        "N.ri Tel.": "011 3826111",
        "Insegna": "PRIME VANITA'",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958"
    },
    "013895": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "POGGIOMARINO",
        "Indirizzo": "VIA XXIV MAGGIO 429,",
        "N.ri Tel.": "0818652711",
        "Insegna": "TOMMASEO GROUP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03101-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01215-007131,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC11095-007110,26SBLGH02501-007558,26SBLGH02502-007558,26SBLKH02511-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKP05531-007557,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02307-007132,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "019521": {
        "Stato": "IT",
        "CAP": "24067",
        "Localit\u00e0": "SARNICO",
        "Indirizzo": "PIAZZA XX SETTEMBRE 1",
        "N.ri Tel.": "035/774303",
        "Insegna": "CERDELLI UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUB04119-007449,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "021454": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "98071",
        "Localit\u00e0": "CAPO D'ORLANDO",
        "Indirizzo": "VIA CRISPI, 41/43",
        "Insegna": "MANGANO JUNIOR"
    },
    "020475": {
        "CODICE PRODOTTO KOOOMO": "26SBLUC04131-007449,26SBLUC04139-007449,26SBLUH02068-007439,26SBLUN01432-006581,26SBLUN02490-007542,26SBLUP02037-007441,26SBLUS02271-007501,26SBLUS02271-007502",
        "Stato": "IT",
        "CAP": "00062",
        "Localit\u00e0": "BRACCIANO",
        "Indirizzo": "VIA SANDRO PERTINI, 1",
        "N.ri Tel.": "06 5898254",
        "Insegna": "CASTELLA.CASTELLESE",
        "PRODUCT CODE KOOOMO": "26SBLUC04131-007449"
    },
    "004859": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "GRAN VIA S. MARCOS,13",
        "N.ri Tel.": "0034 987 237203",
        "Insegna": "DIEGUEZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03161-006719,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK11140-007286"
    },
    "016353": {
        "Stato": "DE",
        "CAP": "67655",
        "Localit\u00e0": "Kaiserslautern",
        "Indirizzo": "Marktstrasse 40",
        "N.ri Tel.": "063163900",
        "Insegna": "HOSENSTUDIO WOLF GMBH",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK11140-007286,26SBLUB04119-007449,26SBLUC01043-007120,26SBLUC01199-007108,26SBLUC01229-007108,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUL02445-007516",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "000453": {
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA RUGGERO SETTIMO, 64",
        "N.ri Tel.": "091 326284",
        "Insegna": "UOMO CLUB",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC03169-007455,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC01107-007101,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUH02312-007132,26SBLUS04360-007499,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "020037": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "VIALE GALILEO GALILEI, 29",
        "N.ri Tel.": "0558797034",
        "Insegna": "MARTELLI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,26SBLDC01217-007108,26SBLDC02194-007476,26SBLDC03169-007455,26SBLDK11145-007110,26SBLDX02171-006648,26SBLUC01229-007108,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "000251": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLUC02079-A05958",
        "Stato": "IT",
        "CAP": "24050",
        "Localit\u00e0": "ORIO AL SERIO",
        "Indirizzo": "VIA PORTICO, 71",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI"
    },
    "008344": {
        "CODICE PRODOTTO KOOOMO": "26SBBXC02422-005958,26SBBXF02493-007570,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXP01494-007570,26SBBXP05495-007570,26SBLGF08505-007557,26SBLGH02501-007558,26SBLGH03504-007561,26SBLGP05503-007560,26SBLKA04464-007525,26SBLKC03373-006719,26SBLKF03528-007557,26SBLKF08530-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958",
        "Stato": "IT",
        "CAP": "66100",
        "Localit\u00e0": "CHIETI SCALO",
        "Indirizzo": "VIA TIRINO - LOC. S. FILOMENA  C/o C.C. MEGALO'",
        "N.ri Tel.": "0871 540245",
        "Insegna": "PELLIZZARI",
        "PRODUCT CODE KOOOMO": "26SBLKX02365-005958"
    },
    "012907": {
        "Stato": "CZ",
        "CAP": "110 00",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03182-006985,25WBLDM01463-007330,25WBLDX03181-006985"
    },
    "007667": {
        "Stato": "IT",
        "CAP": "88068",
        "Localit\u00e0": "SOVERATO",
        "Indirizzo": "VIA SANTA MARIA, 15",
        "N.ri Tel.": "0967 23325",
        "Insegna": "ALESSIO MELINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUB05126-007283,25WBLUC02077-006943,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11113-006787,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02065-006526,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02541-007608,26SBLUT02064-006526,26SBLUX02184-005958,26SBLUX02184-A05958,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "010914": {
        "Stato": "IT",
        "CAP": "16043",
        "Localit\u00e0": "CHIAVARI",
        "Indirizzo": "PIAZZA ROMA, 2",
        "N.ri Tel.": "0185 598043",
        "Insegna": "BLAUER STORE CHIAVARI",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBBXC02456-005958,25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDL01340-007355,25WBLDM01463-007330,25WBLGA05461-007349,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308,25WBLKC11416-007110,25WBLUA05297-006127,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC01136-007110,26SBLDC01217-007108,26SBLDC02173-007104,26SBLDC03165-007455,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDC04192-007474,26SBLDC04275-007475,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDF01114-006804,26SBLDF01322-007484,26SBLDF03115-006804,26SBLDF08057-007441,26SBLDH02407-007508,26SBLDH02411-005707,26SBLDH02414-005707,26SBLDH02415-007507,26SBLDH02418-006845,26SBLDH03222-007460,26SBLDH03413-005707,26SBLDK04249-007474,26SBLDK11147-007111,26SBLDL02447-007520,26SBLDL02536-007515,26SBLDM01486-007530,26SBLDM01488-007532,26SBLDM02484-007531,26SBLDP01116-006804,26SBLDP01276-007474,26SBLDP01279-007475,26SBLDP01395-007524,26SBLDP02278-007475,26SBLDP02399-007524,26SBLDP03351-007496,26SBLDP03352-007496,26SBLDP03353-007496,26SBLDP05117-006804,26SBLDP05265-007474,26SBLDS02400-007464,26SBLDS04343-007506,26SBLDS04392-007506,26SBLDT02086-006526,26SBLDV01339-007526,26SBLDV02341-007526,26SBLDV03258-007464,26SBLDX03166-007455,26SBLUA04463-007525,26SBLUA04468-007527,26SBLUB04119-007449,26SBLUC01043-007120,26SBLUC01108-007101,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01045-007465,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUF08140-007448,26SBLUH02121-007451,26SBLUH02235-007457,26SBLUH02246-007457,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUH02314-005695,26SBLUL02435-007520,26SBLUL02437-007156,26SBLUL02439-007521,26SBLUM01480-007167,26SBLUM06481-007167,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01128-007453,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUT02307-007132,26SBLUX03232-006719,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "015694": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480",
        "Stato": "ES",
        "CAP": "17100",
        "Localit\u00e0": "LA BISBAL D'EMPORDA",
        "Indirizzo": "CALLE PLAZA JACINTO, 4",
        "N.ri Tel.": "972640384",
        "Insegna": "HOMO"
    },
    "015023": {
        "Stato": "IT",
        "CAP": "80057",
        "Localit\u00e0": "SANT'ANTONIO ABATE",
        "Indirizzo": "VIA SANTA MARIA LA CARITA', 415",
        "N.ri Tel.": "081 8741741",
        "Insegna": "SANTONICOLA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK01375-007378,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUK03142-005480,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDH02414-005707,26SBLDH02416-007507,26SBLUC01107-007101,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUM01477-006233,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "019544": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA PRINCIPALE, 65",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK01376-007378"
    },
    "005189": {
        "Stato": "IT",
        "CAP": "95031",
        "Localit\u00e0": "ADRANO",
        "Indirizzo": "VIA CASALE DEI GRECI, 2",
        "N.ri Tel.": "095 7699130",
        "Insegna": "TREND ADRANO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02066-006526,26SBLUP02037-007441,26SBLUP04036-007441,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "018833": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUB05126-007283,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUX02081-005958,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11099-007462,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUP02037-007441,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "00158",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA GIOVANNI PENTA, 39/43",
        "N.ri Tel.": "06 86215948",
        "Insegna": "GIBOT",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "020496": {
        "Stato": "IT",
        "CAP": "72023",
        "Localit\u00e0": "MESAGNE",
        "Indirizzo": "CENTRO COMMERCIALE APPIA ANTICA SS7,7",
        "N.ri Tel.": "080 6970050",
        "Insegna": "TOP SPORT SRL - DESTINAZIONE IPERSPORT MESAGNE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDH02418-006845,26SBLDP03351-007496,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC11019-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP03329-007496,26SBLUP04332-007493,26SBLUT02290-006803,26SBLUT02297-006801,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "023222": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDK02073-006648",
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "WEITERSTADT",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- "
    },
    "012000": {
        "Stato": "IT",
        "CAP": "74011",
        "Localit\u00e0": "CASTELLANETA",
        "Indirizzo": "VIA R. MARGHERITA, 30",
        "N.ri Tel.": "099/ 8442321",
        "Insegna": "FUORI DAL COMUNE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC11083-007110,26SBLUC04118-007452,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02311-007132,26SBLUS04360-007499,26SBLUT02293-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04118-007452"
    },
    "018211": {
        "Stato": "IT",
        "CAP": "00173",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA TUSCOLANA, 1402",
        "N.ri Tel.": "06 7481852",
        "Insegna": "BABALUS",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958"
    },
    "015761": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01220-007108,26SBLDC04077-007474,26SBLDC04460-007475,26SBLDF01104-007441,26SBLDF03056-007441,26SBLDH02412-005707,26SBLDP01059-007441",
        "Stato": "DE",
        "CAP": "28832",
        "Localit\u00e0": "ACHIM",
        "Indirizzo": "AM SCHMIEDEBERG 19",
        "N.ri Tel.": "0049 4202881292",
        "Insegna": "VIVA DAMENMODEN",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "017904": {
        "Stato": "IT",
        "CAP": "75013",
        "Localit\u00e0": "FERRANDINA",
        "Indirizzo": "CORSO VITTORIO EMANUELE 60",
        "N.ri Tel.": "0835554619",
        "Insegna": "TUNNEL",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC11163-007110,25WBLDK01376-007378,25WBLDK11162-007110,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDH02415-007507,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUN02490-007542,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "019984": {
        "Stato": "IT",
        "CAP": "35100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA DELLE CONVERTITE 12/13",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25WBLUC03233-007308"
    },
    "016948": {
        "Stato": "IT",
        "CAP": "35028",
        "Localit\u00e0": "PIOVE DI SACCO",
        "Indirizzo": "VIA FRATELLI SANGUINAZZI, 1",
        "Insegna": "UOMO FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUB04040-006788,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUM01477-006233,26SBLUM06481-007167,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02294-006801,26SBLUT02296-006801,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04040-006788"
    },
    "018651": {
        "Stato": "IT",
        "CAP": "95037",
        "Localit\u00e0": "SAN GIOVANNI LA PUNTA",
        "Indirizzo": "VIA COLOMBO (PARCO COMMERCIALE I PORTALI BOX 105)",
        "N.ri Tel.": "095-387799",
        "Insegna": "DISTEFANO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,26SBLUB04226-007124,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUH02066-006526,26SBLUH02284-007480,26SBLUH02541-007608,26SBLUT02064-006526,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04226-007124"
    },
    "020059": {
        "Stato": "IT",
        "CAP": "01017",
        "Localit\u00e0": "TUSCANIA",
        "Indirizzo": "VIALE TRIESTE, 20",
        "N.ri Tel.": "3932167330",
        "Insegna": "CONTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUX02081-005958,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDF08057-007441,26SBLDP01059-007441,26SBLDT02087-006526,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUP02037-007441,26SBLUS04360-007499,26SBLUT02067-006526,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "000425": {
        "Stato": "IT",
        "CAP": "10141",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO RACCONIGI, 159/D",
        "N.ri Tel.": "011 331867",
        "Insegna": "UP COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03495-006047,25WBLUA05300-006434,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03090-006719,25WBLUC11083-007110,26SBLDC01158-007131,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDF01104-007441,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUS04360-007499,26SBLUT02293-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01158-007131"
    },
    "001367": {
        "Stato": "IT",
        "CAP": "60033",
        "Localit\u00e0": "CHIARAVALLE",
        "Indirizzo": "VIA D'ANTONA, 1",
        "N.ri Tel.": "071 948950",
        "Insegna": "GIGOLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDF01104-007441,26SBLDP01059-007441,26SBLDV02341-007526,26SBLUB04093-007461,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUF01239-006804,26SBLUH05070-007439,26SBLUM01477-006233,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "015217": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "70033",
        "Localit\u00e0": "CORATO",
        "Indirizzo": "VIA RUVO, 29",
        "N.ri Tel.": "0831-5640725",
        "Insegna": "GRAFFITI"
    },
    "013996": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA NINO BIXIO 16,",
        "N.ri Tel.": " 081-1956779",
        "Insegna": "CIRDEC",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03527-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBBXC01420-007111,26SBBXH02498-007558,26SBBXP05495-007570,26SBBXP05496-007570,26SBLDC01217-007108,26SBLDC11095-007110,26SBLGC01389-007111,26SBLGC01402-007111,26SBLGH02501-007558,26SBLGH03504-007561,26SBLGP05503-007560,26SBLKC11423-007110,26SBLKF03528-007557,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,26SBLKT02514-007559,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "015197": {
        "Stato": "IT",
        "CAP": "80142",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO GARIBALDI, 378/E",
        "N.ri Tel.": "081 202474",
        "Insegna": "MEDITERRANEO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03233-007308,26SBLDC01098-007111,26SBLDC01215-007131,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDH02211-007439,26SBLDH02415-007507,26SBLDH02416-007507,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02306-007440,26SBLUP02037-007441,26SBLUS04360-007499,26SBLUT02294-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "016517": {
        "Stato": "DE",
        "CAP": "44225",
        "Localit\u00e0": "DORTMUND",
        "Indirizzo": "HARKORTSTRASSE 25-27",
        "N.ri Tel.": "02317101142",
        "Insegna": "DUSTMANN. \t",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03161-006719,25WBLUC02079-005958,25WBLUC02151-007287,25WBLUC03090-006719,25WBLUC08078-006355,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC04460-007475,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUL02445-007516",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "018067": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,26SBBXC01420-007111,26SBBXC02422-005958,26SBLGC01389-007111,26SBLGC01406-007462,26SBLKC02364-005958,26SBLKX02368-007104,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "70033",
        "Localit\u00e0": "CORATO",
        "Indirizzo": "CORSO GARIBALDI, 156",
        "N.ri Tel.": "080 8984728",
        "Insegna": "HICMOS",
        "PRODUCT CODE KOOOMO": "26SBBXC01420-007111"
    },
    "015950": {
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "LEPORANO",
        "Indirizzo": "VIA PORTA TARANTO 40",
        "N.ri Tel.": "099- 5316143",
        "Insegna": "FERRANTINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUF02118-007121,25WBLUF03119-007121"
    },
    "016127": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC02176-006648,26SBLDC02281-007476,26SBLDC03168-007455",
        "Stato": "ES",
        "CAP": "43840",
        "Localit\u00e0": "SALOU, TARRAGONA",
        "Indirizzo": "PASEO JAIME 1, 10",
        "N.ri Tel.": "0034 977350723",
        "Insegna": "CACHE",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "020530": {
        "Stato": "IT",
        "CAP": "61043",
        "Localit\u00e0": "CAGLI",
        "Indirizzo": "VIA FLAMINIA, 175 B",
        "N.ri Tel.": "0721 781795",
        "Insegna": "TOPI ROSALBA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC11099-007462,26SBLDH02411-005707,26SBLUC02179-007104,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUH02302-007439,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "018210": {
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "24064",
        "Localit\u00e0": "GRUMELLO DEL MONTE",
        "Indirizzo": "VIA NEMBRINI, 63",
        "N.ri Tel.": "035 0782745",
        "Insegna": "DIDI STORE"
    },
    "013751": {
        "Stato": "IT",
        "CAP": "83012",
        "Localit\u00e0": "CERVINARA",
        "Indirizzo": "VIA ROMA 14",
        "N.ri Tel.": "0824 838042",
        "Insegna": "KALIMBUSA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355"
    },
    "007936": {
        "Stato": "IT",
        "CAP": "89046",
        "Localit\u00e0": "MARINA DI GIOIOSA IONICA",
        "Indirizzo": "PIAZZA ZALEUCO, 19",
        "N.ri Tel.": "0964 416439",
        "Insegna": "BELCASTRO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04201-007124"
    },
    "021256": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110",
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIA MAZZINI 72",
        "N.ri Tel.": "335-8112666",
        "Insegna": "- "
    },
    "015365": {
        "Stato": "CZ",
        "CAP": "370 01",
        "Localit\u00e0": "Ceske Budejovice CZ",
        "Indirizzo": "Namesti Otakara Premysla II 36",
        "N.ri Tel.": "00420777934924",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047,25WBLDM01463-007330"
    },
    "022129": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "VITORIA-GASTEIZ",
        "Indirizzo": "VIA LARGO BONITO 4-6-8",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047"
    },
    "001549": {
        "Stato": "IT",
        "CAP": "70033",
        "Localit\u00e0": "CORATO",
        "Indirizzo": "VIA RUVO, 29",
        "N.ri Tel.": "080 8981812",
        "Insegna": "GRAFFITI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC03169-007455,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUH02347-007495,26SBLUP01120-007452,26SBLUS01128-007453,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "014144": {
        "Stato": "IT",
        "CAP": "08100",
        "Localit\u00e0": "NUORO",
        "Indirizzo": "VIA BELLISSARIO, 113 - Z.I. PATROSARDO",
        "N.ri Tel.": "348 2292933",
        "Insegna": "TENDENZE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC11416-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKT02431-007440,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC01107-007101,26SBLUC04139-007449,26SBLUH02069-007439,26SBLUH02237-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "015861": {
        "Stato": "IT",
        "CAP": "56038",
        "Localit\u00e0": "PONSACCO",
        "Indirizzo": "PIAZZA D'APPIANO, 31",
        "N.ri Tel.": " 0587732836",
        "Insegna": "FEDERICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03101-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUK11140-007286,25WBLUL02318-007340,26SBLUB01024-007111,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUH01476-007478,26SBLUH04349-007495,26SBLUT02291-006803,26SBLUT02294-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB01024-007111"
    },
    "009128": {
        "Stato": "IT",
        "CAP": "82018",
        "Localit\u00e0": "SAN GIORGIO DEL SANNIO",
        "Indirizzo": "VIALE SPINELLI, 116",
        "N.ri Tel.": "0824 58992",
        "Insegna": "VANITY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC08078-006355,26SBLUH02068-007439,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUS04360-007499,26SBLUT02289-007479,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUH02068-007439"
    },
    "008209": {
        "Stato": "IT",
        "CAP": "51017",
        "Localit\u00e0": "UZZANO",
        "Indirizzo": "VIA PROVINCIALE LUCCHESE, 314/318",
        "N.ri Tel.": "0572 451098",
        "Insegna": "MALTAGLIATI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC02228-007119,26SBLDX03166-007455,26SBLUC04139-007449,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUT02067-006526,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02228-007119"
    },
    "015822": {
        "Stato": "IT",
        "CAP": "700121",
        "Localit\u00e0": "BARI",
        "Indirizzo": "VIA PRINCIPE AMEDEO, 43",
        "N.ri Tel.": "0805242936",
        "Insegna": "LUXX",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480"
    },
    "014993": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA CIRCUMVALLAZIONE ESTERNA, 96/98",
        "N.ri Tel.": "081 7593838",
        "Insegna": "CHARME AND MORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01215-007131,26SBLDC02172-007104,26SBLDC11095-007110,26SBLDH02211-007439,26SBLDH02327-007483,26SBLDH02411-005707,26SBLDT02087-006526,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP05244-006804,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "019958": {
        "Stato": "IT",
        "CAP": "67100",
        "Localit\u00e0": "L' AQUILA",
        "Indirizzo": "VIA VADO LA LENA, 15",
        "N.ri Tel.": "0776-855029",
        "Insegna": "BROGI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC03169-007455,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUL02441-007515,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "017826": {
        "Stato": "IT",
        "CAP": "39011",
        "Localit\u00e0": "LANA",
        "Indirizzo": "VIA ANDREAS HOFER, 12",
        "N.ri Tel.": "0473 090244",
        "Insegna": "MAVE'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDK02073-006648,25WBLDK03161-006719,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01215-007131,26SBLDC01219-007108,26SBLDC02176-006648,26SBLDC03167-007455,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC11027-007462,26SBLUF02240-006804,26SBLUP04334-007493,26SBLUT02288-007479,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "019227": {
        "Stato": "IT",
        "CAP": "91025",
        "Localit\u00e0": "MARSALA",
        "Indirizzo": "C.DA COZZARO, 323D - INT. 1-2",
        "N.ri Tel.": "0923-951043",
        "Insegna": "BONINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958"
    },
    "014565": {
        "Stato": "IT",
        "CAP": "71042",
        "Localit\u00e0": "CERIGNOLA",
        "Indirizzo": "VIA PEBLISCITO",
        "Insegna": "ORLANDO MICHELE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,26SBLUC02179-007104,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF02014-007121,26SBLUF02034-007441,26SBLUH02011-007149,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02238-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUP02037-007441,26SBLUP04016-007121,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "014619": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "PRATO",
        "Indirizzo": "VIA FABIO FILZI, 39/G",
        "N.ri Tel.": "0574/42371",
        "Insegna": "SPGJ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUF03119-007121,26SBLDC01215-007131,26SBLDC04077-007474,26SBLUC01108-007101,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11028-007462,26SBLUF03013-007121,26SBLUF03243-006804,26SBLUH02069-007439,26SBLUH02235-007457,26SBLUH02283-007480,26SBLUH02285-007480,26SBLUP02037-007441,26SBLUP05244-006804,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "018626": {
        "Stato": "IT",
        "CAP": "25035",
        "Localit\u00e0": "OSPITALETTO",
        "Indirizzo": "VIA PADANA SUPERIORE",
        "N.ri Tel.": "340 2373984",
        "Insegna": "SPORTLAND STILE OSPITALETTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,26SBLDC02173-007104,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDP01059-007441,26SBLUC01106-007101,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUT02064-006526,26SBLUX02181-007104,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "020879": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA ASTALONGA, 98",
        "N.ri Tel.": "081-8501783",
        "Insegna": "- "
    },
    "008241": {
        "Stato": "IT",
        "CAP": "24121",
        "Localit\u00e0": "BERGAMO",
        "Indirizzo": "VIALE PAPA GIOVANNI XXIII, 88",
        "N.ri Tel.": "035 244504",
        "Insegna": "TIFFANY CLUB 88",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC03169-007455,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "020766": {
        "Stato": "IT",
        "CAP": "61033",
        "Localit\u00e0": "FERMIGNANO",
        "Indirizzo": "VIALE KENNEDY, 44",
        "N.ri Tel.": "0722 331403",
        "Insegna": "ZAGARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308"
    },
    "006253": {
        "Stato": "IT",
        "CAP": "00044",
        "Localit\u00e0": "FRASCATI",
        "Indirizzo": "VIA C. BATTISTI, 6",
        "N.ri Tel.": "329 9391946",
        "Insegna": "PIGNATELLI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDK03102-006047,25WBLUB05126-007283,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL02318-007340,26SBLDF01114-006804,26SBLDH03222-007460,26SBLDH05223-007460,26SBLDP01116-006804,26SBLUC04139-007449,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01132-007448,26SBLUH02284-007480,26SBLUH02306-007440,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUP01133-007448,26SBLUP02336-007493,26SBLUS01126-007453,26SBLUS01356-007500,26SBLUS02271-007501,26SBLUT02067-006526,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02307-007132,26SBLUX02181-007104,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDF01114-006804"
    },
    "023414": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03092-006719,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC03090-006719",
        "Stato": "XK",
        "CAP": "85748",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- "
    },
    "016919": {
        "Stato": "ES",
        "CAP": "37002",
        "Localit\u00e0": "SALAMANCA",
        "Indirizzo": "ANAMONT C / ZAMORA 84-86",
        "N.ri Tel.": "0034 923267680",
        "Insegna": "ANAMONT",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC01215-007131,26SBLDC01218-007108,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDK11147-007111,26SBLDL02446-007520,26SBLDL02452-007513,26SBLDP05326-007484,26SBLDV03258-007464,26SBLUB04040-006788,26SBLUB04226-007124,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF01045-007465,26SBLUF03044-007465,26SBLUH02011-007149,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUL02439-007521,26SBLUP04332-007493,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02304-007481,99CBLUP04003-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "009763": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "VIA CANCELLIERI DI SASSETE 17",
        "N.ri Tel.": "055 8798793",
        "Insegna": "TIPITOSTI",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBLKF02527-007557,26SBLKF08530-007557,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLKF02527-007557"
    },
    "016427": {
        "Stato": "IT",
        "CAP": "20095",
        "Localit\u00e0": "CUSANO MILANINO",
        "Indirizzo": "VIA SORMANI, 52",
        "N.ri Tel.": "347/5337685",
        "Insegna": "BROOMLEY",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648"
    },
    "011200": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308",
        "Stato": "IT",
        "CAP": "23900",
        "Localit\u00e0": "LECCO",
        "Indirizzo": "Piazza XX Settembre, 5",
        "N.ri Tel.": "0341 1716240",
        "Insegna": "BUTTI"
    },
    "017352": {
        "CODICE PRODOTTO KOOOMO": "26SBBXC02422-005958,26SBLGC02380-006648,26SBLGC03410-007455,26SBLKC02366-007104,26SBLKC03373-006719,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA MONTESANTO, 83-85",
        "N.ri Tel.": "0984 86233",
        "Insegna": "PRIMAMODA",
        "PRODUCT CODE KOOOMO": "26SBBXC02422-005958"
    },
    "000746": {
        "Stato": "IT",
        "CAP": "80046",
        "Localit\u00e0": "S. GIORGIO A CREMANO",
        "Indirizzo": "VIA DE LAUZIERES, 16/18",
        "N.ri Tel.": "081 479666",
        "Insegna": "GUARRACINO",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958"
    },
    "015026": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "26866",
        "Localit\u00e0": "SANT'ANGELO LODIGIANO",
        "Indirizzo": "VIA GIUSEPPE MAZZINI,  21",
        "N.ri Tel.": "0371933926",
        "Insegna": "FRATTI"
    },
    "014967": {
        "Stato": "IT",
        "CAP": "00133",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE SAN LORENZO, 60",
        "N.ri Tel.": "06/2005495",
        "Insegna": "L' ELEFANTINO STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "018629": {
        "Stato": "IT",
        "CAP": "08029",
        "Localit\u00e0": "SINISCOLA",
        "Indirizzo": "VIA GRAMSCI, 20",
        "Insegna": "ALMON 20",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUK03142-005480"
    },
    "014875": {
        "Stato": "ES",
        "CAP": "17820",
        "Localit\u00e0": "BA\u00d1OAS",
        "Indirizzo": "CALLE MERCADAL 9",
        "N.ri Tel.": "972574856",
        "Insegna": "COMALAT DONA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,26SBLDC02173-007104,26SBLDC11099-007462,26SBLDK04249-007474,26SBLDK11147-007111",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "008799": {
        "Stato": "IT",
        "CAP": "74100",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "PIAZZA MARIA IMMACOLATA, 7/9",
        "N.ri Tel.": "099 4528083",
        "Insegna": "NITOR",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLUA05298-006127,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUF02118-007121,25WBLUL02318-007340"
    },
    "000354": {
        "Stato": "IT",
        "CAP": "29010",
        "Localit\u00e0": "CASTELVETRO PIACENTINO",
        "Indirizzo": "STRADA STATALE, 10",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03096-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,26SBLDC01219-007108,26SBLDC02194-007476,26SBLDC02281-007476,26SBLDC11099-007462,26SBLUB04119-007449,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS01356-007500,26SBLUX02184-005958,99CBLUP04003-007493,99CBLUP04004-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC02194-007476"
    },
    "008962": {
        "Stato": "IT",
        "CAP": "86039",
        "Localit\u00e0": "TERMOLI",
        "Indirizzo": "C.SO F.LLI BRIGIDA",
        "N.ri Tel.": "0874.65273",
        "Insegna": "MONDOVELA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDC03357-007294,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "015613": {
        "Stato": "IT",
        "CAP": "21040",
        "Localit\u00e0": "GERENZANO VARESE",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 2",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03527-006047,25WBLDP01291-007324,25WBLGC02391-006648,25WBLUA05301-006434,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDC03169-007455,26SBLKC02364-005958,26SBLKC02542-007459,26SBLUC01022-007110,26SBLUC01106-007101,26SBLUC03177-006719,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "018326": {
        "Stato": "IT",
        "CAP": "00053",
        "Localit\u00e0": "CIVITAVECCHIA",
        "Indirizzo": "VIA SETTEVENE PALO ,81",
        "N.ri Tel.": "0766 370357",
        "Insegna": "PER LUI PER LEI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC03169-007455,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUL02442-007515,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "018302": {
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "SAN GIOVANNI ROTONDO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "335 568 5635",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110"
    },
    "019992": {
        "Stato": "IT",
        "CAP": "66043",
        "Localit\u00e0": "CASOLI",
        "Indirizzo": "CONTRADA SELVA PIANA, 62",
        "N.ri Tel.": "0872982751",
        "Insegna": "CAPUZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355"
    },
    "009104": {
        "Stato": "IT",
        "CAP": "80016",
        "Localit\u00e0": "MARANO DI NAPOLI",
        "Indirizzo": "CORSO EUROPA, 190/192",
        "N.ri Tel.": "081 5865395",
        "Insegna": "IDEASPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK03495-006047,25WBLUC02132-007284,25WBLUC03090-006719,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11021-007111,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "017481": {
        "Stato": "IT",
        "CAP": "89024",
        "Localit\u00e0": "POLISTENA",
        "Indirizzo": "PIAZZETTA GARIBALDI 4",
        "N.ri Tel.": "0966 931479",
        "Insegna": "CARBONE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,26SBLDC02154-006648,26SBLDC03165-007455,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02154-006648"
    },
    "017187": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "BENEVENTO",
        "Indirizzo": "CORSO GARIBALDI, 119-121",
        "N.ri Tel.": "0824 21110",
        "Insegna": "MAG JHON",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01215-007131,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02068-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "017405": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA FORIA, 44",
        "N.ri Tel.": "081 450265",
        "Insegna": "DRESS",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,26SBBXC01430-007111,26SBLGC01402-007111,26SBLKC11401-007111,26SBLKC11423-007110,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04201-007124"
    },
    "019052": {
        "Stato": "IT",
        "CAP": "80035",
        "Localit\u00e0": "NOLA",
        "Indirizzo": "VIA SARNELLA, 9",
        "N.ri Tel.": "081 8232420",
        "Insegna": "FEDELE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047"
    },
    "009442": {
        "Stato": "IT",
        "CAP": "81056",
        "Localit\u00e0": "SPARANISE",
        "Indirizzo": "VIA CONTE ALDEMARIO, 25",
        "N.ri Tel.": "0823-881174",
        "Insegna": "PIRMEMPS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK01375-007378,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC11095-007110,26SBLDK11147-007111,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUT02295-006801,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "019285": {
        "Stato": "ES",
        "CAP": "31500",
        "Localit\u00e0": "TUDELA, NAVARRA",
        "Indirizzo": "AV. ZARAGOZA 14",
        "N.ri Tel.": "948820061",
        "Insegna": "AQUERRETA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "018283": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03100-006047,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "43010",
        "Localit\u00e0": "MONCHIO DELLE CORTI",
        "Indirizzo": "VIA PER PRATOSPILLA, 10",
        "N.ri Tel.": "335 711 6528",
        "Insegna": "WINNER"
    },
    "001226": {
        "Stato": "IT",
        "CAP": "50136",
        "Localit\u00e0": "FIRENZE",
        "Indirizzo": "VIA F. DE SANCTIS, 24R",
        "N.ri Tel.": "055 660712",
        "Insegna": "MARCO OLIVA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUK03142-005480"
    },
    "021087": {
        "Stato": "IT",
        "CAP": "73951",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "WESTERBACHSTRASSE 5",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03100-006047,25WBLDM01463-007330"
    },
    "007636": {
        "Stato": "IT",
        "CAP": "28015",
        "Localit\u00e0": "MOMO",
        "Indirizzo": "VIA BONIPERTI, 71",
        "N.ri Tel.": "0321 990073",
        "Insegna": "NEW BOX",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958"
    },
    "015557": {
        "Stato": "IT",
        "CAP": "76011",
        "Localit\u00e0": "BISCEGLIE",
        "Indirizzo": "VIA ALDO MORO, 17",
        "N.ri Tel.": "0803968313",
        "Insegna": "LA FIORENTE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK02069-006648,25WBLDL01346-007354,25WBLUA05297-006127,25WBLUC11083-007110,26SBLDC01219-007108,26SBLDC02170-006648,26SBLDC02173-007104,26SBLDC02281-007476,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDK11147-007111,26SBLDP03351-007496,26SBLDP03352-007496,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "015587": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "31046",
        "Localit\u00e0": "ODERZO",
        "Indirizzo": "PIAZZA GRANDE, 5",
        "N.ri Tel.": "0422-814510",
        "Insegna": "START ODERZO"
    },
    "020181": {
        "Stato": "IT",
        "CAP": "87023",
        "Localit\u00e0": "DIAMANTE",
        "Indirizzo": "CORSO V.EMANUELE, 15",
        "Insegna": "MIRIADE DIAMANTE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958,26SBLUC02179-007104,26SBLUC11027-007462,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUH02283-007480,26SBLUH02300-007439,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "019231": {
        "Stato": "IT",
        "CAP": "25034",
        "Localit\u00e0": "ORZI NUOVI",
        "Indirizzo": "PIAZZA VITTORIO EMANUELE II , 2",
        "N.ri Tel.": "030 9941872",
        "Insegna": "JOLIE BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958,26SBLGC01389-007111,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKF08530-007557,26SBLKH02524-007558,26SBLKN02491-007542,26SBLKP05531-007557,26SBLKT02431-007440,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "018990": {
        "Stato": "IT",
        "CAP": "74016",
        "Localit\u00e0": "MASSAFRA",
        "Indirizzo": "VIA GUGLIELMO MARCONI 75",
        "N.ri Tel.": "099 4005589",
        "Insegna": "SALVATORE VALENTINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDF08057-007441,26SBLDH02327-007483,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDP01059-007441,26SBLDP05058-007441,26SBLDP05326-007484,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "004883": {
        "Stato": "ES",
        "CAP": "08037",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "CALLE PAU CLARIS, 159",
        "N.ri Tel.": "0034 934 876084",
        "Insegna": "NOTENOM",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK02192-006648,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308"
    },
    "020061": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA SANDRO PERTINI,4",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- "
    },
    "023910": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047",
        "Stato": "PL",
        "CAP": "M1 2EG",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "941593051",
        "Insegna": "- "
    },
    "019316": {
        "Stato": "ES",
        "CAP": "39700",
        "Localit\u00e0": "CASTRO URDIALES, CANTABRIA",
        "Indirizzo": "JUAN DE LA COSA, 10",
        "N.ri Tel.": "637773089",
        "Insegna": "EL BORNE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02170-006648,25WBLDC03099-006047,25WBLDC03173-007307,25WBLDK02192-006648,25WBLDK11162-007110,25WBLDL01340-007355,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC01220-007108,26SBLDC01262-007101,26SBLDC04077-007474,26SBLDK11147-007111,26SBLDP01259-007464,26SBLDT02087-006526",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "001232": {
        "Stato": "IT",
        "CAP": "16132",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA BORGORATTI, 8R",
        "N.ri Tel.": "010 381779",
        "Insegna": "OLMEDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP03350-007496,26SBLUT02304-007481,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "015198": {
        "Stato": "DE",
        "CAP": "52146",
        "Localit\u00e0": "Wuerselen",
        "Indirizzo": "Kaiserstrasse 72",
        "N.ri Tel.": "+49 240591770",
        "Insegna": "ROBOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03182-006985"
    },
    "020921": {
        "Stato": "IT",
        "CAP": "96100",
        "Localit\u00e0": "VALENZANO",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "3475860510",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110"
    },
    "001140": {
        "CODICE PRODOTTO KOOOMO": "26SBBXC02422-005958,26SBLGC03410-007455,26SBLKC03373-006719,26SBLKF02527-007557,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "52100",
        "Localit\u00e0": "AREZZO",
        "Indirizzo": "VIA V. VENETO, 19/21",
        "N.ri Tel.": "0575 902650",
        "Insegna": "ADA E ZUCCHERO",
        "PRODUCT CODE KOOOMO": "26SBBXC02422-005958"
    },
    "000126": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01218-007108,26SBLDC02206-007459,26SBLGC01378-007108,26SBLKC06372-007101,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04201-007124",
        "Stato": "IT",
        "CAP": "00040",
        "Localit\u00e0": "MARINO",
        "Indirizzo": "VIA APPIA NUOVA KM 19,4",
        "N.ri Tel.": "06 93548512",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "003575": {
        "Stato": "DE",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ESCHENBRUENNLESTRASSE 11",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287"
    },
    "015243": {
        "Stato": "IT",
        "CAP": "85038",
        "Localit\u00e0": "SENISE",
        "Indirizzo": "VIA MADONNA D'ANGLONA, 130",
        "N.ri Tel.": "0973 584426",
        "Insegna": "MIRAGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC03165-007455,26SBLDC11099-007462,26SBLDC11100-007462,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUP04332-007493,26SBLUT02297-006801,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "015465": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA FILUMENA MARTURANO, 28",
        "N.ri Tel.": "081 5593427",
        "Insegna": "BLACK JACK"
    },
    "021330": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958",
        "Stato": "IT",
        "CAP": "86039",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA XX SETTEMBRE 9",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- "
    },
    "019759": {
        "Stato": "IT",
        "CAP": "25136",
        "Localit\u00e0": "BRESCIA",
        "Indirizzo": "VIA TRIUMPLINA, 235",
        "N.ri Tel.": "030 - 2000859",
        "Insegna": "E-MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGA05461-007349,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,26SBLDC01218-007108,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02212-007439,26SBLDK11147-007111,26SBLGC01406-007462,26SBLKC01369-007101,26SBLKX02365-005958,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP05244-006804,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "019370": {
        "Stato": "IT",
        "CAP": "00125",
        "Localit\u00e0": "ROMA - ACILIA",
        "Indirizzo": "PIAZZA SAN LEONARDO DA PORTO MAURIZIO, 27",
        "N.ri Tel.": "06/65746565",
        "Insegna": "sportcenter",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11099-007462,26SBLUA04467-007527,26SBLUC01108-007101,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUM01477-006233,26SBLUP05244-006804,26SBLUT02296-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "010591": {
        "Stato": "IT",
        "CAP": "10142",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA MONGINEVRO, 187/D",
        "N.ri Tel.": "011-19037343",
        "Insegna": "ZAGHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDF08057-007441,26SBLDP01059-007441,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "016991": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "PIAZZA XX SETTEMBRE, 8",
        "N.ri Tel.": "055 8798664",
        "Insegna": "RICICLO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC11095-007110,26SBLUA04463-007525,26SBLUA04467-007527,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02233-007457,26SBLUH02234-007457,26SBLUH02283-007480,26SBLUH02301-007439,26SBLUH02302-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "000862": {
        "Stato": "IT",
        "CAP": "87022",
        "Localit\u00e0": "CETRARO MARINA",
        "Indirizzo": "VIA AMALFI, 32 34 36",
        "N.ri Tel.": "0982 999226",
        "Insegna": "PAGINE DI MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC01262-007101,26SBLDC02172-007104,26SBLDL02536-007515,26SBLUC03177-006719,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUF02034-007441,26SBLUH02300-007439,26SBLUH02541-007608,26SBLUL02442-007515,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "008619": {
        "Stato": "IT",
        "CAP": "70042",
        "Localit\u00e0": "MOLA DI BARI",
        "Indirizzo": "VIA C. BATTISTI, 115",
        "N.ri Tel.": "080 4744144",
        "Insegna": "PIETANZA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUK03142-005480"
    },
    "012611": {
        "Stato": "IT",
        "CAP": "67032",
        "Localit\u00e0": "PESCASSEROLI",
        "Indirizzo": "VIA PRINCIPE DI NAPOLI, 3",
        "N.ri Tel.": "0863/91881",
        "Insegna": "GALLINELLI MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC11163-007110,25WBLDK01375-007378,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110"
    },
    "007364": {
        "Stato": "IT",
        "CAP": "71043",
        "Localit\u00e0": "MANFREDONIA",
        "Indirizzo": "CORSO MANFREDI, 202",
        "N.ri Tel.": "0884 534712",
        "Insegna": "PROPOSTA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDF08236-007301,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02246-007457,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02067-006526,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02297-006801,26SBLUT02304-007481,26SBLUX02184-005958,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "009733": {
        "Stato": "IT",
        "CAP": "84129",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA ROCCO COCCHIA 21/25",
        "N.ri Tel.": "089 721928",
        "Insegna": "GOA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP02037-007441,26SBLUP05244-006804,26SBLUT02064-006526,26SBLUT02298-007440,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "007078": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA CALOPRESE, 47-49",
        "N.ri Tel.": "0984 390262",
        "Insegna": "VIP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLDP01291-007324,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958,26SBLDC01262-007101,26SBLDC02170-006648,26SBLDC02281-007476,26SBLDC11099-007462,26SBLDH02411-005707,26SBLDK04249-007474,26SBLDK11147-007111,26SBLDV02341-007526,26SBLDV04396-007526,26SBLUC02179-007104,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUL02441-007515,26SBLUT02304-007481,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01262-007101"
    },
    "015568": {
        "Stato": "IT",
        "CAP": "00044",
        "Localit\u00e0": "FRASCATI",
        "Indirizzo": "VIA BEZZECCA, 1",
        "N.ri Tel.": "069425631",
        "Insegna": "GENTE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03527-006047,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC04460-007475,26SBLDH02415-007507,26SBLDH02417-006845,26SBLDP01398-007526,26SBLDS04343-007506,26SBLDV01339-007526,26SBLDV03258-007464,26SBLDV04396-007526,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "011464": {
        "Stato": "IT",
        "CAP": "87067",
        "Localit\u00e0": "ROSSANO",
        "Indirizzo": "VIA NAZIONALE, 85",
        "N.ri Tel.": "0983/290788",
        "Insegna": "IN STILE BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUL01314-007012,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC02190-007454,26SBLDC02228-007119,26SBLDC03169-007455,26SBLDC04460-007475,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "018117": {
        "Stato": "IT",
        "CAP": "26013",
        "Localit\u00e0": "CREMA",
        "Indirizzo": "VIA XX SETTEMBRE, 105",
        "N.ri Tel.": "0373 222997",
        "Insegna": "GDS BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLGA05461-007349,25WBLKA05458-006127,25WBLKC02429-005958,25WBLUC03074-006355,25WBLUC08078-006355,26SBBXC02422-005958,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP01494-007570,26SBBXP05495-007570,26SBBXP05496-007570,26SBLDC03169-007455,26SBLGC03410-007455,26SBLKA04464-007525,26SBLKA04466-007525,26SBLKA04469-007527,26SBLKC03373-006719,26SBLKF02527-007557,26SBLKF03529-007557,26SBLKF08530-007557,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKN02491-007542,26SBLKP05526-007557,26SBLKT02431-007440,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUT02064-006526,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "020664": {
        "Stato": "IT",
        "CAP": "80016",
        "Localit\u00e0": "MARANO DI NAPOLI",
        "Indirizzo": "CORSO EUROPA, 158",
        "N.ri Tel.": "3772037225",
        "Insegna": "SCUGNIZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBLGC01389-007111,26SBLGC01402-007111,26SBLKC11423-007110,26SBLKH02512-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKP05526-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "022053": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIALE CARDUCCI, 79",
        "N.ri Tel.": "686095154",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK11162-007110"
    },
    "018897": {
        "Stato": "IT",
        "CAP": "92015",
        "Localit\u00e0": "RAFFADALI",
        "Indirizzo": "VIA PORTA AGRIGENTO, 203",
        "N.ri Tel.": "0922/471607",
        "Insegna": "BIMBO IN",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02429-005958,26SBLGC01402-007111,26SBLGC02380-006648,26SBLGH02501-007558,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKC11401-007111,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKN01433-006581,26SBLKN02491-007542,26SBLKP05519-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01402-007111"
    },
    "015715": {
        "Stato": "IT",
        "CAP": "16164",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA ANFOSSI, 118R",
        "N.ri Tel.": "010/715606",
        "Insegna": "OLIVA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUS04360-007499,26SBLUT02293-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "023206": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958",
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "Magnice, Wroclaw",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- "
    },
    "000145": {
        "Stato": "IT",
        "CAP": "00157",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA CURIONI, 37",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,26SBLUN02490-007542",
        "PRODUCT CODE KOOOMO": "26SBLUN02490-007542"
    },
    "007740": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLKC02427-005958,26SBLGC01389-007111,26SBLGC01402-007111,26SBLKA04469-007527,26SBLKC01403-007462,26SBLKC06372-007101,26SBLKF08515-007557,26SBLKH02512-007558,26SBLKN02491-007542,26SBLKT02514-007559,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "22017",
        "Localit\u00e0": "MENAGGIO",
        "Indirizzo": "VIA CAMOZZI, 26",
        "N.ri Tel.": "0344 31382",
        "Insegna": "BOLLICINE",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "010512": {
        "Stato": "IT",
        "CAP": "76123",
        "Localit\u00e0": "ANDRIA",
        "Indirizzo": "VIA REGINA MARGHERITA 47,",
        "N.ri Tel.": "0883/593579",
        "Insegna": "BRUNO 1924",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC08078-006355,25WBLUK11140-007286,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUB04119-007449,26SBLUC02221-007124,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUH02011-007149,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02541-007608,26SBLUL02445-007516,26SBLUM01480-007167,26SBLUS01356-007500,26SBLUS01358-007499,26SBLUS02271-007501,26SBLUS02271-007502,26SBLUS04360-007499,26SBLUT02297-006801,26SBLUT02309-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "019365": {
        "Stato": "IT",
        "CAP": "80079",
        "Localit\u00e0": "PROCIDA",
        "Indirizzo": "VIA VITTORIO EMANUELE, 307",
        "N.ri Tel.": "081/19564365",
        "Insegna": "LUPES",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDF08248-006948,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC01218-007108,26SBLDC02175-007119,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF08057-007441,26SBLUA04463-007525,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02069-007439,26SBLUH02238-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUH05070-007439,26SBLUM01477-006233,26SBLUP03350-007496,26SBLUS01126-007453,26SBLUT02064-006526,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUT02304-007481,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "016149": {
        "Stato": "IT",
        "CAP": "73020",
        "Localit\u00e0": "CASTRI' DI LECCE",
        "Indirizzo": "VIA G. BRODOLINI ANG VIA MENOTTI SNC",
        "Insegna": "SMACH",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308"
    },
    "015300": {
        "Stato": "IT",
        "CAP": "84102",
        "Localit\u00e0": "ANGRI",
        "Indirizzo": "CORSO ITALIA, 107",
        "N.ri Tel.": "0815132638",
        "Insegna": "PEPP O PIEZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03233-007308,26SBLDC01218-007108,26SBLDC11095-007110,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "001765": {
        "Stato": "IT",
        "CAP": "00060",
        "Localit\u00e0": "FORMELLO",
        "Indirizzo": "VIA CASAL DEI PINI, 9/10/11",
        "N.ri Tel.": "06 90127774",
        "Insegna": "EXPANCE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDP01059-007441,26SBLDP01398-007526,26SBLDP02278-007475,26SBLDS01345-007506,26SBLDT02087-006526,26SBLUA04463-007525,26SBLUA04470-007525,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01132-007448,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUH02311-007132,26SBLUP05244-006804,26SBLUT02064-006526,26SBLUT02298-007440,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "020927": {
        "Stato": "UA",
        "CAP": "85748",
        "Localit\u00e0": "GARCHING",
        "Indirizzo": "PR. POBEDI 90",
        "N.ri Tel.": "0049 89 5527860",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03182-006985"
    },
    "008587": {
        "Stato": "IT",
        "CAP": "36047",
        "Localit\u00e0": "MONTEGALDA",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "0444 635146",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284"
    },
    "012431": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK05019-007298",
        "Stato": "GB",
        "CAP": "LL53 7AS",
        "Localit\u00e0": "GWYNEDD",
        "Indirizzo": "THE HARBOUR, ABERSOCH, PWLLHELI",
        "N.ri Tel.": "01758 712293",
        "Insegna": "- "
    },
    "016594": {
        "Stato": "ES",
        "CAP": "09003",
        "Localit\u00e0": "BURGOS",
        "Indirizzo": "PLAZA ALONSO MARTINEZ N. 7",
        "N.ri Tel.": "0034 947209358",
        "Insegna": "BOUTIQUE GISELA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK02192-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBLDC02173-007104,26SBLDC02228-007119,26SBLKC02364-005958",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "000706": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "05029",
        "Localit\u00e0": "SAN GEMINI",
        "Indirizzo": "VIA E. FERMI s.n.c.",
        "N.ri Tel.": "0744 242531 AMM",
        "Insegna": "- "
    },
    "018628": {
        "Stato": "IT",
        "CAP": "25055",
        "Localit\u00e0": "PISOGNE",
        "Indirizzo": "VIA DELLA REPUBBLICA, 1",
        "N.ri Tel.": "340 2373984",
        "Insegna": "SPORTLAND PISOGNE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,26SBLDC02173-007104,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDP01059-007441,26SBLUC01106-007101,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUT02064-006526,26SBLUX02181-007104,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "010556": {
        "Stato": "IT",
        "CAP": "70052",
        "Localit\u00e0": "BISCEGLIE",
        "Indirizzo": "PIAZZA VITT. EMANUELE, 62",
        "N.ri Tel.": "080/3957689",
        "Insegna": "LAMANUZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLUC02180-007104,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02285-007480,26SBLUP02037-007441,26SBLUP03329-007496,26SBLUP04036-007441,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02180-007104"
    },
    "020342": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+49(0)40 638569-427",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK02192-006648"
    },
    "011069": {
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA ENRICO PARISI, 21",
        "N.ri Tel.": "091 322719",
        "Insegna": "UOMO STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "008356": {
        "Stato": "IT",
        "CAP": "20813",
        "Localit\u00e0": "LIMBIATE",
        "Indirizzo": "CORSO COMO, 13",
        "N.ri Tel.": "0362 594987",
        "Insegna": "MARCONI 22",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355"
    },
    "013864": {
        "Stato": "IT",
        "CAP": "88018",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "CORSO UMBERTO I, 118",
        "N.ri Tel.": "0963 42301",
        "Insegna": "BONGIOVANNI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08248-006948,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC03169-007455,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDK11147-007111,26SBLDP01059-007441,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02541-007608,26SBLUM01480-007167,26SBLUM06481-007167,26SBLUP02037-007441,26SBLUS01358-007499,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "016836": {
        "Stato": "DE",
        "CAP": "32052",
        "Localit\u00e0": "Herford",
        "Indirizzo": "Gehrenberg 11",
        "Insegna": "Klingenthal (Herford)",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK02192-006648,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC03168-007455,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000845": {
        "Stato": "IT",
        "CAP": "80059",
        "Localit\u00e0": "TORRE DEL GRECO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 160 (EX 264)",
        "N.ri Tel.": "081 8812587",
        "Insegna": "PROCIDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02294-006801,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "001579": {
        "Stato": "IT",
        "CAP": "06059",
        "Localit\u00e0": "TODI",
        "Indirizzo": "VIA ANGELO CORTESI, 38",
        "N.ri Tel.": "075 8942732",
        "Insegna": "FIRENZE MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK11162-007110,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUL02441-007515,26SBLUS01358-007499,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "010718": {
        "Stato": "IT",
        "CAP": "56028",
        "Localit\u00e0": "PONTE A EGOLA - SAN MINIATO",
        "Indirizzo": "VIA ANTONIO GRAMSCI 8 10 12,",
        "N.ri Tel.": "0571 497870",
        "Insegna": "BONNIE & CLYDE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDK03527-006047,25WBLUC03074-006355"
    },
    "009497": {
        "Stato": "IT",
        "CAP": "81025",
        "Localit\u00e0": "MARCIANISE",
        "Indirizzo": "VIA S.S. SANNITICA, 87 KM 19",
        "N.ri Tel.": "379 1827111 amm.",
        "Insegna": "O1 COSCIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,26SBLKC06372-007101,26SBLKC11423-007110,26SBLUC01106-007101,26SBLUC11021-007111,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02306-007440,26SBLUP05244-006804,26SBLUT02298-007440,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "018121": {
        "Stato": "IT",
        "CAP": "10147",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA STRADELLA, 215",
        "N.ri Tel.": "3462150758",
        "Insegna": "MOD EMPORIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDP01291-007324,25WBLUA05298-006127,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01217-007108,26SBLDC02206-007459,26SBLDF03056-007441,26SBLDH03224-007460,26SBLDP05058-007441,26SBLUA04463-007525,26SBLUC01022-007110,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUF01032-007441,26SBLUH02066-006526,26SBLUH02069-007439,26SBLUH02237-007439,26SBLUH02246-007457,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02311-007132,26SBLUP02037-007441,26SBLUT02293-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "014780": {
        "Stato": "ES",
        "CAP": "25230",
        "Localit\u00e0": "MOLLERUSSA",
        "Indirizzo": "PLAZA PLA DE URGELL 1",
        "N.ri Tel.": "0034 973603401",
        "Insegna": "ESSER ROBA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK03161-006719,25WBLDK11162-007110,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDF03056-007441,26SBLDF08323-007484,26SBLDH03328-007483,26SBLDM02484-007531,26SBLDP01059-007441,26SBLDP02260-007464,26SBLDP05326-007484,26SBLDS02400-007464,26SBLDV03258-007464,26SBLDV05282-007475,26SBLUC01106-007101,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02246-007457,26SBLUH02299-007439,26SBLUH02312-007132,26SBLUM06481-007167,26SBLUN02129-007447,26SBLUT02296-006801,26SBLUT02304-007481",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "001618": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01215-007131,26SBLDC01217-007108,26SBLDC04460-007475,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC01108-007101,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH05070-007439,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "80126",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO DUCA D'AOSTA, 27",
        "N.ri Tel.": "081 7267187",
        "Insegna": "MELE",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "001630": {
        "Stato": "IT",
        "CAP": "80053",
        "Localit\u00e0": "CASTELLAMARE DI STABIA",
        "Indirizzo": "VIA ALFREDO COTTRAU, 24",
        "N.ri Tel.": "081 8703474",
        "Insegna": "PAVIDAS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK01375-007378,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC11095-007110,26SBLDF01104-007441,26SBLDP01059-007441,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02069-007439,26SBLUH02284-007480,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "002316": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "50051",
        "Localit\u00e0": "CASTEL FIORENTINO",
        "Indirizzo": "VIA GARIBALDI, 40/42",
        "N.ri Tel.": "0571 61611",
        "Insegna": "PUCCI"
    },
    "007356": {
        "Stato": "ES",
        "CAP": "08026",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "C/ PUJADES 77-79, 1 2",
        "N.ri Tel.": "932657599",
        "Insegna": "PILAR Y ANDREA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02303-007440",
        "PRODUCT CODE KOOOMO": "26SBLUT02288-007479"
    },
    "000236": {
        "Stato": "IT",
        "CAP": "22079",
        "Localit\u00e0": "VILLAGUARDIA",
        "Indirizzo": "VIA VARESINA 15/17",
        "N.ri Tel.": "031/481494",
        "Insegna": "ADEMARK",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "006216": {
        "Stato": "IT",
        "CAP": "10136",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA TRIPOLI, 68",
        "N.ri Tel.": "011 3292512",
        "Insegna": "NEW SALOON JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958"
    },
    "014992": {
        "Stato": "IT",
        "CAP": "71010",
        "Localit\u00e0": "LESINA",
        "Indirizzo": "VIA RAFFAELE CENTONZA, 20",
        "N.ri Tel.": "0882 216709",
        "Insegna": "FRIZZI E LAZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,26SBLDC01219-007108,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC03169-007455,26SBLDC04460-007475,26SBLDC11099-007462,26SBLUA04463-007525,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUH02065-006526,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUL02445-007516,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUT02297-006801,26SBLUT02309-007132,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "017613": {
        "Stato": "IT",
        "CAP": "64010",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE ERITREA 70/D/E/F - AFRICANO",
        "N.ri Tel.": "O6 41734336",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355"
    },
    "021649": {
        "Stato": "RU",
        "CAP": "92016",
        "Localit\u00e0": "Wladyslawow",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047"
    },
    "019884": {
        "Stato": "ES",
        "CAP": "43001",
        "Localit\u00e0": "TARRAGONA",
        "Indirizzo": "CARRER UNIO 12",
        "N.ri Tel.": "977214201",
        "Insegna": "TACCO DISTANTE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02192-006648,25WBLDK03161-006719,25WBLDK11162-007110,26SBLDC01158-007131,26SBLDC01262-007101,26SBLDC02281-007476,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDF03056-007441,26SBLDH02407-007508,26SBLDH02425-007495,26SBLDK11147-007111,26SBLDP01059-007441,26SBLDP01259-007464,26SBLDP02260-007464,26SBLDP05058-007441,26SBLDP05326-007484,26SBLDS01255-007464,26SBLDS02400-007464,26SBLDV03258-007464,26SBLDV04396-007526,26SBLUH02287-007480,26SBLUH02305-007457,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLDC01158-007131"
    },
    "014958": {
        "Stato": "IT",
        "CAP": "000049",
        "Localit\u00e0": "VELLETRI",
        "Indirizzo": "VIALE BRUNO BUOZZI, 66/74",
        "N.ri Tel.": "06 963 3238",
        "Insegna": "ANTIDOTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355"
    },
    "012558": {
        "Stato": "IT",
        "CAP": "00054",
        "Localit\u00e0": "FIUMICINO",
        "Indirizzo": "VIA DELLA TORRE CLEMENTINA 158,",
        "N.ri Tel.": "06-6505059",
        "Insegna": "FRATELLI COTARDO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUL01316-007012,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUL02434-007520,26SBLUL02440-007522,26SBLUL02441-007515,26SBLUM01482-007167,26SBLUT02291-006803,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04118-007452"
    },
    "018384": {
        "Stato": "IT",
        "CAP": "90032",
        "Localit\u00e0": "BISACQUINO",
        "Indirizzo": "VIA DECANO DI VINCENTI, 82",
        "N.ri Tel.": "0918351214",
        "Insegna": "MC DOWELL",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,26SBLDC01136-007110,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC04192-007474,26SBLDP03353-007496,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02066-006526,26SBLUH02300-007439,26SBLUH02311-007132,26SBLUH05070-007439,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "014533": {
        "Stato": "IT",
        "CAP": "81030",
        "Localit\u00e0": "SANT'ARPINO",
        "Indirizzo": "VIA MARTIRI ATELLANI 169",
        "N.ri Tel.": "081-5011685",
        "Insegna": "KAOS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC11083-007110,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02541-007608,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "010006": {
        "Stato": "IT",
        "CAP": "20161",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA FONTANELLI, 2",
        "N.ri Tel.": "02/66220118",
        "Insegna": "ROBERTO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02173-007104,26SBLDC03169-007455,26SBLDF01104-007441,26SBLDH02411-005707,26SBLDP01059-007441,26SBLKX02365-005958,26SBLUC03177-006719,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUM01480-007167,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUX02184-005958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "000243": {
        "Stato": "IT",
        "CAP": "70056",
        "Localit\u00e0": "MOLFETTA",
        "Indirizzo": "VIA TENENTE FIORINO, 72/74",
        "N.ri Tel.": "080 3345701",
        "Insegna": "NOLUMA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480"
    },
    "002848": {
        "Stato": "IT",
        "CAP": "76125",
        "Localit\u00e0": "TRANI",
        "Indirizzo": "PIAZZA DELLA REPUBBLICA,60",
        "N.ri Tel.": "0883 506090",
        "Insegna": "NEW MULTIBRAND FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUA05300-006434,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUX02081-005958,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC11021-007111,26SBLUF01132-007448,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02121-007451,26SBLUH02283-007480,26SBLUL02441-007515,26SBLUM01471-007529,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUP02037-007441,26SBLUP05150-007448,26SBLUS01358-007499,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC03177-006719"
    },
    "018246": {
        "Stato": "IT",
        "CAP": "04022",
        "Localit\u00e0": "FONDI",
        "Indirizzo": "CORSO ITALIA, 30",
        "N.ri Tel.": "0773 709592",
        "Insegna": "SBARAGLIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUH02306-007440,26SBLUN02129-007447,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "020888": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "36013",
        "Localit\u00e0": "PIOVENE ROCCHETTE",
        "Indirizzo": "VIA GRUMELLO, 2",
        "N.ri Tel.": "0445-650721",
        "Insegna": "- "
    },
    "016520": {
        "Stato": "ES",
        "CAP": "20600",
        "Localit\u00e0": "EIBAR",
        "Indirizzo": "ZULOAGA 9",
        "N.ri Tel.": "943202833",
        "Insegna": "GUBY HOMBRE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01032-007441,26SBLUF02240-006804,26SBLUT02064-006526",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "017088": {
        "Stato": "IT",
        "CAP": "20146",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "PIAZZA FRATTINI ANG. VIA BARZILLAI 2",
        "Insegna": "DIANA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "019809": {
        "Stato": "IT",
        "CAP": "60019",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110"
    },
    "019880": {
        "Stato": "IT",
        "CAP": "08022",
        "Localit\u00e0": "DORGALI",
        "Indirizzo": "VIA LAMARMORA, 161",
        "N.ri Tel.": "078495318",
        "Insegna": "MARIPIE'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC11083-007110,26SBLKC01403-007462,26SBLKF03528-007557,26SBLKF08530-007557,26SBLKH02525-007558,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC11231-006787,26SBLUF03242-006804,26SBLUF03243-006804,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUM01477-006233,26SBLUM10478-006233,26SBLUT02289-007479,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "015394": {
        "Stato": "IT",
        "CAP": "03100",
        "Localit\u00e0": "FROSINONE",
        "Indirizzo": "VIA ARMANDO VONA, 20 - C.C. LE SORGENTI LIV.1",
        "Insegna": "AMORE CONCEPT STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUA04463-007525,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "012029": {
        "Stato": "ES",
        "CAP": "17230",
        "Localit\u00e0": "PALAMO, GIRONA",
        "Indirizzo": "PLAZA DE LOS ARBOLES 4,6",
        "N.ri Tel.": "972317128",
        "Insegna": "D'AVUI PALAMOS 4-6",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "000229": {
        "Stato": "IT",
        "CAP": "20162",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA VALFURVA, 3",
        "N.ri Tel.": "02 6437773",
        "Insegna": "GRIP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC11099-007462,26SBLDK11147-007111,26SBLDP05265-007474,26SBLUC02179-007104,26SBLUC02180-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "000389": {
        "Stato": "IT",
        "CAP": "84018",
        "Localit\u00e0": "SCAFATI",
        "Indirizzo": "VIA GEREMIA CAVALLARO, 87",
        "N.ri Tel.": "081 8505936",
        "Insegna": "TUFANO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUC01107-007101,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01107-007101"
    },
    "013579": {
        "Stato": "IT",
        "CAP": "91100",
        "Localit\u00e0": "TRAPANI",
        "Indirizzo": "VIA G.B. FARDELLA 356",
        "N.ri Tel.": "0923873536",
        "Insegna": "SPADA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02073-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02287-007480,26SBLUH02541-007608,26SBLUM06481-007167,26SBLUM08479-006233,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "018413": {
        "Stato": "IT",
        "CAP": "10141",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO PESCHIERA, 283/A",
        "N.ri Tel.": "011721220",
        "Insegna": "PRIMA ELEGANZA",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958"
    },
    "001201": {
        "Stato": "IT",
        "CAP": "81025",
        "Localit\u00e0": "AURNO MARCIANISE",
        "Indirizzo": "CENTRO COMMERCIALE CAMPANIA LOC.",
        "N.ri Tel.": "081 8694791",
        "Insegna": "GRILLO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC01215-007131,26SBLDC04077-007474,26SBLDC11095-007110,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02300-007439,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUP05244-006804,26SBLUT02064-006526,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUT02298-007440,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "009703": {
        "Stato": "IT",
        "CAP": "70024",
        "Localit\u00e0": "GRAVINA IN PUGLIA",
        "Indirizzo": "VIA RIMINI,1/3",
        "N.ri Tel.": "080-3258300",
        "Insegna": "MARTONE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02077-006943,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC11099-007462,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDP05326-007484,26SBLDV03258-007464,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11005-007123,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF03035-007441,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02313-005695,26SBLUH02347-007495,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUP01120-007452,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUP04334-007493,99CBLUP02001-007493,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000528": {
        "Stato": "IT",
        "CAP": "80010",
        "Localit\u00e0": "QUARTO",
        "Indirizzo": "CORSO ITALIA, 86/88",
        "N.ri Tel.": "081 8762784",
        "Insegna": "VISCONTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01098-007111,26SBLDC01215-007131,26SBLDC01218-007108,26SBLDC04077-007474,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "011366": {
        "Stato": "IT",
        "CAP": "84047",
        "Localit\u00e0": "CAPACCIO",
        "Indirizzo": "VIA ITALIA 61 168/N., CAPACCIO SCALO",
        "N.ri Tel.": "0828725516",
        "Insegna": "SORRENTINO S.RE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC11083-007110,26SBLDC02206-007459,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "004844": {
        "Stato": "ES",
        "CAP": "15705",
        "Localit\u00e0": "SANTIAGO DE COMPOSTELA",
        "Indirizzo": "C/ RUA DEL VILLAR, 11",
        "N.ri Tel.": "0034 98 1582331",
        "Insegna": "GARYSOM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,26SBLUB04119-007449,26SBLUC11005-007123,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUM06473-007528,26SBLUS02271-007501,26SBLUT02289-007479,26SBLUT02296-006801",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "022163": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "Winnenden",
        "Indirizzo": "Wallstrasse 30",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047"
    },
    "013135": {
        "Stato": "IT",
        "CAP": "18100",
        "Localit\u00e0": "IMPERIA",
        "Indirizzo": "VIA DELLA REPUBBLICA, 25",
        "N.ri Tel.": "0183-681239",
        "Insegna": "LEO JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC03086-006047,25WBLUC03090-006719"
    },
    "016511": {
        "Stato": "ES",
        "CAP": "25300",
        "Localit\u00e0": "TARREGA",
        "Indirizzo": "PLAZA DEL CARMEN,15",
        "N.ri Tel.": "+34973310556",
        "Insegna": "MODA DAIC",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDF08236-007301,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDF01104-007441,26SBLDF08323-007484,26SBLDH03328-007483,26SBLDK04249-007474,26SBLDP01259-007464,26SBLDP05326-007484,26SBLDS02400-007464,26SBLDV03258-007464,26SBLUF03044-007465,26SBLUH02235-007457,26SBLUH02310-007132,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "004855": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "CALLE SANT AUGUSTIN 1",
        "N.ri Tel.": "0034 987 273398",
        "Insegna": "LEIKO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUH02246-007457,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUH02314-005695,26SBLUL02436-007520,26SBLUL02439-007521,26SBLUT02064-006526,26SBLUT02289-007479,26SBLUT02295-006801,26SBLUT02296-006801",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "014362": {
        "Stato": "IT",
        "CAP": "06089",
        "Localit\u00e0": "TORGIANO",
        "Indirizzo": "VIA VIRGILIO MARONE 47",
        "N.ri Tel.": "075 9888182",
        "Insegna": "FAUSTO MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDK11145-007110,26SBLUB01024-007111,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "008957": {
        "Stato": "IT",
        "CAP": "86100",
        "Localit\u00e0": "CAMPOBASSO",
        "Indirizzo": "VIA VITTORIO VENETO, 76",
        "N.ri Tel.": "0874.65273",
        "Insegna": "IAVERONE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDC03357-007294,25WBLDF08236-007301,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLDP01291-007324,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC02170-006648,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC11099-007462,26SBLDF08057-007441,26SBLDP01059-007441,26SBLUC03197-006719,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03243-006804,26SBLUH02302-007439,26SBLUM01477-006233,26SBLUP01245-006804,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "018854": {
        "Stato": "IT",
        "CAP": "97019",
        "Localit\u00e0": "VITTORIA",
        "Indirizzo": "VIA NINO BIXIO 119",
        "Insegna": "TARGET BOY & TEEN",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,25WBLKC11416-007110"
    },
    "015927": {
        "Stato": "IT",
        "CAP": "76011",
        "Localit\u00e0": "BISCEGLIE",
        "Indirizzo": "LARGO CANONICO PASQUALE UVA, 6",
        "N.ri Tel.": "380-3876995",
        "Insegna": "JEK.PIT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUX02081-005958,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC03169-007455,26SBLDX02171-006648,26SBLUC01229-007108,26SBLUC11005-007123,26SBLUF02034-007441,26SBLUH02011-007149,26SBLUL02439-007521,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUL02445-007516,26SBLUP02037-007441,26SBLUP04017-007458,26SBLUS02271-007501,26SBLUX02084-007454,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "023579": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "CORSO MAZZINI, 199/201",
        "Insegna": "CONTAINER UOMO"
    },
    "015098": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "CIRCUMVALLAZIONE ESTERNA, C.DA LOCATELLI",
        "N.ri Tel.": "081.7372902",
        "Insegna": "ALICE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "013310": {
        "Stato": "IT",
        "CAP": "80027",
        "Localit\u00e0": "FRATTAMAGGIORE",
        "Indirizzo": "CORSO FRANCESCO DURANTE, 49",
        "N.ri Tel.": "081/8314945",
        "Insegna": "LES AMIES",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03527-006047"
    },
    "000400": {
        "Stato": "IT",
        "CAP": "70029",
        "Localit\u00e0": "SANTERAMO",
        "Indirizzo": "PIAZZA DI VAGNO, 27",
        "N.ri Tel.": "080 3036585",
        "Insegna": "BOUTIQUE LA SALA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03173-007307,25WBLDK03098-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,26SBLDC01219-007108,26SBLDC03169-007455,26SBLDH02327-007483,26SBLDH02415-007507,26SBLDP05058-007441,26SBLDP05326-007484,26SBLUC03177-006719,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02065-006526,26SBLUH02541-007608,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP04334-007493,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "018745": {
        "Stato": "IT",
        "CAP": "95030",
        "Localit\u00e0": "GRAVINA DI CATANIA",
        "Indirizzo": "VIA CADUTI DEL LAVORO, 2",
        "Insegna": "LUXURY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDP01291-007324,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01136-007110,26SBLDC01215-007131,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC04077-007474,26SBLDC04192-007474,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDP01059-007441,26SBLGC02380-006648,26SBLGC02385-007459,26SBLGC03410-007455,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKF03529-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLUA04463-007525,26SBLUC01106-007101,26SBLUC01107-007101,26SBLUC02207-007459,26SBLUC04109-007473,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02066-006526,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUM06472-007529,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02297-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "016448": {
        "Stato": "ES",
        "CAP": "22002",
        "Localit\u00e0": "HUESCA",
        "Indirizzo": "PLAZA NAVARRA 7",
        "N.ri Tel.": "+34 974210707",
        "Insegna": "MIRATE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLUC03074-006355,25WBLUK11140-007286,26SBLDC03168-007455,26SBLDC04077-007474,26SBLDH02211-007439,26SBLDH02418-006845,26SBLDH03328-007483,26SBLDP01279-007475,26SBLDP05265-007474,26SBLDP05326-007484,26SBLDS02355-007502,26SBLUB04040-006788,26SBLUB04226-007124,26SBLUC04131-007449,26SBLUC11113-006787,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03242-006804,26SBLUH02246-007457,26SBLUH02299-007439,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUH02312-007132,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02304-007481",
        "PRODUCT CODE KOOOMO": "26SBLDC03168-007455"
    },
    "015041": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- "
    },
    "015271": {
        "Stato": "IT",
        "CAP": "09040",
        "Localit\u00e0": "SENORBA",
        "Indirizzo": "VIA CARLO SANNA , 65",
        "N.ri Tel.": "0709809467",
        "Insegna": "ALMAX",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUL01316-007012,26SBLDC01220-007108,26SBLDC02173-007104,26SBLDC04460-007475,26SBLUB01024-007111,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "014051": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "16030",
        "Localit\u00e0": "GATTORNA DI MOCONESI",
        "Indirizzo": "VIA DEL COMMERCIO, 75",
        "N.ri Tel.": "0185 935014",
        "Insegna": "LA FRANCHEZZA"
    },
    "007396": {
        "Stato": "IT",
        "CAP": "65122",
        "Localit\u00e0": "PESCARA",
        "Indirizzo": "VIA ROMA, 57",
        "N.ri Tel.": "085 4216341",
        "Insegna": "MONDOVELA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK05019-007298,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC11416-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDK11145-007110,26SBLDK11147-007111,26SBLDL02448-007521,26SBLDL02449-007522,26SBLDP01059-007441,26SBLGC01390-007131,26SBLGC02377-007104,26SBLKC01369-007101,26SBLKC02366-007104,26SBLKC06372-007101,26SBLKF02516-007557,26SBLKF02527-007557,26SBLKF03517-007557,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02513-007558,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUN01432-006581,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP03329-007494,26SBLUP04036-007441,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02298-007440,26SBLUT02321-007481,26SBLUX02184-005958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "014129": {
        "Stato": "ES",
        "CAP": "17002",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "C/GRAN VIA JAUME I, N\u00b061",
        "N.ri Tel.": "972 29 71 50",
        "Insegna": "ONIX",
        "CODICE PRODOTTO KOOOMO": "25WBLDL01346-007354,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDP01395-007524,26SBLUC04110-007473,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02314-005695,26SBLUM06473-007528,26SBLUT02288-007479",
        "PRODUCT CODE KOOOMO": "26SBLDP01395-007524"
    },
    "013355": {
        "Stato": "IT",
        "CAP": "70122",
        "Localit\u00e0": "BARI",
        "Indirizzo": "PIAZZA ALDO MORO 53,",
        "N.ri Tel.": "080/5212290",
        "Insegna": "FERRANDES",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDH02211-007439,26SBLDH02327-007483,26SBLDH02411-005707,26SBLDH02414-005707,26SBLDH02415-007507,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUP04334-007493,26SBLUS01126-007453,26SBLUS02271-007501,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02304-007481,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "021478": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLUC02079-A05958",
        "Stato": "IT",
        "CAP": "62014",
        "Localit\u00e0": "TORREANO DI MARTIGNACCO",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "620885870",
        "Insegna": "- "
    },
    "001088": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110",
        "Stato": "IT",
        "CAP": "80132",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA TOLEDO, 9",
        "N.ri Tel.": "081 4201190",
        "Insegna": "- "
    },
    "021593": {
        "CODICE PRODOTTO KOOOMO": "26SBLUC01106-007101,26SBLUC11018-007110,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02541-007608,26SBLUP02037-007441,26SBLUS04360-007499",
        "Stato": "IT",
        "CAP": "81025",
        "Localit\u00e0": "NOLA",
        "Indirizzo": "VIA GENOVA, 47",
        "N.ri Tel.": "0810146650",
        "Insegna": "SORECA",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "014063": {
        "Stato": "IT",
        "CAP": "71017",
        "Localit\u00e0": "TORREMAGGIORE",
        "Indirizzo": "CORSO MATTEOTTI, 143",
        "N.ri Tel.": "0882 386268",
        "Insegna": "LONGO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLUC02079-005958"
    },
    "021686": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01219-007108,26SBLDC02176-006648,26SBLDC02194-007476,26SBLDC02206-007459,26SBLDC03168-007455,26SBLDC11099-007462,26SBLDF01114-006804,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDH02415-007507,26SBLDP01116-006804,26SBLUC02207-007459,26SBLUF01032-007441,26SBLUH02121-007451,26SBLUH02237-007439,26SBLUL02445-007516,26SBLUM06481-007167,26SBLUP02037-007441,26SBLUP04332-007493,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "LEPORANO",
        "Indirizzo": "VIA PORTA TARANTO, 40",
        "N.ri Tel.": "099- 5316143",
        "Insegna": "FERRANTINO",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "004820": {
        "Stato": "ES",
        "CAP": "17800",
        "Localit\u00e0": "OLOT",
        "Indirizzo": "C/ RECTOR FERRER, 11",
        "N.ri Tel.": "0034 972453416",
        "Insegna": "ANA AULY SUNYEV",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK01376-007378,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01136-007110,26SBLDC01215-007131,26SBLDC01220-007108,26SBLDC04077-007474,26SBLDC04192-007474,26SBLDC11095-007110,26SBLDF08057-007441,26SBLDH02327-007483,26SBLDH03222-007460,26SBLDH03328-007483,26SBLDH03413-005707,26SBLDK04249-007474,26SBLDL02447-007523,26SBLDS02400-007464,26SBLDV03258-007464,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUB04040-006788,26SBLUB04119-007449,26SBLUC01022-007110,26SBLUC11005-007123,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02011-007149,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUT02064-006526,26SBLUT02304-007481",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "000128": {
        "CODICE PRODOTTO KOOOMO": "26SBLUF03149-007448,26SBLUP01133-007448,26SBLUP05150-007448",
        "Stato": "IT",
        "CAP": "27050",
        "Localit\u00e0": "GADESCO PIEVE DELMONA",
        "Indirizzo": "VIA RIVO BRIGNOLO, 2/6",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLUF03149-007448"
    },
    "003298": {
        "Stato": "IT",
        "CAP": "80059",
        "Localit\u00e0": "TORRE DEL GRECO",
        "Indirizzo": "VIA SALVATOR NOTO, 41/43/45",
        "N.ri Tel.": "081 8828144",
        "Insegna": "NOVECENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,26SBLDC02206-007459,26SBLDC04192-007474,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "018379": {
        "Stato": "IT",
        "CAP": "71042",
        "Localit\u00e0": "CERIGNOLA",
        "Indirizzo": "CORSO ALDO MORO 67/69",
        "N.ri Tel.": "0885 414821",
        "Insegna": "NEW TREND",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK03098-006047,25WBLUA05298-006127"
    },
    "017869": {
        "Stato": "IT",
        "CAP": "38010",
        "Localit\u00e0": "ANDALO",
        "Indirizzo": "VIALE TRENTO 7",
        "N.ri Tel.": "046-589003",
        "Insegna": "BOTTAMEDI SPORT ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03101-006047,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC11099-007462,26SBLDH02412-005707,26SBLDK11147-007111,26SBLDS02355-007501,26SBLUC03177-006719,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "019465": {
        "Stato": "IT",
        "CAP": "16011",
        "Localit\u00e0": "ARENZANO",
        "Indirizzo": "VIA GHIGLINI EDOARDO 54/56 RR",
        "N.ri Tel.": "0109126791",
        "Insegna": "FANTASIE DEL BORGO",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBBXC02422-005958,26SBLGC01402-007111,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKC06372-007101,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKF08515-007557,26SBLKH02512-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP01520-007557,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXC02422-005958"
    },
    "020906": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC01262-007101,26SBLDC11099-007462,26SBLDK11147-007111,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUX02184-005958",
        "Stato": "IT",
        "CAP": "33073",
        "Localit\u00e0": "URGNANO",
        "Indirizzo": "VIALE VENEZIA, 86 INT.1",
        "N.ri Tel.": "0434 565499",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "007294": {
        "Stato": "IT",
        "CAP": "10059",
        "Localit\u00e0": "SUSA",
        "Indirizzo": "VIA ROMA, 15",
        "N.ri Tel.": "0122 622818",
        "Insegna": "DA CASTAGNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDL01340-007355,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUC02207-007459,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUP02037-007441,26SBLUP05244-006804,26SBLUT02064-006526,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "002970": {
        "Stato": "IT",
        "CAP": "53100",
        "Localit\u00e0": "SIENA",
        "Indirizzo": "STRADA MASSETANA ROMANA, 54",
        "N.ri Tel.": "0577 283927",
        "Insegna": "GHN",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUK03142-005480,25WBLUX02081-005958"
    },
    "008806": {
        "Stato": "IT",
        "CAP": "16121",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA ROMA, 34/R",
        "Insegna": "BLAUER STORE GENOVA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDL01340-007355,25WBLDM01463-007330,25WBLUA05297-006127,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01098-007111,26SBLDC01136-007110,26SBLDC01217-007108,26SBLDC02173-007104,26SBLDC03165-007455,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDC04192-007474,26SBLDC04275-007475,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDF01114-006804,26SBLDF01322-007484,26SBLDF03115-006804,26SBLDF08057-007441,26SBLDH02407-007508,26SBLDH02411-005707,26SBLDH02414-005707,26SBLDH02415-007507,26SBLDH02418-006845,26SBLDH03222-007460,26SBLDH03413-005707,26SBLDK04249-007474,26SBLDK11147-007111,26SBLDL02447-007520,26SBLDL02536-007515,26SBLDM01486-007530,26SBLDM01488-007532,26SBLDM02484-007531,26SBLDP01116-006804,26SBLDP01276-007474,26SBLDP01279-007475,26SBLDP01395-007524,26SBLDP02278-007475,26SBLDP02399-007524,26SBLDP03351-007496,26SBLDP03352-007496,26SBLDP03353-007496,26SBLDP05117-006804,26SBLDP05265-007474,26SBLDS02400-007464,26SBLDS04343-007506,26SBLDS04392-007506,26SBLDT02086-006526,26SBLDV01339-007526,26SBLDV02341-007526,26SBLDV03258-007464,26SBLDX03166-007455,26SBLUA04463-007525,26SBLUA04468-007527,26SBLUB04119-007449,26SBLUC01043-007120,26SBLUC01108-007101,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01045-007465,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUF08140-007448,26SBLUH02121-007451,26SBLUH02235-007457,26SBLUH02246-007457,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUH02314-005695,26SBLUL02435-007520,26SBLUL02437-007156,26SBLUL02439-007521,26SBLUM01480-007167,26SBLUM06481-007167,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01128-007453,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUT02307-007132,26SBLUX03232-006719,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "000181": {
        "Stato": "IT",
        "CAP": "56025",
        "Localit\u00e0": "PONTEDERA",
        "Indirizzo": "CORSO MATTEOTTI, 8",
        "N.ri Tel.": "0587 52735",
        "Insegna": "CARNABY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC11021-007111,26SBLUH02237-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUT02291-006803,26SBLUT02307-007132,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "008187": {
        "Stato": "IT",
        "CAP": "00054",
        "Localit\u00e0": "FIUMICINO",
        "Indirizzo": "VIA G.MONTANARI SN",
        "N.ri Tel.": "0665489651",
        "Insegna": "AMORE E SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340"
    },
    "020912": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "SM",
        "CAP": "98100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA SANTA LUCIA, 3",
        "N.ri Tel.": "320/9306958",
        "Insegna": "- "
    },
    "001152": {
        "Stato": "IT",
        "CAP": "98044",
        "Localit\u00e0": "SAN FILIPPO DEL MELA",
        "Indirizzo": "CONTRADA MASSERIA CORRIOLO",
        "N.ri Tel.": "090 931525",
        "Insegna": "CALCAGNO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01136-007110,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLUC02179-007104,26SBLUC02182-005958,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUF03035-007441,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "014341": {
        "Stato": "IT",
        "CAP": "73043",
        "Localit\u00e0": "COPERTINO",
        "Indirizzo": "VIA MARIANO ANGOLO VIA BATTISTI SNC",
        "N.ri Tel.": " 0832932939",
        "Insegna": "GYF",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC03167-007455,26SBLDH02411-005707,26SBLDH02416-007507,26SBLDH02418-006845,26SBLDV01339-007526,26SBLUC01106-007101,26SBLUC04201-007124,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUL02442-007515,26SBLUP02336-007493,26SBLUP05244-006804,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "015054": {
        "Stato": "IT",
        "CAP": "74121",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA C.BATTISTI ANG. VICO S.GIO, 55/A",
        "N.ri Tel.": "099 4774653",
        "Insegna": "MALIZIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK01376-007378,25WBLDK03098-006047,25WBLDM01463-007330,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDC04460-007475,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDH02412-005707,26SBLDH02416-007507,26SBLDP01059-007441,26SBLDV01339-007526,26SBLUB04119-007449,26SBLUB11112-006787,26SBLUC03177-006719,26SBLUC11005-007123,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF01045-007465,26SBLUF02014-007121,26SBLUH02012-007149,26SBLUH02237-007439,26SBLUH02272-007478,26SBLUH02301-007439,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUL02441-007515,26SBLUM01480-007167,26SBLUP03350-007496,26SBLUP04016-007121,26SBLUP04017-007458,26SBLUP04048-007465,26SBLUP04332-007493,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02304-007481,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "022123": {
        "Stato": "IT",
        "CAP": "48011",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "944 154 925",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02196-007283"
    },
    "006140": {
        "Stato": "IT",
        "CAP": "22029",
        "Localit\u00e0": "UGGIATE TREVANO",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 2",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,26SBLDC01218-007108,26SBLDC02173-007104,26SBLUC01199-007108,26SBLUC01229-007108,26SBLUC02179-007104,26SBLUC11071-007462,26SBLUF03242-006804,26SBLUH02287-007480",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "000912": {
        "Stato": "IT",
        "CAP": "74100",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA F. DI PALMA, 107",
        "N.ri Tel.": "099 4590127",
        "Insegna": "ANDRIANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC02206-007459,26SBLDC04077-007474,26SBLUB04119-007449,26SBLUC02180-007104,26SBLUC04131-007449,26SBLUC11005-007123,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "019515": {
        "Stato": "IT",
        "CAP": "55100",
        "Localit\u00e0": "LUCCA",
        "Indirizzo": "PIAZZA DELL'ARANCIO 29",
        "N.ri Tel.": "0583494107",
        "Insegna": "GIROTONDO",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBLKC02429-005958,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLKH02523-007558"
    },
    "002376": {
        "Stato": "IT",
        "CAP": "74122",
        "Localit\u00e0": "TALSANO",
        "Indirizzo": "CORSO VITTORIO EMANUELE II, 184/A",
        "N.ri Tel.": "099 7310544",
        "Insegna": "LINEA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLKA05458-006127,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02077-006943,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,26SBLUC01199-007108,26SBLUC02207-007459,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUM01482-007167,26SBLUP02037-007441,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS01358-007499,26SBLUT02309-007132,26SBLUX02184-005958,99CBLUP04003-007493,99CBLUP04004-007493",
        "PRODUCT CODE KOOOMO": "26SBLUC01199-007108"
    },
    "009567": {
        "Stato": "IT",
        "CAP": "40053",
        "Localit\u00e0": "BAZZANO",
        "Indirizzo": "VIA G. MATTEOTTI, 23",
        "N.ri Tel.": "051 830638",
        "Insegna": "LORENZO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03233-007308,26SBLUB04040-006788,26SBLUB04119-007449,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04040-006788"
    },
    "021049": {
        "Stato": "IT",
        "CAP": "10078",
        "Localit\u00e0": "VENARIA REALE",
        "Indirizzo": "VIA ANDREA MENSA,16/B",
        "N.ri Tel.": "011/4598972",
        "Insegna": "ROYAL",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03161-006719,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01158-007131,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDF08057-007441,26SBLDK11147-007111,26SBLDM02484-007531,26SBLDP01059-007441,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUF02240-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUL02440-007522,26SBLUT02293-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01158-007131"
    },
    "001480": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03495-006047,25WBLUC02079-005958,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "16129",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA SAN VINCENZO, 7R",
        "N.ri Tel.": "010 561026",
        "Insegna": "TESSILMODA"
    },
    "012009": {
        "Stato": "ES",
        "CAP": "15701",
        "Localit\u00e0": "SANTIAGO DE COMPOSTELA",
        "Indirizzo": "GENERAL PARDI\u00d1AS 40 BJ",
        "N.ri Tel.": "981593886",
        "Insegna": "FRISEE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03161-006719,25WBLDK11162-007110,26SBLDC01134-007131,26SBLDC01215-007131,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDC04192-007474,26SBLDC04275-007475,26SBLDK04249-007474,26SBLDK11147-007111,99CBLDA09007-007795",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "018040": {
        "Stato": "IT",
        "CAP": "12100",
        "Localit\u00e0": "CUNEO",
        "Indirizzo": "CORSO GIOLITTI, 17",
        "N.ri Tel.": "3470060821",
        "Insegna": "CERUTTI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUF02240-006804,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "018911": {
        "Stato": "IT",
        "CAP": "80063",
        "Localit\u00e0": "PIANO DI SORRENTO",
        "Indirizzo": "CORSO ITALIA 170",
        "N.ri Tel.": "0810201952",
        "Insegna": "METRO STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC03400-007308,26SBLGF02507-007557,26SBLGF03506-007557,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP01509-007557,26SBLGP05508-007557,26SBLKF03517-007557,26SBLKF08518-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGF02507-007557"
    },
    "000353": {
        "Stato": "IT",
        "CAP": "20094",
        "Localit\u00e0": "CORSICO",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 2",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLKC02429-005958,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC11095-007110,26SBLUC11028-007462",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "023443": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "73018",
        "Localit\u00e0": "VILAGARCIA DE AROUSA, PONTEVEDRA",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "986505893",
        "Insegna": "- "
    },
    "019983": {
        "Stato": "IT",
        "CAP": "000124",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA RAVEL MAURICE, 408",
        "N.ri Tel.": "3933127023",
        "Insegna": "LE COSE DI......",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC03074-006355,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC03168-007455,26SBLDC04268-007475,26SBLDC11099-007462,26SBLDK11147-007111,26SBLDV05282-007475,26SBLUA04463-007525,26SBLUA04467-007527,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH02284-007480,26SBLUH02299-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "018278": {
        "Stato": "IT",
        "CAP": "63082",
        "Localit\u00e0": "CASTEL DI LAMA",
        "Indirizzo": "VIA SALARIA, 178",
        "N.ri Tel.": "0736 813814",
        "Insegna": "SNOOPY",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,26SBBXC02422-005958,26SBLGC01389-007111,26SBLGC02377-007104,26SBLGC02380-006648,26SBLKC02364-005958,26SBLKC06372-007101,26SBLKF02516-007557,26SBLKF02527-007557,26SBLKH02511-007558,26SBLKP05531-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBBXC02422-005958"
    },
    "000557": {
        "Stato": "IT",
        "CAP": "20038",
        "Localit\u00e0": "SEREGNO",
        "Indirizzo": "LARGO SAN VITTORE, 27 Ang Via Cavour",
        "N.ri Tel.": "0362 220788",
        "Insegna": "CLAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC11083-007110,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUT02288-007479,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "018968": {
        "Stato": "IT",
        "CAP": "98028",
        "Localit\u00e0": "SANTA TERESA DI RIVA",
        "Indirizzo": "VIA REGINA MARGHERITA, 25",
        "N.ri Tel.": "09-42794803",
        "Insegna": "BRETELLA LAB",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLGA05461-007349,25WBLGC02391-006648,25WBLKA05458-006127,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC02206-007459,26SBLDC04192-007474,26SBLDH02411-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLGC01390-007131,26SBLGC02385-007459,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKC01403-007462,26SBLKC11401-007111,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02523-007558,26SBLKP05519-007557,26SBLUA04463-007525,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP02037-007441,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "023514": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "VA",
        "CAP": "96103",
        "Localit\u00e0": "Wien",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "943 74 41 99",
        "Insegna": "- "
    },
    "014008": {
        "Stato": "IT",
        "CAP": "10147",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA CHIESA DELLA SALUTE 26/BIS,",
        "N.ri Tel.": "011/2217753",
        "Insegna": "PIAZZETTA 26",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03090-006719,25WBLUC11083-007110,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03167-007455,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "014441": {
        "Stato": "IT",
        "CAP": "85021",
        "Localit\u00e0": "AVIGLIANO",
        "Indirizzo": "VIA ROMA 181",
        "N.ri Tel.": "0971/700712",
        "Insegna": "VIA ROMA 181 ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC02174-006648,26SBLDC02206-007459,26SBLDH02411-005707,26SBLDH02414-005707,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUF01239-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUP03350-007496,26SBLUT02293-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "015283": {
        "Stato": "DE",
        "CAP": "77933",
        "Localit\u00e0": "LAHR",
        "Indirizzo": "VORDERE MAUERGASSE 7",
        "N.ri Tel.": "0049 784121474",
        "Insegna": "Feldm\u00fcller - Fank",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC03090-006719"
    },
    "018125": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "347 7006858",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958"
    },
    "022656": {
        "Stato": "IT",
        "CAP": "96012",
        "Localit\u00e0": "TERMINI IMERESE",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02077-006943"
    },
    "012553": {
        "Stato": "IT",
        "CAP": "88900",
        "Localit\u00e0": "CROTONE",
        "Indirizzo": "VIA VITTORIO VENETO 30,",
        "N.ri Tel.": "096228488",
        "Insegna": "BLAUER STORE CROTONE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08248-006948,25WBLDK01375-007378,25WBLDK01376-007378,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDL01340-007355,25WBLDP01291-007324,25WBLDP01295-007323,25WBLGC02391-006648,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC01217-007108,26SBLDC01219-007108,26SBLDC01262-007101,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC04192-007474,26SBLDH02211-007439,26SBLDH02407-007508,26SBLDH02408-007508,26SBLDH02414-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDH02417-006845,26SBLDH02418-006845,26SBLDH03224-007460,26SBLDH03413-005707,26SBLDK04249-007474,26SBLDK11147-007111,26SBLDL02449-007522,26SBLDL02451-007156,26SBLDL02536-007515,26SBLDM01486-007530,26SBLDM02485-007530,26SBLDP01394-007505,26SBLDP01395-007524,26SBLDP02399-007524,26SBLDP03351-007496,26SBLDP03352-007496,26SBLDP03353-007496,26SBLDP04500-007526,26SBLDS01345-007506,26SBLDV01339-007526,26SBLDV04396-007526,26SBLKC01370-007101,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKC02542-007459,26SBLKC06372-007101,26SBLKC11401-007111,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKF03529-007557,26SBLKF08530-007557,26SBLKH02512-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKN02491-007542,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKT02431-007440,26SBLKX02365-005958,26SBLUA04463-007525,26SBLUC01022-007110,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11113-006787,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUF03243-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUH02314-005695,26SBLUH02541-007608,26SBLUL02434-007520,26SBLUL02435-007520,26SBLUL02436-007520,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUM06472-007529,26SBLUM06473-007528,26SBLUM06481-007167,26SBLUM08479-006233,26SBLUN01432-006581,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUN02537-007542,26SBLUP01245-006804,26SBLUP01331-007493,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUP05362-007504,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUT02307-007132,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "004761": {
        "Stato": "ES",
        "CAP": "39003",
        "Localit\u00e0": "Santander",
        "Indirizzo": "Plaza Principe, 3",
        "N.ri Tel.": "942312975",
        "Insegna": "GOLF",
        "CODICE PRODOTTO KOOOMO": "25WBLUK11140-007286,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUL02436-007520",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "000798": {
        "Stato": "IT",
        "CAP": "10122",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GARIBALDI, 5/D",
        "N.ri Tel.": "011 4361543",
        "Insegna": "BLOB",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC03074-006355"
    },
    "007912": {
        "Stato": "IT",
        "CAP": "16012",
        "Localit\u00e0": "BUSALLA",
        "Indirizzo": "PIAZZA E.MACCIO', 17",
        "N.ri Tel.": "010 9643812",
        "Insegna": "PASTORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "002301": {
        "Stato": "IT",
        "CAP": "81031",
        "Localit\u00e0": "AVERSA",
        "Indirizzo": "VIA ROMA, 161",
        "N.ri Tel.": "081 8111689",
        "Insegna": "ARIANO BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC11018-007110,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "014389": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "VILLA D'AGRI DI MARSICOVETERE",
        "Indirizzo": "VIA NAZIONALE 21",
        "N.ri Tel.": "0975 354447",
        "Insegna": "COIRO FASHION TIME",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02176-006648,26SBLDC03167-007455,26SBLDC03169-007455,26SBLUB04093-007461,26SBLUC02182-005958,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC11028-007462,26SBLUH02065-006526,26SBLUH02302-007439,26SBLUP03329-007496,26SBLUP04334-007493,26SBLUT02064-006526,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "023045": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDK02069-006648,25WBLDK02192-006648,25WBLDK03101-006047",
        "Stato": "ES",
        "CAP": "89081",
        "Localit\u00e0": "Ulm",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "945150305",
        "Insegna": "- "
    },
    "009471": {
        "Stato": "IT",
        "CAP": "70051",
        "Localit\u00e0": "BARLETTA",
        "Indirizzo": "VIA MADONNA DELLA CROCE, 38",
        "N.ri Tel.": "0883 881017",
        "Insegna": "I MONELLI",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBLGC01389-007111,26SBLGC02380-006648,26SBLGF03506-007557,26SBLGH02501-007558,26SBLKC02366-007104,26SBLKF02516-007557,26SBLKF08515-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "008424": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "RACALMUTO",
        "Indirizzo": "VIA ALDO MORO, 26",
        "N.ri Tel.": "338 3234106",
        "Insegna": "PALUMBO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03099-006047,25WBLDK01376-007378,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUA05301-006434,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUL01316-007012,26SBLDC01098-007111,26SBLDC01217-007108,26SBLDC02174-006648,26SBLDC04192-007474,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC01107-007101,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUN01432-006581,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01331-007493,26SBLUP03329-007494,26SBLUP03350-007496,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02293-006801,99CBLUP01002-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "001061": {
        "Stato": "IT",
        "CAP": "71100",
        "Localit\u00e0": "FOGGIA",
        "Indirizzo": "PIAZZA CAVOUR, 9",
        "N.ri Tel.": "0881-587803",
        "Insegna": "SIMONE COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05298-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUA04463-007525,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02238-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUS02271-007501,26SBLUS02271-007502,26SBLUT02289-007479,26SBLUT02295-006801,26SBLUT02296-006801,26SBLUX02184-005958,26SBLUX02184-A05958",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "015311": {
        "Stato": "CZ",
        "CAP": "549 00",
        "Localit\u00e0": "Nachod",
        "Indirizzo": "Okruzni 334",
        "N.ri Tel.": "420606606700",
        "Insegna": "Fashion store",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02170-006648,25WBLDC03096-006047,25WBLDF08248-006948,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03161-006719,25WBLUA05298-006127,25WBLUA05301-006434,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK11140-007286"
    },
    "020896": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "12045",
        "Localit\u00e0": "FOSSANO",
        "Indirizzo": "VIA GUGLIELMO MARCONI , 15",
        "Insegna": "- "
    },
    "018811": {
        "Stato": "IT",
        "CAP": "06024",
        "Localit\u00e0": "GUBBIO",
        "Indirizzo": "VIA BENIAMINO UBALDI, 21",
        "N.ri Tel.": "075 927 6333",
        "Insegna": "ACCIAIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUF01239-006804,26SBLUH02299-007439,26SBLUM01477-006233,26SBLUP01245-006804,26SBLUS01358-007499,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "016024": {
        "Stato": "IT",
        "CAP": "80036",
        "Localit\u00e0": "PALMA CAMPANIA",
        "Indirizzo": "NUOVA SARNO, 111",
        "N.ri Tel.": "081-5103836",
        "Insegna": "SORRENTINO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBBXC01420-007111,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC11095-007110,26SBLGC01389-007111,26SBLGC01402-007111,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKC11401-007111,26SBLKC11423-007110,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKP05519-007557,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUP04036-007441,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "020626": {
        "Stato": "IT",
        "CAP": "10040",
        "Localit\u00e0": "LEINI'",
        "Indirizzo": "VIA CASELLE, 74",
        "N.ri Tel.": "376 0139225",
        "Insegna": "TRENDY",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02212-007439,26SBLDH03224-007460,26SBLDP01059-007441,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUP01245-006804,26SBLUP03350-007496,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDF03056-007441"
    },
    "018759": {
        "Stato": "IT",
        "CAP": "81058",
        "Localit\u00e0": "VAIRANO PATENORA",
        "Indirizzo": "PIAZZA UNITA' D'ITALIA 9",
        "N.ri Tel.": "0823 988924",
        "Insegna": "CLOTHES LIFE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUK03142-005480,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02541-007608,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "013266": {
        "Stato": "IT",
        "CAP": "46100",
        "Localit\u00e0": "MANTOVA",
        "Indirizzo": "VIA VERDI, 18",
        "N.ri Tel.": "0376/362153",
        "Insegna": "TELAIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUN02129-007447,26SBLUP04334-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "004800": {
        "Stato": "ES",
        "CAP": "08401",
        "Localit\u00e0": "GRANOLLERS ESPANA",
        "Indirizzo": "CALLE SANTA ANA NUM 15",
        "N.ri Tel.": "0034 938708353",
        "Insegna": "AFRICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01098-007111,26SBLDC04460-007475,26SBLDL02536-007515,26SBLDP01398-007526,26SBLDP02278-007475,26SBLDP02399-007524,26SBLDT02087-006526,26SBLUC04201-007124,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUM06481-007167,26SBLUT02288-007479,26SBLUT02296-006801,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "022235": {
        "Stato": "SK",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "Zilina",
        "Indirizzo": "WILHELMSTRASSE 1-5",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648"
    },
    "021243": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "91011",
        "Localit\u00e0": "Vielha, Lerida",
        "Indirizzo": "carretera de gausac 30",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "008560": {
        "Stato": "IT",
        "CAP": "23100",
        "Localit\u00e0": "SONDRIO",
        "Indirizzo": "VIA CESURA, 15",
        "N.ri Tel.": "0342 517756",
        "Insegna": "PAOLO CURTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUA05297-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC11099-007462,26SBLDH02411-005707,26SBLDL02534-007521,26SBLUB04119-007449,26SBLUC01106-007101,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUF03243-006804,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02300-007439,26SBLUL02441-007515,26SBLUP01245-006804,26SBLUP03350-007496,26SBLUT02288-007479,26SBLUT02293-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "018526": {
        "Stato": "IT",
        "CAP": "28921",
        "Localit\u00e0": "VERBANIA",
        "Indirizzo": "VIA BAIETTINI, 75",
        "N.ri Tel.": "0323/405482",
        "Insegna": "BULLI E PUPE",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBLGC02385-007459,26SBLGF02507-007557,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKC02542-007459,26SBLKF03529-007557,26SBLKF08515-007557,26SBLKH02512-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05526-007557,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC02385-007459"
    },
    "016410": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02151-007287,25WBLUC03090-006719",
        "Stato": "DE",
        "CAP": "71634",
        "Localit\u00e0": "LUDWIGSBURG",
        "Indirizzo": "KOERNERSTRASSE 17",
        "N.ri Tel.": "07141 911291",
        "Insegna": "HOMERUN"
    },
    "000600": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284",
        "Stato": "IT",
        "CAP": "47822",
        "Localit\u00e0": "SANTARCANGELO DI ROMAGNA",
        "Indirizzo": "VIA A. COSTA, 14",
        "N.ri Tel.": "0541 624013",
        "Insegna": "- "
    },
    "020959": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDK02069-006648,25WBLDK03495-006047",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA VIRGILLO SNC",
        "Insegna": "CONTAINER UOMO"
    },
    "010590": {
        "Stato": "IT",
        "CAP": "03100",
        "Localit\u00e0": "FROSINONE",
        "Indirizzo": "VIA VADO LA LENA, 15",
        "N.ri Tel.": "0775-290697",
        "Insegna": "BROGI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC06082-005480,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03169-007455,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04139-007449,26SBLUF02034-007441,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP04036-007441,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "013924": {
        "Stato": "IT",
        "CAP": "55011",
        "Localit\u00e0": "ALTOPASCIO",
        "Indirizzo": "VIA DELLE CERBAIE 24",
        "N.ri Tel.": "0583 269107",
        "Insegna": "CREATIVE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK11140-007286,25WBLUX02081-005958"
    },
    "015411": {
        "Stato": "IT",
        "CAP": "81038",
        "Localit\u00e0": "TRENTOLA-DUCENTA",
        "Indirizzo": "VIA NUZIALE SANT'ANTONIO S.C.",
        "N.ri Tel.": "0815027131",
        "Insegna": "ROMANO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03527-006047,25WBLUC06082-005480,25WBLUK03142-005480"
    },
    "006372": {
        "Stato": "IT",
        "CAP": "84100",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA WENNER, 28/A",
        "N.ri Tel.": "089 302883",
        "Insegna": "MARINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11021-007111,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "013571": {
        "Stato": "IT",
        "CAP": "80074",
        "Localit\u00e0": "CASAMICCIOLA TERME",
        "Indirizzo": "CORSO LUIGI MANZI 61",
        "N.ri Tel.": "081/996880",
        "Insegna": "PISANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "017552": {
        "Stato": "IT",
        "CAP": "06061",
        "Localit\u00e0": "CASTIGLIONE DEL LAGO",
        "Indirizzo": "VIA INDIPENDENZA 116 - POZZUOLO UMBRO",
        "N.ri Tel.": "3495104684",
        "Insegna": "CAMILLONI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03169-007455,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "021168": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05297-006127,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDH02416-007507,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUS01128-007453,26SBLUS01358-007499,26SBLUS02271-007501,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "66100",
        "Localit\u00e0": "CHIETI SCALO",
        "Indirizzo": "VIA PADRE UGOLINO FRASCA SNC",
        "N.ri Tel.": "085 9431373",
        "Insegna": "CLINIKA",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "001793": {
        "Stato": "IT",
        "CAP": "87041",
        "Localit\u00e0": "ACRI",
        "Indirizzo": "VIA DELLA RESISTENZA SNC",
        "N.ri Tel.": "0984 953558",
        "Insegna": "IL QUADRIFOGLIO BY PINO RITACCO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDL01346-007354,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDH02414-005707,26SBLUB01024-007111,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUL02441-007515,26SBLUS01358-007499,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "001486": {
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA COSENZA, 21",
        "N.ri Tel.": "081 5265608",
        "Insegna": "POZZUOLI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP02037-007441,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "000830": {
        "Stato": "IT",
        "CAP": "74023",
        "Localit\u00e0": "GROTTAGLIE",
        "Indirizzo": "VIA MARCONI, 13",
        "N.ri Tel.": "099 5666931",
        "Insegna": "NEW ATLETIC",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC03169-007455,26SBLDH02211-007439,26SBLUC02180-007104,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02305-007457,26SBLUH05070-007439,26SBLUP04332-007493,26SBLUT02290-006803,26SBLUT02297-006801,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "014925": {
        "Stato": "IT",
        "CAP": "10122",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GARIBALDI, 18/D",
        "N.ri Tel.": "0114363058",
        "Insegna": "CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC03169-007455,26SBLUB04119-007449,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUT02064-006526,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "008928": {
        "Stato": "IT",
        "CAP": "53036",
        "Localit\u00e0": "POGGIBONSI",
        "Indirizzo": "LOC. DROVE, 2/G",
        "N.ri Tel.": "0577 937870",
        "Insegna": "CASA DELLO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDL01340-007355,25WBLDP01291-007324,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC02174-006648,26SBLDC02227-007124,26SBLDC03169-007455,26SBLDF01322-007484,26SBLDF03161-007443,26SBLDF08323-007484,26SBLDH02186-007445,26SBLDH02211-007439,26SBLDH02327-007483,26SBLDH02407-007508,26SBLDH03328-007483,26SBLDK11147-007111,26SBLDM01483-007531,26SBLDP01163-007443,26SBLDP01398-007526,26SBLDP03351-007496,26SBLDP04500-007526,26SBLDX03166-007455,26SBLUA04463-007525,26SBLUB04119-007449,26SBLUC01199-007108,26SBLUC01229-007108,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF08140-007448,26SBLUH02065-006526,26SBLUH02121-007451,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02305-007457,26SBLUH02306-007440,26SBLUH04349-007495,26SBLUL02434-007520,26SBLUL02439-007521,26SBLUL02442-007515,26SBLUL02532-007564,26SBLUM01471-007529,26SBLUM06473-007528,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUP01245-006804,26SBLUP01361-007504,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04141-007448,26SBLUP04142-007448,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUP05362-007504,26SBLUS01126-007453,26SBLUS01356-007500,26SBLUS02271-007502,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "016768": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA SANTA MARIA ANTESAECULA 1",
        "N.ri Tel.": "081 456111",
        "Insegna": "BY ANITA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,26SBLDC01215-007131,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC11095-007110,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "020384": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "SURANO",
        "Indirizzo": "VIALE STAZIONE, SNC",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047"
    },
    "003120": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "PRATO",
        "Indirizzo": "VIALE DELLA REPUBBLICA, 254",
        "N.ri Tel.": "0574 580367",
        "Insegna": "PEDINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDF08248-006948,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC11095-007110,26SBLDC11100-007462,26SBLDH02411-005707,26SBLDH02412-005707,26SBLDH02418-006845,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUH02068-007439,26SBLUH02233-007457,26SBLUH02234-007457,26SBLUH02235-007457,26SBLUH02284-007480,26SBLUL02434-007520,26SBLUP02336-007493,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUT02307-007132,26SBLUX02184-005958,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "021328": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "015685": {
        "Stato": "DE",
        "CAP": "44532",
        "Localit\u00e0": "LUENEN",
        "Indirizzo": "MARKSTRASSE 2C",
        "N.ri Tel.": "+49 2306 9280756",
        "Insegna": "TIEMANN'S",
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110,25WBLDK11162-007110,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDC02281-007476,26SBLDC04077-007474,26SBLDC04192-007474,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "000548": {
        "Stato": "IT",
        "CAP": "06012",
        "Localit\u00e0": "CITTA' DI CASTELLO",
        "Indirizzo": "PIAZZA FANTI, 2",
        "N.ri Tel.": "075 8553046",
        "Insegna": "ALUIGI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUH02302-007439,26SBLUS01358-007499,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "017410": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "SENIGALLIA",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "071-79821811",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648"
    },
    "017371": {
        "Stato": "IT",
        "CAP": "72100",
        "Localit\u00e0": "BRINDISI",
        "Indirizzo": "VIA APPIA 269",
        "N.ri Tel.": "0831 514242",
        "Insegna": "FREE TIME",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03098-006047,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC02170-006648,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDC11100-007462,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDP03351-007496,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02295-006801,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02170-006648"
    },
    "018153": {
        "Stato": "IT",
        "CAP": "03024",
        "Localit\u00e0": "CEPRANO",
        "Indirizzo": "VIA CAMPIDOGLIO, 233",
        "N.ri Tel.": "0775 911122",
        "Insegna": "NEW AGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC06082-005480,26SBLUC11018-007110,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "020980": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "47001",
        "Localit\u00e0": "VALLADOLID, CASTILLA",
        "Indirizzo": "VIA GUGLIELMO MARCONI , 15",
        "N.ri Tel.": "0121-393916",
        "Insegna": "- "
    },
    "008051": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "LECCE",
        "Indirizzo": "VIA BRACCIO MARTELLO, 35",
        "N.ri Tel.": "0832 315715",
        "Insegna": "MAGRITTE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDH02411-005707,26SBLDH02412-005707,26SBLDP03351-007496,26SBLDP03352-007496,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04201-007124,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUH02302-007439,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "022931": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648",
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA LARGO BONITO 4-6-8",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- "
    },
    "018901": {
        "Stato": "IT",
        "CAP": "74024",
        "Localit\u00e0": "MANDURIA",
        "Indirizzo": "VIA XX SETTEMBRE, 56/A",
        "N.ri Tel.": "392 2652143",
        "Insegna": "GRANATO STORE ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286,26SBLDL02447-007520,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUP01245-006804,26SBLUP03329-007496,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUT02293-006801,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDL02447-007520"
    },
    "012730": {
        "Stato": "CZ",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "BLAUER - SOUDNI 10/13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03161-006719,25WBLDK05019-007298"
    },
    "021249": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUL01316-007012,26SBLKC01369-007101,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKP05526-007557,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "09025",
        "Localit\u00e0": "SANLURI",
        "Indirizzo": "VIALE RINASCITA S.N.",
        "N.ri Tel.": "070 9370879",
        "Insegna": "TUVERI",
        "PRODUCT CODE KOOOMO": "26SBLKC01369-007101"
    },
    "016020": {
        "Stato": "IT",
        "CAP": "70037",
        "Localit\u00e0": "RUVO DI PUGLIA",
        "Indirizzo": "CORSO GIOVANNI JATTA , 42",
        "N.ri Tel.": "0803601143",
        "Insegna": "CIRASIELLO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03173-007307,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC02172-007104,26SBLDC02281-007476,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDH02415-007507,26SBLDK11147-007111,26SBLUC01229-007108,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUC11028-007462,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH04349-007495,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02297-006801,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "015382": {
        "Stato": "IT",
        "CAP": "75018",
        "Localit\u00e0": "STIGLIANO",
        "Indirizzo": "VIA ROMA, 14",
        "N.ri Tel.": "0835561281",
        "Insegna": "PUNTO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK11162-007110"
    },
    "019234": {
        "Stato": "IT",
        "CAP": "20093",
        "Localit\u00e0": "COLOGNO MONZESE",
        "Indirizzo": "PIAZZA 11 FEBBRAIO, 12",
        "N.ri Tel.": "02 36574173",
        "Insegna": "ZUCCHERO",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,26SBLGC01389-007111,26SBLKA04464-007525,26SBLKF08530-007557,26SBLKH02523-007558,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "009632": {
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "VIA E. BUCCARELLI, 8/10",
        "N.ri Tel.": "0961 721657",
        "Insegna": "NOI DUE & CO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047"
    },
    "001994": {
        "Stato": "IT",
        "CAP": "80038",
        "Localit\u00e0": "POMIGLIANO D'ARCO",
        "Indirizzo": "VIA E. CANTONE, 48",
        "Insegna": "OVER THE TOP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047"
    },
    "017730": {
        "Stato": "IT",
        "CAP": "96014",
        "Localit\u00e0": "FLORIDIA",
        "Indirizzo": "VIA ROMA 11",
        "N.ri Tel.": "3891121405",
        "Insegna": "BON TON",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLGC02391-006648,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,26SBLDC02176-006648,26SBLDC02206-007459,26SBLGC01402-007111,26SBLGC02385-007459,26SBLKC01403-007462,26SBLKC06372-007101,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "017618": {
        "Stato": "IT",
        "CAP": "89861",
        "Localit\u00e0": "TROPEA",
        "Indirizzo": "PIAZZA ERCOLE 24/25",
        "N.ri Tel.": "0963 604110",
        "Insegna": "GIANNINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUL01316-007012,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC03165-007455,26SBLDC03169-007455,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUT02321-007481,26SBLUX02181-007104,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "020648": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "90011",
        "Localit\u00e0": "BAGHERIA",
        "Indirizzo": "CORSO BUTERA, 490",
        "N.ri Tel.": "091/903627",
        "Insegna": "BERTINI"
    },
    "020911": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01219-007108,26SBLDC02173-007104,26SBLDC02175-007119,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDH02412-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUH02347-007495,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUP01120-007452,26SBLUP03329-007496,26SBLUS01128-007453,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "73042",
        "Localit\u00e0": "CASARANO",
        "Indirizzo": "VIALE ANTONIO FILOGRANA, 5",
        "N.ri Tel.": "0833-603097",
        "Insegna": "MAXIMUS",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "021433": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,26SBLUF03243-006804,26SBLUH02237-007439,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUT02289-007479,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA XX SETTEMBRE, 27",
        "Insegna": "CONTAINER UOMO",
        "PRODUCT CODE KOOOMO": "26SBLUF03243-006804"
    },
    "023309": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDK03161-006719,25WBLDL01340-007355",
        "Stato": "IT",
        "CAP": "500 02",
        "Localit\u00e0": "PALMA DE MALLORCA",
        "Indirizzo": "Roudnicska 50/3",
        "N.ri Tel.": "620920155",
        "Insegna": "- "
    },
    "021129": {
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "97015",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA SACRO CUORE, 127",
        "N.ri Tel.": "0932 1972529",
        "Insegna": "- "
    },
    "021524": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03098-006047",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "619768266",
        "Insegna": "- "
    },
    "011216": {
        "Stato": "IT",
        "CAP": "88043",
        "Localit\u00e0": "FEROLETO ANTICO",
        "Indirizzo": "LOC. GARRUBBE SNC",
        "N.ri Tel.": "0968/750121",
        "Insegna": "THE GALLERY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,26SBLUC01106-007101,26SBLUC01200-007108,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03243-006804,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02541-007608,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "017944": {
        "Stato": "IT",
        "CAP": "20123",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA OLONA, 5",
        "N.ri Tel.": "02/89406514",
        "Insegna": "GRANDI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "016142": {
        "Stato": "IT",
        "CAP": "26013",
        "Localit\u00e0": "CREMA",
        "Indirizzo": "VIA CAVOUR 2 ANGOLO VIA MAZZINI",
        "N.ri Tel.": "0373/81837",
        "Insegna": "ENRICO IV",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355"
    },
    "003502": {
        "Stato": "IT",
        "CAP": "81038",
        "Localit\u00e0": "TRENTOLA DUCENTA",
        "Indirizzo": "SP TRENTOLA PARETE C/O C.C. JAMBOL",
        "N.ri Tel.": "081 5017285",
        "Insegna": "MIKA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03090-006719,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC11095-007110,26SBLUC11018-007110,26SBLUC11028-007462,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "015068": {
        "Stato": "IT",
        "CAP": "80069",
        "Localit\u00e0": "VICO EQUENSE",
        "Indirizzo": "CORSO UMBERTO I, 14",
        "N.ri Tel.": "0818027652",
        "Insegna": "COVI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308"
    },
    "023530": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK11162-007110",
        "Stato": "IT",
        "CAP": "80138",
        "Localit\u00e0": "TRENTO",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "973249885",
        "Insegna": "- "
    },
    "015600": {
        "Stato": "IT",
        "CAP": "87040",
        "Localit\u00e0": "LUZZI",
        "Indirizzo": "CONTRADA CAVONI",
        "N.ri Tel.": "0984/949004",
        "Insegna": "PELLE E CUOIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC03169-007455,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC02185-005958,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04201-007124,26SBLUF02034-007441,26SBLUF08538-007512,26SBLUH02069-007439,26SBLUL02435-007520,26SBLUL02441-007515,26SBLUS04360-007499,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "008470": {
        "Stato": "IT",
        "CAP": "51100",
        "Localit\u00e0": "PISTOIA",
        "Indirizzo": "VIA DEGLI ORAFI, 7/9",
        "N.ri Tel.": "0573 368932",
        "Insegna": "STREET 67",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03495-006047,25WBLUA05298-006127,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK11140-007286,26SBLUB04226-007124,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUP01133-007448,26SBLUP02037-007441,26SBLUP05150-007448,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04226-007124"
    },
    "016457": {
        "Stato": "UA",
        "CAP": "-",
        "Localit\u00e0": "UZHGOROD",
        "Indirizzo": "ULICA PEREMOGI 5-3",
        "N.ri Tel.": "02/8321103",
        "Insegna": "PUNTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02192-006648,25WBLDK03182-006985,25WBLDX03181-006985,25WBLUC02079-005958,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUL01316-007012"
    },
    "016649": {
        "Stato": "RU",
        "CAP": "6100",
        "Localit\u00e0": "TULA",
        "Indirizzo": "VIA INDIPENDENZA, 52",
        "N.ri Tel.": "06 9397742",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03527-006047"
    },
    "019874": {
        "Stato": "IT",
        "CAP": "95463",
        "Localit\u00e0": "VARNA",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "335349300",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047"
    },
    "004520": {
        "Stato": "IT",
        "CAP": "46041",
        "Localit\u00e0": "ASOLA",
        "Indirizzo": "VIA CREMONA, 62",
        "N.ri Tel.": "0376 712027",
        "Insegna": "RIZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "002293": {
        "Stato": "IT",
        "CAP": "57125",
        "Localit\u00e0": "LIVORNO",
        "Indirizzo": "VIA RICASOLI, 127",
        "N.ri Tel.": "0586 899779",
        "Insegna": "BERTOLINI",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355"
    },
    "016845": {
        "Stato": "IT",
        "CAP": "08048",
        "Localit\u00e0": "TORTOLI",
        "Indirizzo": "VIA MICHELANGELO, 24",
        "N.ri Tel.": "0782 624122",
        "Insegna": "VICEVERSA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUX02081-005958"
    },
    "001001": {
        "Stato": "IT",
        "CAP": "90146",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA PIETRO NENNI, 30/32",
        "N.ri Tel.": "091 6800911",
        "Insegna": "LA MALFA 14",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBBXC02422-005958,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP05495-007570,26SBBXP05496-007570,26SBLDC01215-007131,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDC11099-007462,26SBLGC01402-007111,26SBLGC01406-007462,26SBLGC02380-006648,26SBLGC03410-007455,26SBLGH02501-007558,26SBLGH02502-007558,26SBLKC01370-007101,26SBLKC02364-005958,26SBLKC02366-007104,26SBLKC06372-007101,26SBLKC11423-007110,26SBLKF02527-007557,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUL02441-007515,26SBLUP01361-007504,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02296-006801,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "011652": {
        "Stato": "IT",
        "CAP": "20882",
        "Localit\u00e0": "BELLUSCO",
        "Indirizzo": "VIA ALESSANDRO MANZONI, 39",
        "N.ri Tel.": "039/623669",
        "Insegna": "PIROLA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01146-007111,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDH02411-005707,26SBLDH02424-007495,26SBLDP01398-007526,26SBLUB01024-007111,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC04118-007452,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01146-007111"
    },
    "009672": {
        "Stato": "IT",
        "CAP": "80124",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE CAMPI FLEGREI, 7/F-9",
        "N.ri Tel.": "081 5704153",
        "Insegna": "MAGLIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02132-007284,25WBLUC03233-007308,25WBLUC11083-007110,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "000352": {
        "Stato": "IT",
        "CAP": "20030",
        "Localit\u00e0": "BOVISIO MASCIAGO",
        "Indirizzo": "VIA SALVEMINI, 1/5/7",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUX02081-005958,26SBLUF01239-006804,26SBLUF02034-007441",
        "PRODUCT CODE KOOOMO": "26SBLUF01239-006804"
    },
    "014548": {
        "Stato": "IT",
        "CAP": "00055",
        "Localit\u00e0": "LADISPOLI",
        "Indirizzo": "VIALE ITALIA 75",
        "N.ri Tel.": "06/99222143",
        "Insegna": "ANTINORI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUA04463-007525,26SBLUC01108-007101,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUM01477-006233,26SBLUP02037-007441,26SBLUP03350-007496,26SBLUT02064-006526,26SBLUT02293-006801,26SBLUT02307-007132,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "012744": {
        "Stato": "IT",
        "CAP": "73052",
        "Localit\u00e0": "PARABITA",
        "Indirizzo": "VIA VITTORIO EMANUELE III , 28",
        "N.ri Tel.": "0833/593038",
        "Insegna": "MIRIZIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03096-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480"
    },
    "013670": {
        "Stato": "IT",
        "CAP": "89041",
        "Localit\u00e0": "CAULONIA",
        "Indirizzo": "SAN NICOLA VIA EMILIA",
        "N.ri Tel.": "0964/863490",
        "Insegna": "DE.MO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC03168-007455,26SBLDC03169-007455,26SBLUC02179-007104,26SBLUC02185-005958,26SBLUC02207-007459,26SBLUX02181-007104,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03168-007455"
    },
    "019460": {
        "Stato": "IT",
        "CAP": "58022",
        "Localit\u00e0": "FOLLONICA",
        "Indirizzo": "VIA ROMA, 65",
        "N.ri Tel.": "056654092",
        "Insegna": "MARINE SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02429-005958,26SBLGC01389-007111,26SBLGC03410-007455,26SBLKC02364-005958,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "000847": {
        "Stato": "IT",
        "CAP": "80045",
        "Localit\u00e0": "POMPEI",
        "Indirizzo": "VIA PLINIO, 25",
        "N.ri Tel.": "081 8506056",
        "Insegna": "PIPOL",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUH02065-006526,26SBLUH02541-007608,26SBLUP02037-007441,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11027-007462"
    },
    "013986": {
        "Stato": "IT",
        "CAP": "25015",
        "Localit\u00e0": "DESENZANO DEL GARDA",
        "Indirizzo": "VIA CASTELLO 6",
        "N.ri Tel.": "030/9911998",
        "Insegna": "MAXIDI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110"
    },
    "015199": {
        "Stato": "IT",
        "CAP": "80049",
        "Localit\u00e0": "SOMMA VESUVIANA",
        "Indirizzo": "VIA SEGGIARI, 16",
        "Insegna": "CITY FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC01218-007108,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDH02212-007439,26SBLDH02411-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLUC02179-007104,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF02240-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02290-006803,26SBLUT02298-007440,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000180": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,26SBLGC01406-007462,26SBLGC03410-007455,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKC01404-007462,26SBLKC02364-005958,26SBLKH02524-007558,26SBLKP05531-007557",
        "Stato": "IT",
        "CAP": "00162",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA NOMENTANA, 459",
        "N.ri Tel.": "06 86215948",
        "Insegna": "GIBOT",
        "PRODUCT CODE KOOOMO": "26SBLGC01406-007462"
    },
    "010697": {
        "Stato": "IT",
        "CAP": "80050",
        "Localit\u00e0": "PIMONTE",
        "Indirizzo": "VIA CASA CUOMO PIAZZA, 8 14",
        "N.ri Tel.": "081-8749071",
        "Insegna": "SHOPPING CUOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC11083-007110,26SBLDC04077-007474,26SBLDC11095-007110,26SBLDH02211-007439,26SBLDH02212-007439,26SBLDH02411-005707,26SBLDH03413-005707,26SBLUC11021-007111,26SBLUH02306-007440,26SBLUH02541-007608,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02291-006803,26SBLUT02295-006801,26SBLUT02304-007481,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04077-007474"
    },
    "021180": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "LOCALITA' BARONE FRASSO",
        "N.ri Tel.": "0968/750121",
        "Insegna": "MILANO FASHION"
    },
    "004952": {
        "Stato": "ES",
        "CAP": "27400",
        "Localit\u00e0": "MONFORTE DE LEMUS",
        "Indirizzo": "CARDENAL, 28",
        "N.ri Tel.": "+34982405341",
        "Insegna": "AVRIL 28",
        "CODICE PRODOTTO KOOOMO": "25WBLDK01376-007378,25WBLDK02192-006648,25WBLDK03161-006719"
    },
    "015070": {
        "Stato": "IT",
        "CAP": "76016",
        "Localit\u00e0": "MARGHERITA DI SAVOIA",
        "Indirizzo": "CORSO VITTORIO EMANUELE 15",
        "N.ri Tel.": "0883/657314",
        "Insegna": "NAPOLITANO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03097-006047,25WBLUC02077-006943,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUL01316-007012,26SBLDC01219-007108,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04201-007124,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "015829": {
        "Stato": "DE",
        "CAP": "72119",
        "Localit\u00e0": "Ammerbuch",
        "Indirizzo": "C/O Logistik & Service, Hagenring 23",
        "N.ri Tel.": "004970711520",
        "Insegna": "MODEHAUS ZINSER GMBH & CO. KG",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03101-006047,26SBLDC01219-007108,26SBLDC02281-007476,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000848": {
        "Stato": "IT",
        "CAP": "61100",
        "Localit\u00e0": "PESARO",
        "Indirizzo": "VIA TRA I DUE PORTI, 2",
        "N.ri Tel.": "0721 25679",
        "Insegna": "NAUTIC STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02408-007508,26SBLDH02416-007507,26SBLDH03409-007508,26SBLDK11145-007110,26SBLDM01488-007532,26SBLDP01059-007441,26SBLUB01024-007111,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUM01477-006233,26SBLUP01245-006804,26SBLUP05337-007568,26SBLUT02288-007479,26SBLUT02296-006801,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "014427": {
        "Stato": "IT",
        "CAP": "80030",
        "Localit\u00e0": "SAN PAOLO BEL SITO",
        "Indirizzo": "STRADA PROVINCIALE PER LIVERI 15",
        "N.ri Tel.": "338-8411311",
        "Insegna": "SINISCALCHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUH02066-006526,26SBLUH02541-007608,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "020609": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "09127",
        "Localit\u00e0": "CAGLIARI",
        "Indirizzo": "VIA SIDNEY SONNINO, 35",
        "N.ri Tel.": "070 666106",
        "Insegna": "SURF SPOT"
    },
    "015288": {
        "Stato": "IT",
        "CAP": "80143",
        "Localit\u00e0": "NOLA",
        "Indirizzo": "VIA GENOVA 90,",
        "N.ri Tel.": "0810146650",
        "Insegna": "SORECA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308"
    },
    "007655": {
        "Stato": "IT",
        "CAP": "20129",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "CORSO VENTIDUE MARZO, 39",
        "N.ri Tel.": "02 717259",
        "Insegna": "ROBERTO LEON",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02153-007300,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01217-007108,26SBLDC01262-007101,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDK11147-007111,26SBLDP01059-007441,26SBLDV03258-007464,26SBLUB04119-007449,26SBLUB04226-007124,26SBLUC04118-007452,26SBLUH02065-006526,26SBLUT02064-006526,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "018462": {
        "Stato": "IT",
        "CAP": "28845",
        "Localit\u00e0": "DOMODOSSOLA",
        "Indirizzo": "CORSO PAOLO FERRARIS, 4",
        "N.ri Tel.": "0324 45878",
        "Insegna": "TOMMY IMMAGINE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11027-007462"
    },
    "017376": {
        "Stato": "ES",
        "CAP": "17250",
        "Localit\u00e0": "PLATJA D'ARO",
        "Indirizzo": "AV. STRASBOURG, 1",
        "N.ri Tel.": "972 81 84 12",
        "Insegna": "MARC FRANC",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC01262-007101,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDH02425-007495,26SBLDP05326-007484,26SBLDS02400-007464,26SBLDV03258-007464,26SBLUC04118-007452,26SBLUF03243-006804,26SBLUH02287-007480,26SBLUH02311-007132,26SBLUL02436-007520,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUT02290-006803,26SBLUT02293-006801",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "015655": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDF08248-006948,25WBLDK02192-006648,25WBLDX03181-006985,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUC02151-007287,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC02175-007119,26SBLDC04077-007474,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDH02418-006845,26SBLDP01059-007441,26SBLDP01398-007526,26SBLDP02278-007475,26SBLDP03330-007494,26SBLDP05058-007441,26SBLDS04392-007506,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUC01043-007120,26SBLUC02221-007124,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02234-007457,26SBLUH02235-007457,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUH02313-005695,26SBLUH02315-005695,26SBLUH02317-005695,26SBLUP01120-007452,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUP01361-007504,26SBLUP02336-007493,26SBLUP03329-007494,26SBLUP03329-007496,26SBLUP05362-007504,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02297-006801",
        "Stato": "RU",
        "CAP": "630112",
        "Localit\u00e0": "NOVOSIBIRSK OBLAST",
        "Indirizzo": "\"AYPA\", VOYENNAYA UL., 5",
        "N.ri Tel.": "028321103",
        "Insegna": "ZEPPELIN",
        "PRODUCT CODE KOOOMO": "26SBLDC02175-007119"
    },
    "001248": {
        "Stato": "IT",
        "CAP": "12011",
        "Localit\u00e0": "BORGO SAN DALMAZZO",
        "Indirizzo": "PIAZZA MARTIRI, 14",
        "N.ri Tel.": "0171 266362",
        "Insegna": "MICLO'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02305-007457,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUP04334-007493,26SBLUS01358-007499,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02307-007132,26SBLUT02321-007481,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "014127": {
        "Stato": "IT",
        "CAP": "10064",
        "Localit\u00e0": "PINEROLO",
        "Indirizzo": "PIAZZA FACTA, 2",
        "N.ri Tel.": "0121 71325",
        "Insegna": "ZEBRA SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "020462": {
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "CORSO VITTORIO EMANUELE II, 32",
        "N.ri Tel.": "3289846573",
        "Insegna": "SAN LORENZO GALLERY BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,26SBLUF08140-007448,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02301-007439,26SBLUL02445-007516,26SBLUP01331-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04142-007448,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS01128-007453,26SBLUS01270-007502,26SBLUT02297-006801,26SBLUT02309-007132,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP01002-007493,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUF08140-007448"
    },
    "019117": {
        "Stato": "ES",
        "CAP": "09200",
        "Localit\u00e0": "MIRANDA DE EBRO, BURGOS",
        "Indirizzo": "AVINGUDA COMUNEROS DE CASTILLA, 8",
        "N.ri Tel.": "947330936",
        "Insegna": "GLOBAL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF08140-007448",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "010005": {
        "Stato": "IT",
        "CAP": "87027",
        "Localit\u00e0": "PAOLA",
        "Indirizzo": "VIA S. AGATA, 81",
        "N.ri Tel.": "0982 585546",
        "Insegna": "MODA KIDS",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,26SBLGC02377-007104,26SBLGC02385-007459,26SBLKC02366-007104,26SBLKC02542-007459,26SBLKF02527-007557,26SBLKF08515-007557,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05531-007557,26SBLKX02365-005958,26SBLKX02368-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC02377-007104"
    },
    "020011": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDF08248-006948,25WBLDK02192-006648,25WBLDX03181-006985,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUC02151-007287,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC02175-007119,26SBLDC04077-007474,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDH02418-006845,26SBLDP01059-007441,26SBLDP01398-007526,26SBLDP02278-007475,26SBLDP03330-007494,26SBLDP05058-007441,26SBLDS04392-007506,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUC01043-007120,26SBLUC02221-007124,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02234-007457,26SBLUH02235-007457,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUH02313-005695,26SBLUH02315-005695,26SBLUH02317-005695,26SBLUP01120-007452,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUP01361-007504,26SBLUP02336-007493,26SBLUP03329-007494,26SBLUP03329-007496,26SBLUP05362-007504,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02297-006801,99CBLUP02001-007493",
        "Stato": "RU",
        "CAP": "105122",
        "Localit\u00e0": "MOSCOW",
        "Indirizzo": "Int.Ter. Municipal District, Golyanovo, Shchelkovskoe highway, 9, office 1P",
        "Insegna": "OSCAR (ULAN UDE)",
        "PRODUCT CODE KOOOMO": "26SBLDC02175-007119"
    },
    "001235": {
        "Stato": "IT",
        "CAP": "88070",
        "Localit\u00e0": "BOTRICELLO",
        "Indirizzo": "VIA NAZIONALE, 463",
        "N.ri Tel.": "0961 963327",
        "Insegna": "STORIE DI MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDH02415-007507,26SBLDH02416-007507,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02237-007439,26SBLUH02238-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP02037-007441,26SBLUT02289-007479,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUX02184-005958,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDH02415-007507"
    },
    "015072": {
        "Stato": "IT",
        "CAP": "24040",
        "Localit\u00e0": "VERDELLINO",
        "Indirizzo": "VIA PRINCIPE AMEDEO 18",
        "N.ri Tel.": "035 870010",
        "Insegna": "ARMANNI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDL01346-007354,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC01134-007131,26SBLDC04077-007474,26SBLDC04275-007475,26SBLDH02327-007483,26SBLDH02425-007495,26SBLDH05223-007460,26SBLDP02278-007475,26SBLUC01199-007108,26SBLUC11028-007462,26SBLUF01132-007448,26SBLUH02302-007439,26SBLUP01133-007448,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "007772": {
        "Stato": "IT",
        "CAP": "80028",
        "Localit\u00e0": "GRUMO NEVANO",
        "Indirizzo": "VIA DUCA D'AOSTA, 9",
        "N.ri Tel.": "081 8332480",
        "Insegna": "ANTEPRIMA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK01375-007378,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUK03142-005480,26SBLUC02207-007459,26SBLUC11071-007462,26SBLUH02283-007480,26SBLUH02285-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUL02436-007520,26SBLUL02440-007522,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "001135": {
        "Stato": "IT",
        "CAP": "61037",
        "Localit\u00e0": "MAROTTA DI MONDOLFO",
        "Indirizzo": "VIA MOLISE, 29",
        "N.ri Tel.": "0721 967081",
        "Insegna": "NETTUNO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK11162-007110,25WBLUC03074-006355,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDF01104-007441,26SBLDP01059-007441,26SBLUB01024-007111,26SBLUC02207-007459,26SBLUF02034-007441,26SBLUH02283-007480,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "008321": {
        "Stato": "IT",
        "CAP": "24050",
        "Localit\u00e0": "ORIO AL SERIO",
        "Indirizzo": "VIA PORTICO",
        "Insegna": "OREGON",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "021764": {
        "CODICE PRODOTTO KOOOMO": "26SBBXC01420-007111,26SBLDC01219-007108,26SBLDC03165-007455,26SBLDC11099-007462,26SBLGC01406-007462,26SBLGC02380-006648,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKF03528-007557,26SBLKH02525-007558,26SBLKP05526-007557,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUX02184-005958,26SBLUX02184-A05958,26SBLUX03232-006719,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "74027",
        "Localit\u00e0": "SAN GIORGIO JONICO",
        "Indirizzo": "P.ZZA FALCONE, 8",
        "N.ri Tel.": "0994501401",
        "Insegna": "RAGNO STORE",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "014476": {
        "Stato": "IT",
        "CAP": "70127",
        "Localit\u00e0": "BARI",
        "Indirizzo": "SANTO SPIRITO VIA NAPOLI 87",
        "N.ri Tel.": "3333586062",
        "Insegna": "STELLACCI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUX02081-005958,26SBLUA04463-007525,26SBLUC04118-007452,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUH02305-007457,26SBLUL02445-007516,26SBLUM06481-007167,26SBLUP01331-007493,26SBLUP04036-007441,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02295-006801,26SBLUT02304-007481,99CBLUP01002-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "000442": {
        "Stato": "IT",
        "CAP": "91100",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA DAL MAZIO BIRAGO, 11",
        "N.ri Tel.": "091 6176500",
        "Insegna": "NEW FORM",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK02192-006648,25WBLDK03102-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBBXC02421-007104,26SBBXH02498-007558,26SBBXP05495-007570,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03169-007455,26SBLGC01402-007111,26SBLGC02377-007104,26SBLGC02380-006648,26SBLGC03410-007455,26SBLKC02366-007104,26SBLKC03373-006719,26SBLKC11401-007111,26SBLKH02522-007558,26SBLKH02525-007558,26SBLKP05526-007557,26SBLUA04463-007525,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02299-007439,26SBLUS02271-007502,26SBLUT02288-007479,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "016837": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01218-007108,26SBLDC03168-007455",
        "Stato": "DE",
        "CAP": "33330",
        "Localit\u00e0": "Guetersloh",
        "Indirizzo": "Kolbeplatz 1",
        "Insegna": "Klingenthal (Guetersloh)",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "012456": {
        "Stato": "IT",
        "CAP": "87032",
        "Localit\u00e0": "AMANTEA",
        "Indirizzo": "VIA REGINA MARGHERITA 12,",
        "N.ri Tel.": "0982426362",
        "Insegna": "IMMAGINE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,26SBLDC03165-007455,26SBLDC03169-007455,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "001926": {
        "Stato": "IT",
        "CAP": "87027",
        "Localit\u00e0": "PAOLA",
        "Indirizzo": "CORSO ROMA, 37",
        "N.ri Tel.": "0982 587057",
        "Insegna": "FOREVER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUB04093-007461,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04131-007449,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUH02283-007480,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUH05070-007439,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04093-007461"
    },
    "012817": {
        "Stato": "IT",
        "CAP": "80035",
        "Localit\u00e0": "BOSCOFANGONE NOLA",
        "Indirizzo": "C. COMM.LE VULCANO - BUONO LOT.G 116",
        "N.ri Tel.": "0815035208",
        "Insegna": "SANTANGELO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01098-007111,26SBLDC02172-007104,26SBLDC11095-007110,26SBLDH02211-007439,26SBLDH02212-007439,26SBLUC11018-007110,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUS04360-007499,26SBLUT02290-006803,26SBLUT02298-007440,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "009937": {
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "VIA M. IANNELLI, 3",
        "N.ri Tel.": "377 4164660",
        "Insegna": "FRANCESCO MELINO",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLUA04463-007525,26SBLUB04119-007449,26SBLUC02179-007104,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02285-007480,26SBLUH02306-007440,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "001498": {
        "Stato": "IT",
        "CAP": "08015",
        "Localit\u00e0": "MACOMER",
        "Indirizzo": "CORSO UMBERTO, 109",
        "N.ri Tel.": "0785 70612",
        "Insegna": "VERDEMELA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355"
    },
    "013926": {
        "Stato": "IT",
        "CAP": "55100",
        "Localit\u00e0": "PICCIORANA",
        "Indirizzo": "VIA PESCIATINA 1299,",
        "N.ri Tel.": "0583 996414",
        "Insegna": "OFFICINA UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUX02081-005958,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUH02300-007439,26SBLUM01482-007167,26SBLUM06473-007528,26SBLUM06481-007167,26SBLUP01245-006804,26SBLUP04036-007441,26SBLUP05150-007448,26SBLUP05244-006804,26SBLUT02067-006526,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04131-007449"
    },
    "010918": {
        "Stato": "IT",
        "CAP": "33077",
        "Localit\u00e0": "SACILE",
        "Indirizzo": "VIALE TRENTO, 59",
        "N.ri Tel.": "0434/780696",
        "Insegna": "PIU' SPORT - amina sportiva",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "000194": {
        "Stato": "IT",
        "CAP": "89063",
        "Localit\u00e0": "MELITO PORTO SALVO",
        "Indirizzo": "VIA NAZIONALE, 81",
        "N.ri Tel.": "0965 732111",
        "Insegna": "CAREZZE",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,25WBLKC11416-007110,26SBLGC02377-007104,26SBLGC02383-007119,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02368-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC02377-007104"
    },
    "001069": {
        "Stato": "IT",
        "CAP": "87012",
        "Localit\u00e0": "CASTROVILLARI",
        "Indirizzo": "VIA ROMA, 79/81",
        "N.ri Tel.": "0981 21721",
        "Insegna": "LA MAMMINA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,26SBLUC02207-007459,26SBLUC03197-006719,26SBLUC04038-006788,26SBLUC04139-007449,26SBLUF01032-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUL02441-007515,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "015886": {
        "Stato": "IT",
        "CAP": "90146",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA STAZIONE SAN LORENZO, 6",
        "N.ri Tel.": "091 6257727",
        "Insegna": "GIGLIO IN",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUX02081-005958,26SBLKH02512-007558,26SBLKH02522-007558,26SBLKH02525-007558,26SBLKN01433-006581,26SBLKN02491-007542,26SBLKP05519-007557,26SBLKT02431-007440,26SBLKT02514-007559,26SBLKX02365-005958,26SBLUC04118-007452,26SBLUH02069-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUM06473-007528,26SBLUM06481-007167,26SBLUM08479-006233,26SBLUM10478-006233,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUP01331-007493,26SBLUP01361-007503,26SBLUP01361-007504,26SBLUP02336-007493,26SBLUP03329-007496,26SBLUP03350-007496,26SBLUP04051-007503,26SBLUP04334-007493,26SBLUP05362-007503,26SBLUP05362-007504,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS01358-007499,26SBLUT02293-006801,26SBLUT02297-006801,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04118-007452"
    },
    "014436": {
        "Stato": "IT",
        "CAP": "74015",
        "Localit\u00e0": "Marianske lazne",
        "Indirizzo": "VIA SALLUSTIO  20c,22,24",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943"
    },
    "007572": {
        "Stato": "IT",
        "CAP": "27100",
        "Localit\u00e0": "PAVIA",
        "Indirizzo": "CORSO STRADA NUOVA, 48",
        "N.ri Tel.": "0382 23254",
        "Insegna": "STILMODE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,25WBLUX02081-005958"
    },
    "017004": {
        "Stato": "IT",
        "CAP": "72027",
        "Localit\u00e0": " SAN PIETRO VERNOTICO",
        "Indirizzo": "VIA BRINDISI 258",
        "N.ri Tel.": "3935328458",
        "Insegna": "FULL SERVICE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480"
    },
    "014847": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01215-007131,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC04192-007474,26SBLDH02415-007507,26SBLDK11147-007111,26SBLUB04040-006788,26SBLUC02180-007104,26SBLUC11005-007123,26SBLUC11006-007123,26SBLUC11020-007110,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02011-007149,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02288-007479,99CBLDA09007-007795",
        "Stato": "ES",
        "CAP": "17520",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "C/ MAYOR 28",
        "N.ri Tel.": "972881144",
        "Insegna": "CHARLES PUIGCERDA",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "016434": {
        "Stato": "IT",
        "CAP": "20021",
        "Localit\u00e0": "BOLLATE",
        "Indirizzo": "VIA CAVOUR,  14",
        "N.ri Tel.": "02-3503468",
        "Insegna": "CALZATURE DANIEL",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC03169-007455,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02293-006801,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "001755": {
        "Stato": "IT",
        "CAP": "10067",
        "Localit\u00e0": "VIGONE",
        "Indirizzo": "VIA UMBERTO I, 28",
        "N.ri Tel.": "011 9809891",
        "Insegna": "IL BRUCO MODA JR",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,26SBLGF08505-007557,26SBLGH02502-007558,26SBLKF02527-007557,26SBLKH02512-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGF08505-007557"
    },
    "012617": {
        "Stato": "IT",
        "CAP": "84013",
        "Localit\u00e0": "CAVA DE' TIRRENI",
        "Indirizzo": "VIA CASA GAGLIARDI, SNC -  SANT'ARCANGELO",
        "N.ri Tel.": "089 441488",
        "Insegna": "DESY-D",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,26SBLDC01215-007131,26SBLDC02172-007104,26SBLDC03169-007455,26SBLDC11095-007110,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "018377": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA TRENCIA, 40",
        "N.ri Tel.": "3662045058",
        "Insegna": "- "
    },
    "014726": {
        "Stato": "DE",
        "CAP": "49835",
        "Localit\u00e0": "Wietmarschen",
        "Indirizzo": "Meitnerstrasse 17",
        "N.ri Tel.": "0049 59154950",
        "Insegna": "L\u00f6ning",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK02192-006648,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC02281-007476,26SBLDC04077-007474",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "022141": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "CALLE SANT AUGUSTIN 7",
        "N.ri Tel.": "0034 987 273398",
        "Insegna": "LEIKO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03161-006719,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC02173-007104,26SBLDC03165-007455,26SBLDC03168-007455,26SBLDF01104-007441,26SBLDK11147-007111,26SBLDP01398-007526,26SBLDS04343-007506,26SBLDS04392-007506,26SBLDV02341-007526,26SBLDV04396-007526",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "015749": {
        "Stato": "IT",
        "CAP": "73016",
        "Localit\u00e0": "SAN CESARIO",
        "Indirizzo": "S.S.476 KM 2+110 N.72",
        "N.ri Tel.": "0832350466",
        "Insegna": "STEP BY STEP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC02176-006648,26SBLDC04460-007475,26SBLDC11099-007462,26SBLUB04093-007461,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUS04360-007499,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "018411": {
        "Stato": "IT",
        "CAP": "25121",
        "Localit\u00e0": "BRESCIA",
        "Indirizzo": "CORSO PALESTRO, 28",
        "N.ri Tel.": "335/5630341",
        "Insegna": "SUITCORSOPALESTRO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUA04470-007525,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUC11071-007462,26SBLUP04142-007448,26SBLUS01358-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04470-007525"
    },
    "012703": {
        "Stato": "IT",
        "CAP": "90011",
        "Localit\u00e0": "BAGHERIA",
        "Indirizzo": "CORSO BUTERA, 412",
        "N.ri Tel.": "091/903627",
        "Insegna": "BERTINI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355"
    },
    "017903": {
        "Stato": "IT",
        "CAP": "87075",
        "Localit\u00e0": "TREBISACCE",
        "Indirizzo": "VIA LEONCAVALLO SNC",
        "N.ri Tel.": "0981-551002",
        "Insegna": "PERESTROIKA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUA05297-006127,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "006324": {
        "Stato": "IT",
        "CAP": "89013",
        "Localit\u00e0": "GIOIA TAURO",
        "Indirizzo": "VIA ROMA, 19/23",
        "N.ri Tel.": "0966 55767",
        "Insegna": "MARCHESE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUC01107-007101,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11113-006787,26SBLUH02284-007480,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01107-007101"
    },
    "023276": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK02192-006648",
        "Stato": "ES",
        "CAP": "73951",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "973243471",
        "Insegna": "- "
    },
    "017201": {
        "Stato": "IT",
        "CAP": "87063",
        "Localit\u00e0": "CARIATI MARINA",
        "Indirizzo": "VIA BARI, 37/A",
        "Insegna": "CENTRO MODA GINA NIGRO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUF01032-007441,26SBLUF02240-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02237-007439,26SBLUH02238-007439,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUS04360-007499,26SBLUT02289-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "000351": {
        "CODICE PRODOTTO KOOOMO": "26SBLUC01199-007108,26SBLUC11028-007462",
        "Stato": "IT",
        "CAP": "21013",
        "Localit\u00e0": "GALLARATE",
        "Indirizzo": "VIA RAFFAELLO SANZIO, 2",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "PRODUCT CODE KOOOMO": "26SBLUC11028-007462"
    },
    "019538": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLGA05461-007349,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02429-005958,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBBXC02422-005958,26SBBXH02498-007558,26SBBXH02499-007558,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDH02411-005707,26SBLDH02416-007507,26SBLGC01402-007111,26SBLGC02377-007104,26SBLGC02385-007459,26SBLGC03410-007455,26SBLKC01369-007101,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKC11401-007111,26SBLKH02511-007558,26SBLKH02523-007558,26SBLKH02525-007558,26SBLKN01433-006581,26SBLKN02491-007542,26SBLKX02365-005958,26SBLUC01107-007101,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUP02336-007493,26SBLUT02064-006526,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "92014",
        "Localit\u00e0": "PORTO EMPEDOCLE",
        "Indirizzo": "VIA VINCENZELLA SNC",
        "N.ri Tel.": "3283771367",
        "Insegna": "PIETRO LEONE",
        "PRODUCT CODE KOOOMO": "26SBLDC02176-006648"
    },
    "013731": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "81042",
        "Localit\u00e0": "CALVI RISORTA",
        "Indirizzo": "VIA O.MANCINI 48",
        "Insegna": "POLIZZI"
    },
    "015807": {
        "Stato": "AT",
        "CAP": "6561",
        "Localit\u00e0": "ISCHGL",
        "Indirizzo": "DORFSTRASSE 79",
        "N.ri Tel.": "+43 (0)5444 59 90",
        "Insegna": "ELISABETH HANGL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,26SBLDC01219-007108,26SBLDC01220-007108",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "004798": {
        "Stato": "ES",
        "CAP": "08221",
        "Localit\u00e0": "Terrassa",
        "Indirizzo": "calle Gavatxons, 5",
        "N.ri Tel.": "0093 783 7744",
        "Insegna": "BASIC CONCEPT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUA05299-006127,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUC01107-007101,26SBLUC01108-007101,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02272-007478,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUL02439-007521,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP04048-007465,26SBLUT02288-007479,26SBLUT02293-006801",
        "PRODUCT CODE KOOOMO": "26SBLUA04463-007525"
    },
    "021403": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958,26SBLGC01389-007111,26SBLGC01402-007111,26SBLGC02380-006648,26SBLGC03410-007455,26SBLKC02366-007104,26SBLKC03373-006719,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "33100",
        "Localit\u00e0": "UDINE",
        "Indirizzo": "VIA RIALTO, 15",
        "N.ri Tel.": "0422 546108",
        "Insegna": "MIOZZI",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "008937": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA ISONZO, 20",
        "N.ri Tel.": "0984 26196",
        "Insegna": "GIGLIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUP02336-007493,26SBLUP04334-007493,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02180-007104"
    },
    "018795": {
        "Stato": "IT",
        "CAP": "20013",
        "Localit\u00e0": "MAGENTA",
        "Indirizzo": "VIA ROMA,  5",
        "N.ri Tel.": "0297002225",
        "Insegna": "fedenosotti@gmail.com",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLKC02427-005958,25WBLKC02429-005958,26SBLGF02507-007557,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKA04464-007525,26SBLKF02527-007557,26SBLKF08518-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,26SBLKT02431-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGF02507-007557"
    },
    "000995": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA APPIA NUOVA, 86",
        "N.ri Tel.": "06 7003609",
        "Insegna": "LIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "020965": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "89057",
        "Localit\u00e0": "GAMBARIE D'ASPROMONTE",
        "Indirizzo": "PIAZZA MANGERUCA, 7",
        "N.ri Tel.": "0965 743010",
        "Insegna": "SPORTIME"
    },
    "006429": {
        "Stato": "DE",
        "CAP": "33332",
        "Localit\u00e0": "GUETERSLOH",
        "Indirizzo": "NEUENKIRCHENER STRASSE 60",
        "N.ri Tel.": "+49 5241-5291",
        "Insegna": "EUSTERHUS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC06082-005480,25WBLUK03142-005480"
    },
    "007711": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA APPIA NUOVA, 109/B",
        "N.ri Tel.": "06 77205372",
        "Insegna": "CLADI'",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUB01024-007111,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02302-007439,26SBLUM01477-006233,26SBLUT02291-006803,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB01024-007111"
    },
    "002441": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958",
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "0818062859",
        "Insegna": "- "
    },
    "012594": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO PONTICELLI 33/35",
        "N.ri Tel.": "081/5965377",
        "Insegna": "PRELUDIO"
    },
    "015309": {
        "Stato": "ES",
        "CAP": "08620",
        "Localit\u00e0": "SANT VICENT DELS HORTS",
        "Indirizzo": "LA POBLA 41",
        "N.ri Tel.": "0034936724792",
        "Insegna": "MUNNE 1941",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK03161-006719,25WBLDK11162-007110,25WBLUC08078-006355,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC03168-007455,26SBLDC04268-007475,26SBLDC04275-007475,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "015583": {
        "Stato": "IT",
        "CAP": "04020",
        "Localit\u00e0": "ITRI",
        "Indirizzo": "VIA CIVITA FARNESE , 18/20",
        "N.ri Tel.": "0771729393",
        "Insegna": "DIVA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC06082-005480,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF08140-007448,26SBLUH02238-007439,26SBLUH02283-007480,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUP01133-007448,26SBLUP01245-006804,26SBLUT02293-006801,26SBLUT02297-006801,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "003563": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01215-007131,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC04077-007474,26SBLUC04139-007449,26SBLUC04201-007124",
        "Stato": "DE",
        "CAP": "53332",
        "Localit\u00e0": "BORNHEIM-HERSEL",
        "Indirizzo": "SIMON-ARZT STRASSE 1",
        "N.ri Tel.": "0049222283060",
        "Insegna": "Daniels",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "009722": {
        "Stato": "IT",
        "CAP": "81100",
        "Localit\u00e0": "CASERTA",
        "Indirizzo": "VIA FILIPPO TURATI 19",
        "N.ri Tel.": "0823 443378",
        "Insegna": "CHARLIE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUF01239-006804,26SBLUH02300-007439,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "021162": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK11140-007286,25WBLUX02081-005958,26SBLDC01136-007110,26SBLDC01218-007108,26SBLDC02228-007119,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUT02064-006526,26SBLUT02293-006801,26SBLUT02294-006801,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "58100",
        "Localit\u00e0": "GROSSETO",
        "Indirizzo": "VIALE DELL'UNIONE, 8",
        "N.ri Tel.": "0564 29525",
        "Insegna": "PARRONCHI",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "007729": {
        "Stato": "IT",
        "CAP": "91011",
        "Localit\u00e0": "ALCAMO",
        "Indirizzo": "CORSO DEI MILLE, 42",
        "N.ri Tel.": "0924 23784",
        "Insegna": "PLAYGROUND",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02206-007459,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02069-007439,26SBLUH02246-007457,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02311-007132,26SBLUP02336-007493,26SBLUP04334-007493,26SBLUT02291-006803,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "012315": {
        "Stato": "IT",
        "CAP": "10151",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "S.DA COMUNALE DI ALTESSANO 141",
        "N.ri Tel.": "011/2121148",
        "Insegna": "ONE'S EASE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDK03495-006047,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11095-007110,26SBLUA04463-007525,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUF01132-007448,26SBLUF02240-006804,26SBLUF03149-007448,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUP01245-006804,26SBLUS01270-007502,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "014635": {
        "Stato": "IT",
        "CAP": "87036",
        "Localit\u00e0": "RENDE",
        "Indirizzo": "PIAZZA MARTIN LUTHER KING",
        "N.ri Tel.": "0984462363",
        "Insegna": "DO & BIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUX02081-005958"
    },
    "021787": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC02172-007104,26SBLDC03165-007455,26SBLDC03168-007455,26SBLUA04463-007525,26SBLUA04467-007527,26SBLUC11021-007111,26SBLUC11027-007462,26SBLUF02034-007441,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "88836",
        "Localit\u00e0": "COTRONEI",
        "Indirizzo": "VILLAGGIO PALUMBO, 1",
        "N.ri Tel.": "0962/493042",
        "Insegna": "360 SLIDE SHOP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "008929": {
        "Stato": "IT",
        "CAP": "00139",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ALBERTO LIONELLO, 201 INT. 125 C/o C.C. PORTE DI ROMA (BUFALOTTA)",
        "N.ri Tel.": "06 87074325",
        "Insegna": "NEGOZI PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLGC02391-006648,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBBXC02422-005958,26SBBXF02493-007570,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXP01494-007570,26SBBXP05495-007570,26SBLGF08505-007557,26SBLGH02501-007558,26SBLGH03504-007561,26SBLGP05503-007560,26SBLKA04464-007525,26SBLKC03373-006719,26SBLKF03528-007557,26SBLKF08530-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC01107-007101,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLUC01107-007101"
    },
    "017037": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK03101-006047",
        "Stato": "DE",
        "CAP": "83022",
        "Localit\u00e0": "Rosenheim (Innenstadt), Bayern",
        "Indirizzo": "Ludwigplatz 4",
        "N.ri Tel.": "08031-9411200",
        "Insegna": "Block 6 - Knierer-Hartinger GbR, Block"
    },
    "015520": {
        "Stato": "IT",
        "CAP": "23037",
        "Localit\u00e0": "TIRANO",
        "Indirizzo": "VIALE ITALIA, 14",
        "N.ri Tel.": "0342-702400",
        "Insegna": "ESSE TRE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK02192-006648,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03233-007308,25WBLUC11083-007110"
    },
    "017822": {
        "Stato": "IT",
        "CAP": "59013",
        "Localit\u00e0": "MONTEMURLO",
        "Indirizzo": "VIA MONTALESE, 475",
        "N.ri Tel.": "320 1157236",
        "Insegna": "NOIR BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDC02175-007119,26SBLDC03165-007455,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDH02414-005707,26SBLDH03413-005707,26SBLDP01059-007441,26SBLDS04392-007506,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUH02068-007439,26SBLUM01480-007167,26SBLUN02129-007447,26SBLUP02037-007441,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "018815": {
        "Stato": "IT",
        "CAP": "04023",
        "Localit\u00e0": "FORMIA",
        "Indirizzo": "VIA VITRUVIO, 27",
        "N.ri Tel.": "0773 709592",
        "Insegna": "SBARAGLIA STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11019-007110,26SBLUH02306-007440,26SBLUN02129-007447,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "020172": {
        "Stato": "IT",
        "CAP": "88067",
        "Localit\u00e0": "SAN VITO SULLO IONIO",
        "Indirizzo": "VIA GARIBALDI, 39",
        "N.ri Tel.": "3286523501",
        "Insegna": "SINOPOLI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDX03181-006985,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUL02318-007340,26SBLDC02172-007104,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDK11147-007111,26SBLDP01059-007441,26SBLDS01345-007506,26SBLDT02086-006526,26SBLUA04463-007525,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC11019-007110,26SBLUC11028-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02541-007608,26SBLUN02490-007542,26SBLUP01361-007504,26SBLUT02289-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "019226": {
        "Stato": "IT",
        "CAP": "21047",
        "Localit\u00e0": "SARONNO",
        "Indirizzo": "VIALE LOMBARDIA 21/A",
        "Insegna": "BRANDS FACTORY",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDP01295-007323,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC03169-007455,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUF03243-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUP01245-006804,26SBLUT02064-006526,26SBLUT02290-006803,26SBLUX02181-007104,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "013361": {
        "Stato": "IT",
        "CAP": "43056",
        "Localit\u00e0": "SOLIERA",
        "Indirizzo": "VIA REPUBBLICA, 26 FRAZ. S.GIACOMO",
        "N.ri Tel.": "052 2886171",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC03177-006719,26SBLUC04131-007449,26SBLUC11231-006787,26SBLUX02184-A05958",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "014510": {
        "Stato": "IT",
        "CAP": "20094",
        "Localit\u00e0": "CORSICO",
        "Indirizzo": "VIA MILANO 25,",
        "N.ri Tel.": "02/4473871",
        "Insegna": "PANDA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480"
    },
    "020179": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "89020",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "0966 937207",
        "Insegna": "- "
    },
    "000410": {
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "36071",
        "Localit\u00e0": "ARZIGNANO",
        "Indirizzo": "PIAZZA DELLE LIBERTA', 4",
        "N.ri Tel.": "0444 670047",
        "Insegna": "- "
    },
    "019977": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01134-007131,26SBLDC01218-007108,26SBLDC02173-007104,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "22070",
        "Localit\u00e0": "GIUSSANO",
        "Indirizzo": "VIA PREALPI 28",
        "N.ri Tel.": "338 583581 MONICA",
        "Insegna": "MASCHERONI",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "023680": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK01376-007378,25WBLDK03101-006047,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "96103",
        "Localit\u00e0": "WOLLERSDORF",
        "Indirizzo": "WILHELMSTR. 13",
        "N.ri Tel.": "973243471",
        "Insegna": "- "
    },
    "018414": {
        "Stato": "IT",
        "CAP": "01037",
        "Localit\u00e0": "RONCIGLIONE",
        "Indirizzo": "VIALE 5 GIUGNO SNC",
        "Insegna": "BAGGIANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03173-007307,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC01262-007101,26SBLDC11095-007110,26SBLDF01104-007441,26SBLDH02211-007439,26SBLDH02327-007483,26SBLDP01059-007441,26SBLDS04392-007506,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF01239-006804,26SBLUH02065-006526,26SBLUH02300-007439,26SBLUM01477-006233,26SBLUS01270-007502,26SBLUS02271-007502,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "007975": {
        "Stato": "ES",
        "CAP": "43870",
        "Localit\u00e0": "AMPOSTA / TARRAGONA",
        "Indirizzo": "AVENIDA SANTA BARBARA, 3",
        "N.ri Tel.": "977701622",
        "Insegna": "TRIBECA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLUC03074-006355,25WBLUC08078-006355"
    },
    "000914": {
        "Stato": "IT",
        "CAP": "19126",
        "Localit\u00e0": "LA SPEZIA",
        "Indirizzo": "VIA DEL CANALETTO, 254",
        "N.ri Tel.": "0187 513847",
        "Insegna": "GODANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC03086-006047,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC03169-007455,26SBLDF08057-007441,26SBLDK11147-007111,26SBLDL02536-007515,26SBLDP01059-007441,26SBLDX03166-007455,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02312-007132,26SBLUH02347-007495,26SBLUH02348-007495,26SBLUS01358-007499,26SBLUT02307-007132,26SBLUX02184-005958,26SBLUX02184-A05958,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "014199": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "SAN GIOVANNI GEMINI",
        "Indirizzo": "PIAZZA PURRELLO 1",
        "N.ri Tel.": "0922-901174",
        "Insegna": "PARG",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLUC01106-007101,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02066-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUT02067-006526,26SBLUT02288-007479,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "013417": {
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "VIA TIBERIO SOLIS, 27",
        "N.ri Tel.": "0882/222446",
        "Insegna": "CRISTALLI DONNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,26SBLDC01219-007108,26SBLDC03165-007455,26SBLDC03168-007455,26SBLDC03169-007455,26SBLDH02411-005707,26SBLDH02412-005707,26SBLDH02414-005707,26SBLDP03351-007496,26SBLDS04343-007506,26SBLDV01339-007526,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000857": {
        "Stato": "IT",
        "CAP": "87021",
        "Localit\u00e0": "BELVEDERE MARITTIMO",
        "Indirizzo": "VIA GIUSTINO FORTUNATO, 50",
        "N.ri Tel.": "0985 84522",
        "Insegna": "FANTASIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC02175-007119,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDL02533-007564,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02541-007608,26SBLUS04360-007499,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "015005": {
        "Stato": "IT",
        "CAP": "71121",
        "Localit\u00e0": "FOGGIA",
        "Indirizzo": "C.SO VITTORIO EMANUELE,86",
        "N.ri Tel.": "0881-587803",
        "Insegna": "SIMONE COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLKC11416-007110,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC03167-007455,26SBLDC11099-007462,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05503-007560,26SBLGP05508-007557,26SBLKF02516-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKN01433-006581,26SBLKN02491-007542,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKT02514-007559,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "023064": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "DE",
        "CAP": "89081",
        "Localit\u00e0": "Ulm",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "0731-140810",
        "Insegna": "- "
    },
    "019251": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "80146",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIA MONTE SAN MICHELE, 23",
        "N.ri Tel.": "3804364649",
        "Insegna": "- "
    },
    "004808": {
        "Stato": "ES",
        "CAP": "48011",
        "Localit\u00e0": "Bilbao Vizcaya",
        "Indirizzo": "C. Gran Via Don Diego Lopez de Haro, 61",
        "N.ri Tel.": "0034 944418743",
        "Insegna": "DOCK",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUB04040-006788,26SBLUB04119-007449,26SBLUB04226-007124,26SBLUC02180-007104,26SBLUC04131-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUF01132-007448,26SBLUF01239-006804,26SBLUF03149-007448,26SBLUL02434-007520",
        "PRODUCT CODE KOOOMO": "26SBLUB04040-006788"
    },
    "008308": {
        "Stato": "IT",
        "CAP": "11100",
        "Localit\u00e0": "AOSTA",
        "Indirizzo": "VIA DE TILLIER, 51",
        "N.ri Tel.": "0165 363544",
        "Insegna": "NEAPOLIS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02306-007440,26SBLUT02293-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "011355": {
        "Stato": "IT",
        "CAP": "10123",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA ROMA, 55",
        "N.ri Tel.": "011 3292512",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03527-006047"
    },
    "019377": {
        "CODICE PRODOTTO KOOOMO": "26SBLUA04465-007525,26SBLUA04470-007525,26SBLUB04093-007461,26SBLUC04139-007449,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02297-006801,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "70017",
        "Localit\u00e0": "PUTIGNANO",
        "Indirizzo": "VIA TURI, 68",
        "N.ri Tel.": "3939161185",
        "Insegna": "PROGETTO STORE",
        "PRODUCT CODE KOOOMO": "26SBLUA04465-007525"
    },
    "000907": {
        "Stato": "IT",
        "CAP": "07041",
        "Localit\u00e0": "ALGHERO",
        "Indirizzo": "VIA CARLO ALBERTO, 57",
        "N.ri Tel.": "333 2591865 Luisella",
        "Insegna": "GILBERT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02313-005695,26SBLUH02315-005695,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02293-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "012507": {
        "Stato": "IT",
        "CAP": "80070",
        "Localit\u00e0": "MONTE DI PROCIDA",
        "Indirizzo": "CORSO GARIBALDI 11",
        "N.ri Tel.": "0818683601",
        "Insegna": "CAPRICCIO",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBLGC01402-007111,26SBLGH02502-007558,26SBLGH03504-007561,26SBLKC06372-007101,26SBLKC11423-007110,26SBLKH02511-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKH02525-007558,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01402-007111"
    },
    "009502": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "PRATO",
        "Indirizzo": "VIA B. RICASOLI, 10",
        "N.ri Tel.": "0574 607070",
        "Insegna": "CARILLON",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUA05297-006127"
    },
    "015932": {
        "Stato": "IT",
        "CAP": "000133",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DELLA TENUTA DI TERRANOVA 154/156",
        "N.ri Tel.": "3478865069",
        "Insegna": "PACHA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLUC03074-006355,25WBLUC08078-006355"
    },
    "020464": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "091-8112478",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284"
    },
    "001231": {
        "Stato": "IT",
        "CAP": "81037",
        "Localit\u00e0": "SESSA AURUNCA",
        "Indirizzo": "VIA XXI LUGLIO, 91",
        "N.ri Tel.": "0823 936825",
        "Insegna": "KUBA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUK03142-005480,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02286-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUP05244-006804,26SBLUS04360-007499,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "008035": {
        "Stato": "IT",
        "CAP": "24047",
        "Localit\u00e0": "TREVIGLIO",
        "Indirizzo": "VIA ROMA, 16/A",
        "N.ri Tel.": "0363 301446",
        "Insegna": "ALLEGRI BIMBI",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958"
    },
    "003148": {
        "Stato": "IT",
        "CAP": "200582",
        "Localit\u00e0": "VILLASANTA",
        "Indirizzo": "VIA CONFALONIERI FEDERICO CONTE, 29",
        "N.ri Tel.": "039 303989",
        "Insegna": "COLOMBO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03102-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110"
    },
    "015664": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01219-007108,26SBLDC02206-007459,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDS01345-007506,26SBLDS04392-007506,26SBLUC02179-007104,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUF02034-007441,26SBLUF08140-007448,26SBLUH02347-007495,26SBLUH02348-007495,26SBLUL02435-007520,26SBLUP01133-007448,26SBLUP04036-007441,26SBLUP04332-007493,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "76012",
        "Localit\u00e0": "CANOSA DI PUGLIA",
        "Indirizzo": "VIA SAVINO DI BARI 3",
        "Insegna": "ANTROPOS",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "014277": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480,26SBLDC04268-007475,26SBLDC04460-007475,26SBLUC04131-007449,26SBLUC11005-007123,26SBLUF03044-007465,26SBLUH02011-007149,26SBLUH02272-007478,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUH02312-007132,26SBLUN02129-007447,26SBLUP04048-007465,26SBLUS01128-007453,26SBLUS02271-007502,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02296-006801",
        "Stato": "ES",
        "CAP": "08201",
        "Localit\u00e0": "SABADELL (BARCELONA)",
        "Indirizzo": "GRACIA 38",
        "N.ri Tel.": "93 727 96 12",
        "Insegna": "JULIAN ADRADOS",
        "PRODUCT CODE KOOOMO": "26SBLDC04268-007475"
    },
    "015004": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC04192-007474,26SBLUC04109-007473,26SBLUC04118-007452,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02300-007439,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "26100",
        "Localit\u00e0": "CREMONA",
        "Indirizzo": "CORSO MAZZINI, 1",
        "N.ri Tel.": "0372/29280",
        "Insegna": "OLIVER",
        "PRODUCT CODE KOOOMO": "26SBLDC04192-007474"
    },
    "010001": {
        "Stato": "IT",
        "CAP": "81031",
        "Localit\u00e0": "AVERSA",
        "Indirizzo": "VIA SAPORITO, 66",
        "N.ri Tel.": "081-5031244",
        "Insegna": "PORCARO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUH02011-007149,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUP02037-007441,26SBLUP05244-006804,26SBLUT02307-007132,26SBLUT02321-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04201-007124"
    },
    "015890": {
        "Stato": "ES",
        "CAP": "26002",
        "Localit\u00e0": "LOGRONO (LA RIOJA)",
        "Indirizzo": "VARA DEL REY 12",
        "Insegna": "LDM",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLUC03086-006047,25WBLUC03090-006719,26SBLDC02206-007459,26SBLDC03168-007455,26SBLDV01339-007526,26SBLDV03258-007464,26SBLDV05282-007475,26SBLUC01107-007101,26SBLUC04201-007124,26SBLUC11005-007123,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF03013-007121,26SBLUH02011-007149",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "015278": {
        "Stato": "IT",
        "CAP": "21100",
        "Localit\u00e0": "VARESE",
        "Indirizzo": "PIAZZA DEL PODESTA' 1",
        "N.ri Tel.": "0332/284402",
        "Insegna": "BASIC",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDF08236-007301,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDP01291-007324,25WBLUA05297-006127,25WBLUA05299-006127,25WBLUA05301-006434,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC03169-007455,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDP01059-007441,26SBLUA04463-007525,26SBLUA04467-007527,26SBLUA04468-007527,26SBLUC01199-007108,26SBLUC01229-007108,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03035-007441,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02316-005695,26SBLUH02317-005695,26SBLUL02439-007521,26SBLUL02441-007515,26SBLUN01432-006581,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUP05244-006804,26SBLUS01358-007499,26SBLUT02293-006801,26SBLUT02298-007440,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "018281": {
        "Stato": "IT",
        "CAP": "00177",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DI ACQUA BULLICANTE, 343",
        "N.ri Tel.": "06 299598",
        "Insegna": "BISOZIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC05125-007283"
    },
    "000983": {
        "Stato": "IT",
        "CAP": "58100",
        "Localit\u00e0": "GROSSETO",
        "Indirizzo": "VIALE SONNINO, 5",
        "N.ri Tel.": "0564 29525",
        "Insegna": "PARRONCHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK03103-006047,25WBLUK11140-007286"
    },
    "019951": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047",
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "Calle ordono II, 12",
        "N.ri Tel.": "0034 987232486",
        "Insegna": "- "
    },
    "022091": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": ". +34 650958601",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308"
    },
    "001164": {
        "Stato": "IT",
        "CAP": "80017",
        "Localit\u00e0": "MELITO",
        "Indirizzo": "CORSO EUROPA, 212",
        "N.ri Tel.": "081 7110086",
        "Insegna": "CEAN",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,26SBLGC01402-007111,26SBLKC11401-007111,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKT02514-007559,26SBLUC11018-007110,26SBLUC11021-007111,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "020082": {
        "Stato": "IT",
        "CAP": "50136",
        "Localit\u00e0": "FIRENZE",
        "Indirizzo": "VIA RATTAZZI 2E",
        "N.ri Tel.": "055678853",
        "Insegna": "DUE PUNTO ZERO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDF08248-006948,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "009576": {
        "Stato": "IT",
        "CAP": "41124",
        "Localit\u00e0": "MODENA",
        "Indirizzo": "VIA SASSI, 1",
        "N.ri Tel.": "059 443156",
        "Insegna": "EXTREME",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958"
    },
    "023227": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "RO",
        "CAP": "89081",
        "Localit\u00e0": "WIEN",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "699913377",
        "Insegna": "- "
    },
    "015086": {
        "Stato": "IT",
        "CAP": "70010",
        "Localit\u00e0": "VALENZANO",
        "Indirizzo": "VIA SAN ROCCO, 68",
        "N.ri Tel.": "080/4676397",
        "Insegna": "EMBLEMA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355"
    },
    "016781": {
        "Stato": "IT",
        "CAP": "80146",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO SAN GIOVANNI A TEDUCCIO, 246",
        "N.ri Tel.": "366 3757055",
        "Insegna": "NIKLO'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03527-006047,26SBLDC01098-007111,26SBLDC01215-007131,26SBLDC11095-007110,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "007893": {
        "Stato": "IT",
        "CAP": "23891",
        "Localit\u00e0": "SIRTORI Loc. BEVERA",
        "Indirizzo": "VIA DELLE INDUSTRIE, 17/A",
        "N.ri Tel.": "039 9211189",
        "Insegna": "BLU FRIDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "012621": {
        "Stato": "IT",
        "CAP": "87026",
        "Localit\u00e0": "MORMANNO",
        "Indirizzo": "VIA SAN BIASE",
        "N.ri Tel.": "098180366",
        "Insegna": "MODA MANIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUL02436-007520,26SBLUL02441-007515,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11027-007462"
    },
    "000124": {
        "Stato": "IT",
        "CAP": "37012",
        "Localit\u00e0": "BUSSOLENGO",
        "Indirizzo": "VIA DELL'OCA BIANCA, 1 - c/o GALLERY SHOPPING CENTER",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047,26SBLDC11099-007462,26SBLDX02171-006648,26SBLUB04226-007124,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUF03243-006804,26SBLUH02302-007439,26SBLUP04036-007441",
        "PRODUCT CODE KOOOMO": "26SBLDC11099-007462"
    },
    "010812": {
        "Stato": "IT",
        "CAP": "27015",
        "Localit\u00e0": "LANDRIANO",
        "Indirizzo": "PIAZZALE AMBROSOLI SNC MAGAZZINO LOTTO 5",
        "N.ri Tel.": "039 9908685",
        "Insegna": "MAXI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01314-007012,25WBLUX02081-005958,26SBLDC02173-007104,26SBLUC02207-007459,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "012728": {
        "Stato": "IT",
        "CAP": "15100",
        "Localit\u00e0": "ALESSANDRIA",
        "Indirizzo": "PIAZZETTA DELLA LEGA LOMBARDA",
        "N.ri Tel.": "0131/40003",
        "Insegna": "FANDANGO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02192-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUK11140-007286"
    },
    "018328": {
        "Stato": "IT",
        "CAP": "00132",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA MASSA DI SAN GIULIANO, 329-331",
        "N.ri Tel.": "3398134761",
        "Insegna": "ORIANA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC04460-007475,26SBLDF01114-006804,26SBLDH02414-005707,26SBLDH02416-007507,26SBLDH03328-007483,26SBLDP01398-007526,26SBLDP02278-007475,26SBLDP05117-006804,26SBLDP05326-007484,26SBLDS01345-007506,26SBLDT02087-006526,26SBLUA04463-007525,26SBLUC02207-007459,26SBLUC11019-007110,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUM01477-006233,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP02037-007441,26SBLUP05244-006804,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02295-006801,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "012950": {
        "Stato": "IT",
        "CAP": "80143",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA NAZIONALE,80",
        "N.ri Tel.": "081-260870",
        "Insegna": "IDEAL MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUF03035-007441,26SBLUH02300-007439,26SBLUP04036-007441,26SBLUT02288-007479,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "006038": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC03086-006047,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "08027",
        "Localit\u00e0": "ORGOSOLO",
        "Indirizzo": "CORSO REPUBBLICA, 288",
        "N.ri Tel.": "0784 403126",
        "Insegna": "GARDENIA BLU"
    },
    "017258": {
        "Stato": "IT",
        "CAP": "25017",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA MANTOVA, 36 - C.C. IL LEONE SHOPPING CENTER",
        "N.ri Tel.": "06 87074325",
        "Insegna": "NEGOZI PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDA05335-007349,25WBLDA05336-007349,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC01043-007120,26SBLUC01107-007101,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01043-007120"
    },
    "019774": {
        "Stato": "IT",
        "CAP": "95014",
        "Localit\u00e0": "GIARRE",
        "Indirizzo": "VIA RUGGERO I, 1/B",
        "N.ri Tel.": "3939626955",
        "Insegna": "SENSAZIONI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC11416-007110,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC04192-007474,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDH03222-007460,26SBLDP05058-007441,26SBLGC01406-007462,26SBLGC02380-006648,26SBLGC02385-007459,26SBLKC01403-007462,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP05531-007557,26SBLUB04119-007449,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP05150-007448,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02304-007481,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "018920": {
        "Stato": "IT",
        "CAP": "85022",
        "Localit\u00e0": "BARILE",
        "Indirizzo": "Strada Statale 93, snc NOI DUE",
        "N.ri Tel.": "0972 724350",
        "Insegna": "ROLEMA ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,26SBLGC02380-006648,26SBLGC03410-007455,26SBLKC03373-006719,26SBLKH02522-007558,26SBLKH02525-007558,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC02380-006648"
    },
    "023154": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "98123",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "937960308",
        "Insegna": "- "
    },
    "009669": {
        "Stato": "IT",
        "CAP": "66100",
        "Localit\u00e0": "CHIETI SCALO",
        "Indirizzo": "VIA PADRE UGOLINO FRASCA SNC",
        "N.ri Tel.": "085 9431373",
        "Insegna": "CLINIKA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,26SBLDH02416-007507,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUS01358-007499",
        "PRODUCT CODE KOOOMO": "26SBLDH02416-007507"
    },
    "021375": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110",
        "Stato": "PL",
        "CAP": "85100",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "3939161185",
        "Insegna": "- "
    },
    "018938": {
        "Stato": "ES",
        "CAP": "08192",
        "Localit\u00e0": "SAN QUIRZE DEL VALLES",
        "Indirizzo": "RAMBLA LLUIS COMPANY, 18B",
        "N.ri Tel.": "638011639",
        "Insegna": "EVA SEVILLA FASION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02192-006648,25WBLDK11162-007110,26SBLDC01218-007108,26SBLDC03168-007455,26SBLDC04268-007475,26SBLDH02425-007495,26SBLDH03328-007483,26SBLDV01339-007526,26SBLDV04396-007526,26SBLUF03149-007448,26SBLUH02068-007439,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUM01480-007167,26SBLUN02129-007447,26SBLUP04048-007465,26SBLUP05150-007448",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "001879": {
        "Stato": "IT",
        "CAP": "80019",
        "Localit\u00e0": "QUALIANO",
        "Indirizzo": "VIA CAMPANA, 224",
        "N.ri Tel.": "081 8189187 Luciano",
        "Insegna": "I GABBIANI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03527-006047,25WBLKC02427-005958,25WBLKC11416-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC11095-007110,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02300-007439,26SBLUP02037-007441,26SBLUS04360-007499,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "011236": {
        "Stato": "IT",
        "CAP": "20017",
        "Localit\u00e0": "RHO",
        "Indirizzo": "VIA MADONNA, 79/B",
        "N.ri Tel.": "373/8250889",
        "Insegna": "ASCOT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUF02240-006804,26SBLUF03243-006804,26SBLUH02068-007439,26SBLUH02287-007480,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP03350-007496,26SBLUS01126-007453,26SBLUT02290-006803,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "018983": {
        "Stato": "IT",
        "CAP": "10139",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA FREJUS, 99",
        "N.ri Tel.": "334 9096724",
        "Insegna": "JEANS BLUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK11162-007110,25WBLUA05297-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02302-007439,26SBLUP02037-007441,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04201-007124"
    },
    "016386": {
        "CODICE PRODOTTO KOOOMO": "26SBLGF02507-007557,26SBLGF08505-007557,26SBLGH02502-007558,26SBLKF03528-007557,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKT02431-007440",
        "Stato": "ES",
        "CAP": "17600",
        "Localit\u00e0": "FIGUERAS, GIRONA",
        "Indirizzo": "C/ PERELADA N. 8",
        "N.ri Tel.": "0034 605099690",
        "Insegna": "BOUTIQUE CATIMINI",
        "PRODUCT CODE KOOOMO": "26SBLGF02507-007557"
    },
    "001057": {
        "Stato": "IT",
        "CAP": "70038",
        "Localit\u00e0": "TERLIZZI",
        "Indirizzo": "VIALE ROMA, 37",
        "N.ri Tel.": "080 3511091",
        "Insegna": "JUST COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUK03142-005480"
    },
    "014646": {
        "Stato": "IT",
        "CAP": "85040",
        "Localit\u00e0": "LAURIA",
        "Indirizzo": "CONTRADA GALDO ZONA F4 SNC",
        "N.ri Tel.": "0973620120",
        "Insegna": "CITY SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK01376-007378,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC01219-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDF01114-006804,26SBLDF01322-007484,26SBLDF03115-006804,26SBLDH02327-007483,26SBLDH02415-007507,26SBLDP01116-006804,26SBLDP03351-007496,26SBLDP03352-007496,26SBLDP05326-007484,26SBLKC06372-007101,26SBLKF02516-007557,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02525-007558,26SBLKP01520-007557,26SBLKP05519-007557,26SBLKX02365-005958,26SBLUC01199-007108,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04092-007461,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUL02436-007520,26SBLUL02441-007515,26SBLUP03329-007496,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUX02184-005958,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "016404": {
        "Stato": "DE",
        "CAP": "44787",
        "Localit\u00e0": "BOCHUM",
        "Indirizzo": "HELLWEG 13",
        "N.ri Tel.": "00492345889944",
        "Insegna": "RUSCH MEN'S SHOES & MORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02151-007287,25WBLUC02153-007300,25WBLUC03090-006719,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC01229-007108,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01045-007465,26SBLUF01132-007448",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "018202": {
        "Stato": "IT",
        "CAP": "00172",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DEI CASTANI, 41/43",
        "N.ri Tel.": "06 23234353",
        "Insegna": "GIANO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUM06472-007529,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "018890": {
        "Stato": "IT",
        "CAP": "10057",
        "Localit\u00e0": "SANT'AMBROGIO DI TORINO",
        "Indirizzo": "C.SO MONCENISIO 125",
        "N.ri Tel.": "011/939241",
        "Insegna": "GIUGLAR SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDF08057-007441,26SBLDP01059-007441,26SBLDP05058-007441,26SBLDX03166-007455,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02293-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "011369": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA ABATE MINICHINI,32",
        "N.ri Tel.": "3319667149",
        "Insegna": "MANU",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01215-007131,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC04077-007474,26SBLDC11095-007110,26SBLGC01389-007111,26SBLGC01402-007111,26SBLKC11423-007110,26SBLKH02511-007558,26SBLKH02513-007558,26SBLKH02525-007558,26SBLKP05519-007557,26SBLUC01106-007101,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02284-007480,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "013757": {
        "Stato": "IT",
        "CAP": "70038",
        "Localit\u00e0": "TERLIZZI",
        "Indirizzo": "VIA PIAVE N 20",
        "N.ri Tel.": "080 3511091",
        "Insegna": "JUST COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,26SBLDC02170-006648,26SBLDC02206-007459,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDH02327-007483,26SBLDH02415-007507,26SBLDP01059-007441,26SBLUB04093-007461,26SBLUB11112-006787,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02237-007439,26SBLUH02246-007457,26SBLUH02284-007480,26SBLUH02301-007439,26SBLUL02445-007516,26SBLUM01471-007529,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUT02067-006526,26SBLUT02288-007479,26SBLUT02294-006801,26SBLUX02184-005958,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02170-006648"
    },
    "023266": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDF08236-007301,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC03074-006355",
        "Stato": "ME",
        "CAP": "85310",
        "Localit\u00e0": "TRICASE",
        "Indirizzo": "PIAZZA CAPPUCCINI, 63",
        "N.ri Tel.": "392 2236490",
        "Insegna": "- "
    },
    "023343": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958",
        "Stato": "PL",
        "CAP": "97015",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIALE CARDUCCI, 79",
        "N.ri Tel.": "988 60 25 20",
        "Insegna": "- "
    },
    "004816": {
        "Stato": "ES",
        "CAP": "08241",
        "Localit\u00e0": "MANRESA",
        "Indirizzo": "CALLE ANGEL GUIMERA, 36",
        "N.ri Tel.": "938738817",
        "Insegna": "COKKO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,26SBLDC01215-007131,26SBLDC04077-007474,26SBLDF08057-007441,26SBLUA04467-007527,26SBLUA04468-007527,26SBLUC01107-007101,26SBLUF01239-006804,26SBLUF03044-007465,26SBLUF03242-006804,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02312-007132,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "018693": {
        "Stato": "IT",
        "CAP": "80065",
        "Localit\u00e0": "SANT'AGNELLO",
        "Indirizzo": "CORSO ITALIA, 4",
        "N.ri Tel.": "334 8030933",
        "Insegna": "ACANFORA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC02206-007459,26SBLDC04192-007474,26SBLDC11099-007462,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03242-006804,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02311-007132,26SBLUS04360-007499,26SBLUT02290-006803,26SBLUT02307-007132,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "002454": {
        "Stato": "IT",
        "CAP": "80053",
        "Localit\u00e0": "CASTELLAMARE DI STABIA",
        "Indirizzo": "PIAZZA PRINCIPE UMBERTO, 11",
        "N.ri Tel.": "081 8716248",
        "Insegna": "ANTONELLA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK01375-007378,25WBLDK01376-007378,25WBLDK03098-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUH02300-007439,26SBLUH02306-007440,26SBLUM01471-007529,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02295-006801,26SBLUT02304-007481,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "010401": {
        "Stato": "IT",
        "CAP": "07100",
        "Localit\u00e0": "SASSARI",
        "Indirizzo": "VIALE ITALIA, 18",
        "N.ri Tel.": "079 2019202 Ausilia",
        "Insegna": "DESOLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUL01314-007012,25WBLUL01316-007012,25WBLUL02318-007340,26SBLDC03169-007455,26SBLUB04119-007449,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUF03044-007465,26SBLUS02271-007502,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "015457": {
        "Stato": "IT",
        "CAP": "89125",
        "Localit\u00e0": "REGGIO CALABRIA",
        "Indirizzo": "CORSO G. GARIBALDI, 262",
        "N.ri Tel.": "0965 811730",
        "Insegna": "MYTHOS 262",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK01375-007378,25WBLDK01376-007378,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDL01346-007354,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,25WBLUX02081-005958,26SBLDH03224-007460,26SBLDH03328-007483,26SBLDH03413-005707,26SBLDL02447-007520,26SBLDL02448-007521,26SBLDL02452-007513,26SBLDL02533-007564,26SBLDL02536-007515,26SBLDP01073-007474,26SBLDP01398-007526,26SBLDS01345-007506,26SBLDS04392-007506,26SBLDV03258-007464,26SBLUB04040-006788,26SBLUC01043-007120,26SBLUC04091-007461,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02069-007439,26SBLUH02121-007451,26SBLUH02314-005695,26SBLUL02441-007515,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP01361-007504,26SBLUP04036-007441,26SBLUP04052-007503,26SBLUP05244-006804,26SBLUP05362-007504,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS01356-007500,26SBLUS01492-007458,26SBLUT02307-007132,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDH03224-007460"
    },
    "000811": {
        "Stato": "IT",
        "CAP": "71029",
        "Localit\u00e0": "TROIA",
        "Indirizzo": "VIA REGINA MARGHERITA, 160",
        "N.ri Tel.": "0881 970039",
        "Insegna": "CARMELINO BUONO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC11083-007110,26SBLUA04465-007525,26SBLUB04093-007461,26SBLUC04118-007452,26SBLUH02068-007439,26SBLUP03350-007496,26SBLUS01358-007499,26SBLUT02309-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUA04465-007525"
    },
    "012880": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK01375-007378,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC03400-007308,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLUC01106-007101,26SBLUC04139-007449,26SBLUC11021-007111,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUT02064-006526,26SBLUT02295-006801",
        "Stato": "IT",
        "CAP": "81020",
        "Localit\u00e0": "SAN MARCO EVANGELISTA",
        "Indirizzo": "STRADA STATALE 265 KM 26.200",
        "Insegna": "MASSARO",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "015612": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047",
        "Stato": "IT",
        "CAP": "00186",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA TIBURTINA VALERIA KM 20 - UNITA' 67",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI"
    },
    "014535": {
        "Stato": "IT",
        "CAP": "00135",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA INZAGO 117",
        "N.ri Tel.": "06 5898254",
        "Insegna": "CASTELLESE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "010105": {
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA DELL'EPOMEO, 77/79",
        "N.ri Tel.": "0812413920",
        "Insegna": "GHIGGI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLUC01106-007101,26SBLUC04131-007449,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "016065": {
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "SAN MARZANO",
        "Indirizzo": "VIA VITTORIO EMANUELE, 164",
        "N.ri Tel.": "099 6618307",
        "Insegna": "FF",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03097-006047,25WBLDC11163-007110,25WBLDK03103-006047,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUX02081-005958,26SBLDC04268-007475,26SBLDH02211-007439,26SBLDH02327-007483,26SBLDH02411-005707,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDP03352-007496,26SBLDV05282-007475,26SBLUC11028-007462,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP03350-007496,26SBLUP04334-007493,26SBLUP05244-006804,26SBLUS01356-007500,26SBLUS02271-007502,26SBLUT02288-007479,26SBLUT02296-006801,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04268-007475"
    },
    "019865": {
        "Stato": "IT",
        "CAP": "33054",
        "Localit\u00e0": "LIGNANO SABBIADORO",
        "Indirizzo": "VIA LOVATO, 23",
        "N.ri Tel.": "3491245378",
        "Insegna": "BEI MERLIN",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDK11147-007111,26SBLUC01106-007101,26SBLUC03177-006719,26SBLUC03197-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03149-007448,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02294-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "009823": {
        "Stato": "IT",
        "CAP": "10022",
        "Localit\u00e0": "CARMAGNOLA",
        "Indirizzo": "PIAZZA SANT 'AGOSTINO, 2",
        "N.ri Tel.": "011 9773350",
        "Insegna": "DOVER",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDK11145-007110,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUH02306-007440,26SBLUP01331-007493,26SBLUP03350-007496,99CBLUP01002-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "018676": {
        "Stato": "IT",
        "CAP": "87024",
        "Localit\u00e0": "FUSCALDO",
        "Indirizzo": "VIA MOLINO 6",
        "N.ri Tel.": "0982-686052",
        "Insegna": "MAY FLOWER",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUK03142-005480,25WBLUL01316-007012,26SBLDC02173-007104,26SBLDC11099-007462,26SBLDK04249-007474,26SBLUC04201-007124,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02306-007440,26SBLUP05244-006804,26SBLUT02293-006801,26SBLUT02298-007440,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "001126": {
        "Stato": "IT",
        "CAP": "87027",
        "Localit\u00e0": "PAOLA",
        "Indirizzo": "VIA NAZIONALE, 124",
        "N.ri Tel.": "0982 587450",
        "Insegna": "SAX MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03086-006047,26SBLDC01262-007101,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC04077-007474,26SBLDK04249-007474,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01262-007101"
    },
    "020570": {
        "Stato": "IT",
        "CAP": "70026",
        "Localit\u00e0": "MODUGNO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 49",
        "N.ri Tel.": "3394380618",
        "Insegna": "RIZZA KIDS",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,26SBBXC02422-005958,26SBBXH02498-007558,26SBBXH02499-007558,26SBBXP05495-007570,26SBBXP05496-007570,26SBLGC01389-007111,26SBLGC02380-006648,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKC01403-007462,26SBLKC02364-005958,26SBLKF02516-007557,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02513-007558,26SBLKH02524-007558,26SBLKN01433-006581,26SBLKN02491-007542,26SBLKP05519-007557,26SBLKP05531-007557",
        "PRODUCT CODE KOOOMO": "26SBBXC02422-005958"
    },
    "019191": {
        "Stato": "IT",
        "CAP": "66016",
        "Localit\u00e0": "GUARDIAGRELE",
        "Indirizzo": "VIA ROMA, 150",
        "N.ri Tel.": "087182768",
        "Insegna": "DES STORE",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC03169-007455,26SBLDC11099-007462,26SBLDK11145-007110,26SBLGC02380-006648,26SBLKC02364-005958,26SBLUC02207-007459,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02064-006526,26SBLUT02290-006803,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000994": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA APPIA NUOVA, 90",
        "N.ri Tel.": "06 7003609",
        "Insegna": "LIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK05019-007298,25WBLDK11162-007110"
    },
    "010124": {
        "Stato": "IT",
        "CAP": "10100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO G.FERRARIS 35",
        "N.ri Tel.": "3389823369",
        "Insegna": "GALFER 35",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03161-006719,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUK11140-007286,25WBLUX02081-005958"
    },
    "020123": {
        "Stato": "IT",
        "CAP": "07026",
        "Localit\u00e0": "OLBIA",
        "Indirizzo": "VIA SANTA LUCIA SS 125 LOC. BASA SNC C.C TERRANOVA",
        "Insegna": "KERLY KIDS",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,26SBLGC01402-007111,26SBLKC01369-007101,26SBLKC06372-007101,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01402-007111"
    },
    "007038": {
        "Stato": "IT",
        "CAP": "76123",
        "Localit\u00e0": "ANDRIA",
        "Indirizzo": "VIALE ROMA, 5",
        "N.ri Tel.": "0883 556095",
        "Insegna": "CARDINALE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,26SBLDC02172-007104,26SBLDC11099-007462,26SBLDH02211-007439,26SBLDH02411-005707,26SBLDH02415-007507,26SBLDM01488-007532,26SBLDP03351-007496,26SBLDV02341-007526,26SBLDX02171-006648,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "023413": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284,25WBLUC03090-006719",
        "Stato": "PL",
        "CAP": "85310",
        "Localit\u00e0": "ZIELONA GORA",
        "Indirizzo": "WALLSTRASSE 1A",
        "N.ri Tel.": "619108808",
        "Insegna": "- "
    },
    "000921": {
        "Stato": "IT",
        "CAP": "73012",
        "Localit\u00e0": "CAMPI SALENTINA",
        "Indirizzo": "VIA PACINOTTI  19 - CAMPICENTRO",
        "N.ri Tel.": "0832 792966",
        "Insegna": "VERSIENTI VOGUER",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03100-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC01262-007101,26SBLDC02173-007104,26SBLDH02211-007439,26SBLDH02415-007507,26SBLDM01488-007532,26SBLUC04118-007452,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUM01480-007167,26SBLUM01482-007167,26SBLUP04334-007493,26SBLUS04360-007499,26SBLUT02294-006801,26SBLUT02295-006801,99CBLUP04004-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "013234": {
        "Stato": "IT",
        "CAP": "06132",
        "Localit\u00e0": "SAN SISTO",
        "Indirizzo": "VIA PIEVAIOLA, 164 C.C. IL TRIANGOLO",
        "N.ri Tel.": "075-5287653",
        "Insegna": "WONDERFUL",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,26SBLDC02206-007459,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDP01059-007441,26SBLUC02207-007459,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02295-006801,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "022176": {
        "Stato": "IT",
        "CAP": "93012",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PLINIO, 377",
        "N.ri Tel.": "96 159 42 50",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02506-007254,25WBLUK11140-007286"
    },
    "015714": {
        "Stato": "IT",
        "CAP": "27029",
        "Localit\u00e0": "VIGEVANO",
        "Indirizzo": "VIA GIORGIO SILVA, 2",
        "N.ri Tel.": "0381/90196",
        "Insegna": "BOSTON CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC11083-007110,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP05244-006804,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "001034": {
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA XX SETTEMBRE, 48",
        "Insegna": "IL PUNTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC05125-007283,25WBLUC06082-005480"
    },
    "017304": {
        "Stato": "IT",
        "CAP": "76013",
        "Localit\u00e0": "MINERVINO MURGE",
        "Indirizzo": "CORSO MATTEOTTI 6",
        "N.ri Tel.": "0883 692933",
        "Insegna": "BLU & CO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03100-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC01219-007108,26SBLDC02228-007119,26SBLDC04268-007475,26SBLDC04460-007475,26SBLUB04226-007124,26SBLUB11112-006787,26SBLUC01199-007108,26SBLUC04131-007449,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUL02435-007520,26SBLUP04036-007441,26SBLUX02184-005958",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "017553": {
        "Stato": "IT",
        "CAP": "60121",
        "Localit\u00e0": "ANCONA",
        "Indirizzo": "CORSO GARIBALDI 115",
        "N.ri Tel.": "3205672142",
        "Insegna": "+39",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02196-007283,25WBLDF08236-007301,25WBLDP01291-007324,25WBLUC05125-007283"
    },
    "018549": {
        "Stato": "ES",
        "CAP": "08700",
        "Localit\u00e0": "IGUALADA",
        "Indirizzo": "RAMBLA GENERAL VIVES, 19",
        "N.ri Tel.": "938032867",
        "Insegna": "Llucia Moda",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC04077-007474,26SBLDC04192-007474,26SBLDF01322-007484,26SBLDF03056-007441,26SBLDH02425-007495,26SBLDM02484-007531,26SBLDS01345-007506,26SBLDV02341-007526,26SBLDV03258-007464,26SBLUC01107-007101,26SBLUC04201-007124,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03035-007441,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUT02293-006801,99CBLDA09007-007795",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "001428": {
        "Stato": "IT",
        "CAP": "17027",
        "Localit\u00e0": "PIETRA LIGURE",
        "Indirizzo": "VIA VINZONE, 4",
        "N.ri Tel.": "019 625454",
        "Insegna": "PEPE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03102-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC11083-007110,26SBLDC01098-007111,26SBLDL02536-007515,26SBLDX02171-006648,26SBLUC01108-007101,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUF08140-007448,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUP04142-007448,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "000506": {
        "Stato": "IT",
        "CAP": "87064",
        "Localit\u00e0": "CORIGLIANO CALABRO",
        "Indirizzo": "VIA NAZIONALE, 42",
        "N.ri Tel.": "0983 886956",
        "Insegna": "PAPILLON",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUX02081-005958,26SBLUC11113-006787,26SBLUH02065-006526,26SBLUS01128-007453,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11113-006787"
    },
    "021428": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUL01316-007012,25WBLUX02081-005958,26SBLUC11027-007462,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUP02037-007441,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA XX SETTEMBRE, 62",
        "Insegna": "CONTAINER UOMO",
        "PRODUCT CODE KOOOMO": "26SBLUC11027-007462"
    },
    "008311": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DI TORREVECCHIA 84",
        "N.ri Tel.": "06 3012785",
        "Insegna": "WEST END ROMA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02073-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUK03142-005480,26SBLDC04269-007475,26SBLDC04460-007475,26SBLDH02417-006845,26SBLDH02489-007536,26SBLDT02087-006526,26SBLDX03166-007455,26SBLUA04463-007525,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUF01319-007482,26SBLUF03320-007482,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUH02313-005695,26SBLUH05070-007439,26SBLUM01477-006233,26SBLUN02129-007447,26SBLUP03350-007496,26SBLUS01356-007500,26SBLUT02307-007132,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04269-007475"
    },
    "023422": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355",
        "Stato": "RU",
        "CAP": "98123",
        "Localit\u00e0": "ZARAGOZA",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- "
    },
    "005942": {
        "Stato": "IT",
        "CAP": "62010",
        "Localit\u00e0": "PASSO DI TREIA",
        "Indirizzo": "CORSO GARIBALDI, 263/C",
        "N.ri Tel.": "0733 541525",
        "Insegna": "JOLLY PIU'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC11099-007462,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11028-007462,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02302-007439,26SBLUP04036-007441,26SBLUS01358-007499,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "020555": {
        "Stato": "IT",
        "CAP": "82018",
        "Localit\u00e0": "CALVI",
        "Indirizzo": "VIA PIANO CASIELLO, 13 - CONTRADA CUBANTE",
        "Insegna": "ZEUS STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11018-007110"
    },
    "014029": {
        "Stato": "IT",
        "CAP": "98051",
        "Localit\u00e0": "BARCELLONA POZZO DI GOTTO",
        "Indirizzo": "VIA ROMA ANG. VIA MOLETI SNC",
        "Insegna": "PUGLISI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDF03056-007441,26SBLDP01059-007441,26SBLGC01402-007111,26SBLGC02377-007104,26SBLKC02364-005958,26SBLKC06372-007101,26SBLKF02516-007557,26SBLKF08515-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC02180-007104,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02541-007608,26SBLUL02435-007520,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "005999": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUB04119-007449,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02304-007481,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "10067",
        "Localit\u00e0": "VIGONE",
        "Indirizzo": "VIA OGGERO BESSONE, 2/A",
        "N.ri Tel.": "011 9809646",
        "Insegna": "BIASIBETTI",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "011060": {
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "FAVARA",
        "Indirizzo": "CORSO VITTORIO VENETO, 392",
        "N.ri Tel.": "0922 33216",
        "Insegna": "LIVRERI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958"
    },
    "018574": {
        "Stato": "IT",
        "CAP": "20855",
        "Localit\u00e0": "LESMO",
        "Indirizzo": "VIA XXV APRILE, 11",
        "Insegna": "SIMEONI JUNIOR",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02429-005958,26SBLGC01389-007111,26SBLGF08505-007557,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKF02527-007557,26SBLKH02524-007558,26SBLKP05526-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "018350": {
        "Stato": "IT",
        "CAP": "85022",
        "Localit\u00e0": "BARILE",
        "Indirizzo": "STRADA STATALE 93, snc",
        "N.ri Tel.": "0972 724350",
        "Insegna": "ROLEMA ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC02194-007476,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDH02414-005707,26SBLDH02417-006845,26SBLUC01199-007108,26SBLUC02185-005958,26SBLUC03177-006719,26SBLUH02068-007439,26SBLUH05070-007439,26SBLUM01471-007529,26SBLUP01331-007493,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUX02184-005958,99CBLUP01002-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "023455": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUK03142-005480,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "92017",
        "Localit\u00e0": "TRIESTE",
        "Indirizzo": "VIALE P. SERAFINI 22",
        "N.ri Tel.": "328/6445076",
        "Insegna": "- "
    },
    "022548": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047",
        "Stato": "AT",
        "CAP": "1010",
        "Localit\u00e0": "WIEN",
        "Indirizzo": "C/O BLAUMAX STORE, Goldschmiedgasse 9",
        "N.ri Tel.": "0043 2243 228990",
        "Insegna": "NEUMANN"
    },
    "020550": {
        "Stato": "IT",
        "CAP": "80029",
        "Localit\u00e0": "SANT'ANTIMO",
        "Indirizzo": "VIA TRIESTE E TRENTO, 59",
        "N.ri Tel.": "347 6675483",
        "Insegna": "ER NONNO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,26SBLDC01098-007111,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUT02067-006526,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "000347": {
        "Stato": "IT",
        "CAP": "37012",
        "Localit\u00e0": "RONCHI DEI LEGIONARI",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03098-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC06082-005480,26SBLDC01219-007108,26SBLDC02175-007119,26SBLGC01406-007462,26SBLKC02366-007104,26SBLUC01043-007120,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC11027-007462",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "020050": {
        "Stato": "IT",
        "CAP": "74027",
        "Localit\u00e0": "SAN GIORGIO JONICO",
        "Indirizzo": "VIA DEL CANALETTO, 27",
        "N.ri Tel.": "0994504101",
        "Insegna": "RAGNO STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLGC02391-006648,25WBLUA05297-006127,25WBLUC02077-006943,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480"
    },
    "017887": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047",
        "Stato": "PL",
        "CAP": "62-080",
        "Localit\u00e0": "Swadzim",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "501090403",
        "Insegna": "- "
    },
    "020527": {
        "Stato": "IT",
        "CAP": "30015",
        "Localit\u00e0": "CHIOGGIA",
        "Indirizzo": "CORSO DEL POPOLO , 1224",
        "N.ri Tel.": "041-401911",
        "Insegna": "FERRY BOAT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUA05298-006127,25WBLUA05300-006434,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02170-006648,26SBLDC02176-006648,26SBLDC03165-007455,26SBLDC03169-007455,26SBLDC04460-007475,26SBLDC11095-007110,26SBLDF08057-007441,26SBLDP01059-007441,26SBLDX02171-006648,26SBLGC02380-006648,26SBLKC02364-005958,26SBLKX02365-005958,26SBLUA04463-007525,26SBLUC03177-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUL02440-007522,26SBLUL02441-007515,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02170-006648"
    },
    "017943": {
        "Stato": "IT",
        "CAP": "24060",
        "Localit\u00e0": "SOVERE",
        "Indirizzo": "VIA PAPA GIOVANNI PAOLO I 9",
        "N.ri Tel.": "035/982627",
        "Insegna": "BOSIO FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUK03142-005480"
    },
    "021570": {
        "CODICE PRODOTTO KOOOMO": "BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "81025",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA GENOVA, 90",
        "N.ri Tel.": "0810146650",
        "Insegna": "SORECA",
        "PRODUCT CODE KOOOMO": "BLAP076-POP"
    },
    "001002": {
        "Stato": "IT",
        "CAP": "62024",
        "Localit\u00e0": "MATELICA",
        "Indirizzo": "VIA CESARE BATTISTI, 8",
        "N.ri Tel.": "0737 85770",
        "Insegna": "SPORT LINE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC11099-007462,26SBLUC02179-007104,26SBLUC11028-007462,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "018719": {
        "Stato": "IT",
        "CAP": "20013",
        "Localit\u00e0": "MAGENTA",
        "Indirizzo": "PIAZZA LIBERAZIONE, 17",
        "N.ri Tel.": "02/36738277",
        "Insegna": "AL DIECI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480"
    },
    "018316": {
        "Stato": "IT",
        "CAP": "74013",
        "Localit\u00e0": "GINOSA",
        "Indirizzo": "VIA LUGI GLIONNA, 40",
        "N.ri Tel.": "338- 9842960",
        "Insegna": "I MASCHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDF08248-006948,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUF02118-007121,25WBLUF03119-007121,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC04460-007475,26SBLDH02416-007507,26SBLDK11147-007111,26SBLDM01483-007531,26SBLDM01488-007532,26SBLUB04119-007449,26SBLUC11005-007123,26SBLUF03013-007121,26SBLUH02011-007149,26SBLUH02234-007457,26SBLUH02238-007439,26SBLUH02283-007480,26SBLUH02317-005695,26SBLUM01482-007167,26SBLUP02037-007441,26SBLUP04017-007458,26SBLUP04153-007458,26SBLUS02271-007501,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "018988": {
        "Stato": "IT",
        "CAP": "64026",
        "Localit\u00e0": "ROSETO DEGLI ABRUZZI",
        "Indirizzo": "VIA G.BOCCACCIO, 15",
        "Insegna": "ANGELS",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958,26SBLGC01389-007111,26SBLGC01402-007111,26SBLKC01369-007101,26SBLKC02364-005958,26SBLKC06372-007101,26SBLKF03528-007557,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP05526-007557,26SBLKP05531-007557,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "020008": {
        "Stato": "IT",
        "CAP": "50132",
        "Localit\u00e0": "FIRENZE",
        "Indirizzo": "VIA MASACCIO 201/D",
        "N.ri Tel.": "3351275708",
        "Insegna": "GAME 7 ATHLETICS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBLDC02172-007104,26SBLDC11095-007110,26SBLDX03166-007455,26SBLUC02179-007104,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "019886": {
        "Stato": "RU",
        "CAP": "97-306",
        "Localit\u00e0": "SAN PIETROBURGO",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "3386722069",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719"
    },
    "009612": {
        "Stato": "IT",
        "CAP": "80018",
        "Localit\u00e0": "MUGNANO DI NAPOLI",
        "Indirizzo": "VIA NAPOLI, 255/A/B/C/D",
        "N.ri Tel.": "081 5862862",
        "Insegna": "VOGUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC11095-007110,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUH02300-007439,26SBLUH02302-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "001562": {
        "Stato": "IT",
        "CAP": "00019",
        "Localit\u00e0": "TIVOLI",
        "Indirizzo": "VIA PACIFICI, 15",
        "N.ri Tel.": "0774 314387",
        "Insegna": "PLANET FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUL02318-007340,26SBLDC01215-007131,26SBLDC11099-007462,26SBLDF01104-007441,26SBLDH02327-007483,26SBLDH02411-005707,26SBLDH02412-005707,26SBLDH03328-007483,26SBLDS04343-007506,26SBLUB04119-007449,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUH02065-006526,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02306-007440,26SBLUN02129-007447,26SBLUS01126-007453,26SBLUS02271-007501,26SBLUT02288-007479,26SBLUT02291-006803,26SBLUT02307-007132,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "014106": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "83031",
        "Localit\u00e0": "ARIANO IRPINO",
        "Indirizzo": "VIA CARDITO , 112",
        "N.ri Tel.": "349-1492635",
        "Insegna": "PUOPOLO"
    },
    "018383": {
        "Stato": "IT",
        "CAP": "71037",
        "Localit\u00e0": "MONTE SANT'ANGELO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 181",
        "N.ri Tel.": "3402362744",
        "Insegna": "FASHION BABY",
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958"
    },
    "000328": {
        "Stato": "IT",
        "CAP": "10036",
        "Localit\u00e0": "SETTIMO TORINESE",
        "Indirizzo": "VIA ASTEGIANO, 8",
        "N.ri Tel.": "011 8971766",
        "Insegna": "ULTIMO IMPERO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDX02171-006648,26SBLUB04119-007449,26SBLUC03197-006719,26SBLUH02284-007480,26SBLUH02306-007440,26SBLUT02293-006801",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "019972": {
        "Stato": "IT",
        "CAP": "71037",
        "Localit\u00e0": "MONTE SANT'ANGELO",
        "Indirizzo": "VIA GIUSEPPE GARIBALDI, 88",
        "N.ri Tel.": "0884-564562",
        "Insegna": "BOUTIQUE CAPRICCIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03100-006047,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC02281-007476,26SBLDC11099-007462,26SBLDH02416-007507,26SBLDH02418-006845,26SBLUC11021-007111,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02301-007439,26SBLUS01126-007453,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02295-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "000346": {
        "Stato": "IT",
        "CAP": "37053",
        "Localit\u00e0": "CEREA",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,26SBLDC01262-007101,26SBLDC02172-007104,26SBLDC04460-007475",
        "PRODUCT CODE KOOOMO": "26SBLDC01262-007101"
    },
    "016067": {
        "Stato": "IT",
        "CAP": "71121",
        "Localit\u00e0": "FOGGIA",
        "Indirizzo": "VIA LECCE, 24",
        "N.ri Tel.": "0881-637512",
        "Insegna": "ZENO NEGOZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03173-007307,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,26SBLDC01219-007108,26SBLDC02170-006648,26SBLDC02176-006648,26SBLDC02206-007459,26SBLDC11095-007110,26SBLDH02211-007439,26SBLDH02412-005707,26SBLDH02415-007507,26SBLDP03351-007496,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUF03243-006804,26SBLUF03320-007482,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUP01245-006804,26SBLUP05318-007482,26SBLUT02295-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000271": {
        "Stato": "IT",
        "CAP": "60035",
        "Localit\u00e0": "JESI",
        "Indirizzo": "CORSO MATTEOTTI, 44",
        "N.ri Tel.": "0731 215417",
        "Insegna": "LUCA' S",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC11083-007110,25WBLUK03142-005480,26SBLUB01024-007111,26SBLUB04119-007449,26SBLUC02180-007104,26SBLUC04118-007452,26SBLUF01239-006804,26SBLUP01245-006804,26SBLUS01126-007453,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUT02321-007481,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB01024-007111"
    },
    "009017": {
        "Stato": "IT",
        "CAP": "20871",
        "Localit\u00e0": "VIMERCATE",
        "Indirizzo": "VIA CAVOUR, 15",
        "N.ri Tel.": "039 6082211",
        "Insegna": "TRUE TYPE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUK03142-005480"
    },
    "013969": {
        "Stato": "IT",
        "CAP": "80039",
        "Localit\u00e0": "SAVIANO",
        "Indirizzo": "STRADA PROVINCIALE FRESSURIELLO 9,",
        "N.ri Tel.": "081-8203599",
        "Insegna": "LE FOLLIE DELLA MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC02175-007119,26SBLDC11095-007110,26SBLDC11099-007462,26SBLDC11100-007462,26SBLDF01104-007441,26SBLDF03056-007441,26SBLDH02416-007507,26SBLDH02417-006845,26SBLDP01059-007441,26SBLGC01389-007111,26SBLGC01402-007111,26SBLGH02502-007558,26SBLGP05508-007557,26SBLKC11423-007110,26SBLKH02524-007558,26SBLKP05531-007557,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02300-007439,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02309-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "019244": {
        "Stato": "IT",
        "CAP": "64021",
        "Localit\u00e0": "GIULIANOVA",
        "Indirizzo": "VIA TRIESTE, 30",
        "N.ri Tel.": "085 8008606",
        "Insegna": "LA GENOVESE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01098-007111,26SBLDC01220-007108,26SBLDC03169-007455,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDH02416-007507,26SBLDK11145-007110,26SBLDP01059-007441,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH05070-007439,26SBLUL02441-007515,26SBLUM01471-007529,26SBLUM01477-006233,26SBLUN02490-007542,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUP04334-007493,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUS01358-007499,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "019568": {
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "36012",
        "Localit\u00e0": "ASIAGO",
        "Indirizzo": "CORSO IV NOVEMBRE, 5",
        "N.ri Tel.": "0424 1761774",
        "Insegna": "ORSO DINO"
    },
    "009831": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03101-006047,25WBLDK11162-007110,25WBLKC02427-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,26SBBXF03497-007570,26SBBXH02498-007558,26SBBXP05495-007570,26SBBXP05496-007570,26SBLDC03165-007455,26SBLDC03169-007455,26SBLGF08505-007557,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP01510-007557,26SBLGP05508-007557,26SBLKF03528-007557,26SBLKH02522-007558,26SBLKH02525-007558,26SBLKP01521-007557,26SBLKP05531-007557,26SBLUA04463-007525,26SBLUA04465-007525,26SBLUA04470-007525,26SBLUC03177-006719,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUH02284-007480,26SBLUP01245-006804,26SBLUS01356-007500,26SBLUT02288-007479,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "38054",
        "Localit\u00e0": "SIROR Loc. S. MARTINO DI CASTROZZA",
        "Indirizzo": "VIA LAGHETTO, 4",
        "N.ri Tel.": "0439 769109",
        "Insegna": "BANCHER",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "000365": {
        "Stato": "IT",
        "CAP": "20020",
        "Localit\u00e0": "ARESE",
        "Indirizzo": "VIALE MONTE RESEGONE, 1 ANGOLO VIA GIACOMO MATTEOTTI, 18",
        "N.ri Tel.": "02 9380109",
        "Insegna": "CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDM01463-007330,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03090-006719,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02173-007104,26SBLDF01114-006804,26SBLDH02407-007508,26SBLDK11147-007111,26SBLDL02447-007520,26SBLDM01488-007532,26SBLDP01116-006804,26SBLDP03352-007496,26SBLDT02086-006526,26SBLUC01106-007101,26SBLUC04118-007452,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUM01477-006233,26SBLUM06472-007529,26SBLUP01331-007493,26SBLUP02037-007441,26SBLUP02336-007493,26SBLUP03350-007496,26SBLUP04036-007441,26SBLUX02181-007104,99CBLUP01002-007493,99CBLUP02001-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "011466": {
        "Stato": "IT",
        "CAP": "87067",
        "Localit\u00e0": "ROSSANO",
        "Indirizzo": "VIA NAZIONALE, 42/44",
        "Insegna": "PIERO & MIMMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03099-006047,25WBLUA05298-006127,25WBLUB05126-007283,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,25WBLUL02318-007340,26SBLDC03165-007455,26SBLDC03169-007455,26SBLUC02180-007104,26SBLUC11231-006787,26SBLUH02284-007480,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUL02436-007520,26SBLUL02441-007515,26SBLUT02288-007479,26SBLUT02294-006801,26SBLUT02297-006801,26SBLUT02304-007481,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "014728": {
        "Stato": "DE",
        "CAP": "30823",
        "Localit\u00e0": "GARBSEN",
        "Indirizzo": "HAVELSER STR. 1",
        "N.ri Tel.": "0049 5131 1619",
        "Insegna": "BROOXX",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDK01376-007378,25WBLDK02192-006648,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUL01314-007012,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDC04077-007474,26SBLDC04460-007475,26SBLUC01199-007108,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUX02181-007104",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "018531": {
        "Stato": "IT",
        "CAP": "12100",
        "Localit\u00e0": "CUNEO",
        "Indirizzo": "VIA CARLO EMANUELE III, 25",
        "N.ri Tel.": "01711890112",
        "Insegna": "MINIME'",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,26SBLGC01389-007111,26SBLKC01369-007101,26SBLKF08518-007557,26SBLKH02513-007558,26SBLKX02365-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "001103": {
        "Stato": "IT",
        "CAP": "85043",
        "Localit\u00e0": "FRANCAVILLA SUL SINNI",
        "Indirizzo": "VIA LUIGI CIMINELLI, 23",
        "N.ri Tel.": "0973 574212",
        "Insegna": "MELE FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC03169-007455,26SBLDC04268-007475,26SBLDC04460-007475,26SBLDH02415-007507,26SBLDH02416-007507,26SBLUB11112-006787,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUH02065-006526,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUL02435-007520,26SBLUS01358-007499,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "000934": {
        "Stato": "IT",
        "CAP": "98055",
        "Localit\u00e0": "LIPARI",
        "Indirizzo": "VIA VITTORIO EMANUELE, 55",
        "N.ri Tel.": "090 9817020",
        "Insegna": "IL BOTTEGHINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLUH02065-006526,26SBLUH02302-007439,26SBLUP02336-007493,26SBLUP04334-007493,26SBLUT02288-007479,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUH02065-006526"
    },
    "021280": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "98123",
        "Localit\u00e0": "RIBERA",
        "Indirizzo": "VIA PARLAPIANO 39,",
        "N.ri Tel.": "0925 67939",
        "Insegna": "- "
    },
    "014446": {
        "Stato": "DE",
        "CAP": "63741",
        "Localit\u00e0": "ASCHAFFENBURG",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "00493041706555",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047"
    },
    "017555": {
        "Stato": "IT",
        "CAP": "40037",
        "Localit\u00e0": "SASSO MARCONI",
        "Indirizzo": "GALLERIA GUGLIELMO MARCONI 2 4",
        "N.ri Tel.": "335470192",
        "Insegna": "BERTOCCHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355"
    },
    "020897": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUA05300-006434,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC03165-007455,26SBLDF01104-007441,26SBLDH02411-005707,26SBLDH02415-007507,26SBLDH02489-007536,26SBLDK11147-007111,26SBLDP01059-007441,26SBLDP02399-007524,26SBLDS02355-007501,26SBLDX03166-007455,26SBLUA04463-007525,26SBLUC01043-007120,26SBLUC03197-006719,26SBLUF01132-007448,26SBLUF03044-007465,26SBLUF03149-007448,26SBLUH02121-007451,26SBLUH02272-007478,26SBLUH02285-007480,26SBLUH02302-007439,26SBLUH02311-007132,26SBLUH02313-005695,26SBLUH02315-005695,26SBLUM01474-007528,26SBLUM01475-007528,26SBLUM01477-006233,26SBLUM01480-007167,26SBLUM06473-007528,26SBLUM06481-007167,26SBLUM08479-006233,26SBLUN02129-007447,26SBLUP01133-007448,26SBLUP02336-007493,26SBLUP04047-007465,26SBLUP04048-007465,26SBLUP04334-007493,26SBLUP05150-007448,26SBLUS01126-007453,26SBLUS02271-007501,26SBLUS02271-007502,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02291-006803,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUX02181-007104,26SBLUX02184-005958,26SBLUX02184-A05958,99CBLUP02001-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "35042",
        "Localit\u00e0": "ESTE",
        "Indirizzo": "VIA PRINCIPE UMBERTO, 10/A",
        "N.ri Tel.": "0444 887860",
        "Insegna": "GIO' ABBIGLIAMENTO",
        "PRODUCT CODE KOOOMO": "26SBLDC03165-007455"
    },
    "023438": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLUC03074-006355,25WBLUC06082-005480",
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIALE INDIPENDENZA, 2",
        "N.ri Tel.": "986438299",
        "Insegna": "- "
    },
    "004797": {
        "Stato": "ES",
        "CAP": "27001",
        "Localit\u00e0": "LUGO",
        "Indirizzo": "calle Juan Montes, 5",
        "N.ri Tel.": "982227916",
        "Insegna": "GARYSOM",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUA05297-006127,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUK03142-005480,26SBLDC01218-007108,26SBLDC01262-007101,26SBLDC03168-007455,26SBLDK11147-007111,26SBLUB04226-007124,26SBLUC01106-007101,26SBLUC11021-007111",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "009015": {
        "Stato": "IT",
        "CAP": "16011",
        "Localit\u00e0": "ARENZANO",
        "Indirizzo": "CORSO GIACOMO MATTEOTTI, 114",
        "N.ri Tel.": "010 9127605",
        "Insegna": "OLIVETTE 2",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719"
    },
    "017386": {
        "Stato": "IT",
        "CAP": "00012",
        "Localit\u00e0": "GUIDONIA",
        "Indirizzo": "VIA DELLE GENZIANE, 13E",
        "N.ri Tel.": "0774-552687",
        "Insegna": "GOCCIA  SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02170-006648,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUL02441-007515,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "015774": {
        "Stato": "IT",
        "CAP": "73058",
        "Localit\u00e0": "TUGLIE",
        "Indirizzo": "VIA TRIESTE, 30",
        "N.ri Tel.": "0833598047",
        "Insegna": "RAINBOW",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC11083-007110,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUH02065-006526"
    },
    "006199": {
        "Stato": "IT",
        "CAP": "20121",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "P.ZZA XXV APRILE, 1",
        "N.ri Tel.": "02 63471267",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDP01295-007323,25WBLUC03086-006047"
    },
    "018518": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA CARLO ALBERTO , 2",
        "N.ri Tel.": "3472541996",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648"
    },
    "021558": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01217-007108,26SBLDC02170-006648,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDH02411-005707,26SBLDL02447-007520,26SBLDP03351-007496,26SBLDP03352-007496,26SBLDP03353-007496,26SBLDX02171-006648,26SBLUC02207-007459,26SBLUC03178-006719,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF02240-006804,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUL02440-007522,26SBLUP03350-007496,26SBLUS01126-007453,26SBLUT02293-006801,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "10011",
        "Localit\u00e0": "AGLIE'",
        "Indirizzo": "VIA PRINCIPE TOMMASO, 6",
        "N.ri Tel.": "012 43630148",
        "Insegna": "ALLARIA ABBIGLIAMENTI",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "004199": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUK11140-007286",
        "Stato": "DE",
        "CAP": "96047",
        "Localit\u00e0": "BAMBERG",
        "Indirizzo": "OBERE BR\u00dcCKE  7",
        "N.ri Tel.": "004995121808",
        "Insegna": "ali er&sie"
    },
    "017829": {
        "CODICE PRODOTTO KOOOMO": "26SBLDC01220-007108,26SBLDC03168-007455,26SBLDC03169-007455,26SBLUC01107-007101,26SBLUC03177-006719,26SBLUC11005-007123,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF03242-006804,26SBLUH02284-007480,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUH02310-007132,26SBLUH02311-007132,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02304-007481",
        "Stato": "ES",
        "CAP": "08013",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "CALLE BALMES 188",
        "N.ri Tel.": "619768266",
        "Insegna": "LINEA DIAGONAL",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "014041": {
        "Stato": "IT",
        "CAP": "16011",
        "Localit\u00e0": "ARENZANO",
        "Indirizzo": "VIA OLIVETTE 18",
        "N.ri Tel.": "010 9127605",
        "Insegna": "OLIVETTE 2",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047"
    },
    "003003": {
        "Stato": "IT",
        "CAP": "22077",
        "Localit\u00e0": "OLGIATE COMASCO",
        "Indirizzo": "VIA SEGANTINI, 14",
        "N.ri Tel.": "031 945155",
        "Insegna": "CONFEZIONI GIEM",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDP01291-007324,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286,26SBLDC01218-007108,26SBLDC02173-007104,26SBLDC03169-007455,26SBLDC11095-007110,26SBLDF01104-007441,26SBLDK11147-007111,26SBLDP01059-007441,26SBLUC01229-007108,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUH02299-007439,26SBLUT02291-006803,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000877": {
        "Stato": "IT",
        "CAP": "80127",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA LUCA GIORDANO, 39",
        "N.ri Tel.": "081 0502087",
        "Insegna": "REVELATION",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03233-007308"
    },
    "011458": {
        "Stato": "IT",
        "CAP": "85042",
        "Localit\u00e0": "LAGONEGRO",
        "Indirizzo": "VIALE ROMA, 36/25",
        "N.ri Tel.": "0973/22061",
        "Insegna": "MARY CHIC",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUX02081-005958,26SBLDC11095-007110,26SBLUC04118-007452,26SBLUC11018-007110,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUH02068-007439,26SBLUH02347-007495,26SBLUH04349-007495,26SBLUM01482-007167,26SBLUM06481-007167,26SBLUP01331-007493,26SBLUP02336-007493,26SBLUP04332-007493,26SBLUS01128-007453,26SBLUT02290-006803,99CBLUP01002-007493,99CBLUP02001-007493,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC11095-007110"
    },
    "014751": {
        "Stato": "ES",
        "CAP": "08720",
        "Localit\u00e0": "VILAFRANCA DE PENEDES",
        "Indirizzo": "CALLE PARELLADA 22",
        "N.ri Tel.": "349212127",
        "Insegna": "JUST",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK01376-007378,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC08078-006355,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC03168-007455,26SBLDC04460-007475,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDH03328-007483,26SBLDK11145-007110,26SBLDK11147-007111,26SBLDP01259-007464,26SBLDP01398-007526,26SBLDP02399-007524,26SBLDP05326-007484,26SBLDS02400-007464,26SBLDV02341-007526,26SBLDV03258-007464,26SBLDV04396-007526,26SBLUC01107-007101,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02306-007440,26SBLUH02312-007132,26SBLUP04048-007465,26SBLUT02064-006526,26SBLUT02290-006803,26SBLUT02291-006803",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "009493": {
        "Stato": "IT",
        "CAP": "37032",
        "Localit\u00e0": "MONTEFORTE D'ALPONE",
        "Indirizzo": "VIA ALPONE, 3/A",
        "N.ri Tel.": "045 6101850",
        "Insegna": "POLI MODE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01220-007108,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC03169-007455,26SBLUC11005-007123,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUH02300-007439,26SBLUH02311-007132,26SBLUP02336-007493,26SBLUT02288-007479,26SBLUT02296-006801,26SBLUX02184-005958,99CBLUP02001-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "000444": {
        "Stato": "IT",
        "CAP": "16162",
        "Localit\u00e0": "GENOVA BOLZANETO",
        "Indirizzo": "VIA PASTORINO, 35 R",
        "N.ri Tel.": "010 7455284",
        "Insegna": "LULLI",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC11083-007110,26SBLUC04139-007449,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUS01358-007499,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "018311": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK11162-007110",
        "Stato": "IT",
        "CAP": "81059",
        "Localit\u00e0": "VAIRANO SCALO",
        "Indirizzo": "VIA NAPOLI, 52",
        "N.ri Tel.": "0823 988924",
        "Insegna": "CLOTHES LIFE"
    },
    "023027": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "MISTERBIANCO",
        "Indirizzo": "VIA GARIBALDI, 605  P.T.",
        "N.ri Tel.": "095-445648",
        "Insegna": "- "
    },
    "021114": {
        "Stato": "ES",
        "CAP": "08700",
        "Localit\u00e0": "IGUALADA, CATALUNA",
        "Indirizzo": "CARRER ODENA 15",
        "N.ri Tel.": "0034 667726068",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648"
    },
    "000573": {
        "Stato": "IT",
        "CAP": "84100",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA DEI MERCANTI, 55",
        "N.ri Tel.": "089 220855",
        "Insegna": "FERLAZZO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUC01022-007110,26SBLUC01106-007101,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUF01032-007441,26SBLUH02068-007439,26SBLUH02541-007608,26SBLUP02037-007441,26SBLUT02295-006801,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01022-007110"
    },
    "018277": {
        "CODICE PRODOTTO KOOOMO": "26SBLGC01389-007111,26SBLGC02380-006648,26SBLGF02507-007557,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGP01510-007557,26SBLGP05508-007557,26SBLKC02364-005958,26SBLKF02516-007557,26SBLKF02527-007557,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKP05531-007557,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "10121",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "PIAZZA CARLO FELICE, 18",
        "N.ri Tel.": "011 3826111",
        "Insegna": "PRIME VANITA'",
        "PRODUCT CODE KOOOMO": "26SBLGC01389-007111"
    },
    "015172": {
        "Stato": "IT",
        "CAP": "80055",
        "Localit\u00e0": "PORTICI",
        "Indirizzo": "VIA DELLA LIBERTA', 166",
        "N.ri Tel.": "3333098891",
        "Insegna": "MAGNI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,26SBLDC01215-007131,26SBLDC11095-007110,26SBLUC04201-007124,26SBLUC11018-007110,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01215-007131"
    },
    "018880": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "70014",
        "Localit\u00e0": "CONVERSANO",
        "Indirizzo": "VIA MANTOVA, 35",
        "N.ri Tel.": "080 4951275",
        "Insegna": "MAX 1980"
    },
    "001652": {
        "Stato": "IT",
        "CAP": "17047",
        "Localit\u00e0": "VADO LIGURE",
        "Indirizzo": "VIA ITALIA, 2",
        "N.ri Tel.": "019 215801",
        "Insegna": "EGO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,26SBLDC03169-007455,26SBLDX02171-006648,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "019010": {
        "Stato": "IT",
        "CAP": "72017",
        "Localit\u00e0": "OSTUNI",
        "Indirizzo": "VIA GIOVANNI XXIII 82,",
        "N.ri Tel.": "0831-305341",
        "Insegna": "META SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC01219-007108,26SBLDC02281-007476,26SBLDC11099-007462,26SBLDH02412-005707,26SBLDP03351-007496,26SBLDS01345-007506,26SBLGC01390-007131,26SBLGC01406-007462,26SBLKA04464-007525,26SBLKC01404-007462,26SBLKC06372-007101,26SBLKH02511-007558,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC04118-007452,26SBLUC11071-007462,26SBLUC11231-006787,26SBLUH04349-007495,26SBLUT02290-006803,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "017850": {
        "Stato": "CZ",
        "CAP": "779 00",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "TYNECKA 714/6",
        "N.ri Tel.": "00420777934924",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047"
    },
    "020510": {
        "Stato": "IT",
        "CAP": "67051",
        "Localit\u00e0": "AVEZZANO",
        "Indirizzo": "VIA SERGIO CATALDI, 144",
        "N.ri Tel.": "0863441428",
        "Insegna": "EMPORIO D'ANTONI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUX02081-005958,26SBLDC02175-007119,26SBLDC02206-007459,26SBLDC11099-007462,26SBLUC02180-007104,26SBLUC11028-007462,26SBLUF01032-007441,26SBLUF02240-006804,26SBLUH02066-006526,26SBLUH02302-007439,26SBLUP01245-006804,26SBLUP04036-007441,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02175-007119"
    },
    "001165": {
        "Stato": "IT",
        "CAP": "80017",
        "Localit\u00e0": "MELITO",
        "Indirizzo": "CORSO EUROPA , 139-141-143",
        "N.ri Tel.": "081 7117671",
        "Insegna": "ANITA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047"
    },
    "021530": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC11083-007110,26SBLUA04465-007525,26SBLUB04119-007449,26SBLUC03178-006719,26SBLUC04118-007452,26SBLUC04139-007449,26SBLUC04201-007124,26SBLUC11021-007111,26SBLUH02299-007439,26SBLUH04349-007495,26SBLUN02129-007447,26SBLUP01120-007452,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02298-007440,26SBLUT02304-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "50113",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE DELL'OCEANO PACIFICO, 83 - UNITA' T106  C/o  C.C. EUR ROMA 2",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI",
        "PRODUCT CODE KOOOMO": "26SBLUA04465-007525"
    },
    "023012": {
        "CODICE PRODOTTO KOOOMO": "25WBLUL01316-007012",
        "Stato": "PL",
        "CAP": "M1 2EG",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- "
    },
    "020893": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648",
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "TERRASINI",
        "Indirizzo": "VIALE INDIPENDENZA, 2",
        "N.ri Tel.": "3890215357",
        "Insegna": "- "
    },
    "000048": {
        "Stato": "IT",
        "CAP": "66023",
        "Localit\u00e0": "FRANCAVILLA AL MARE",
        "Indirizzo": "VIALE NETTUNO, 155",
        "N.ri Tel.": "085 4910656",
        "Insegna": "DEL RE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK03101-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02172-007104,26SBLUC02180-007104,26SBLUH02283-007480,26SBLUH02299-007439,26SBLUL02441-007515,26SBLUS01358-007499,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "000250": {
        "CODICE PRODOTTO KOOOMO": "26SBLUX02184-005958",
        "Stato": "IT",
        "CAP": "00155",
        "Localit\u00e0": "ROMA LUNGHEZZA",
        "Indirizzo": "VIA COLLATINA, 858-860 UNITA' 213  C/o C.C. ROMA EST",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "PRODUCT CODE KOOOMO": "26SBLUX02184-005958"
    },
    "020939": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648",
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "3383015250",
        "Insegna": "- "
    },
    "008232": {
        "Stato": "IT",
        "CAP": "84036",
        "Localit\u00e0": "SALA CONSILINA",
        "Indirizzo": "VIA TRINITA' 67",
        "N.ri Tel.": "0975 45815",
        "Insegna": "CARBONE1950",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC03169-007455,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11231-006787,26SBLUH02283-007480,26SBLUH02300-007439,26SBLUS04360-007499,26SBLUT02294-006801,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC03169-007455"
    },
    "000837": {
        "Stato": "IT",
        "CAP": "22066",
        "Localit\u00e0": "MARIANO COMENSE",
        "Indirizzo": "VIA VOLTA, 26",
        "N.ri Tel.": "031 746224",
        "Insegna": "SORELLE MOTTA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUA05299-006127,25WBLUC02079-005958,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,26SBLUC02179-007104,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUF03044-007465,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUM06472-007529,26SBLUM06473-007528,26SBLUP02037-007441,26SBLUP04048-007465,26SBLUP04141-007448,26SBLUT02288-007479,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "023290": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "VIALE INDIPENDENZA, 2",
        "N.ri Tel.": "3939686845",
        "Insegna": "- "
    },
    "000186": {
        "Stato": "IT",
        "CAP": "93100",
        "Localit\u00e0": "CALTANISSETTA",
        "Indirizzo": "VIA ROSSO DI SAN SECONDO, 87",
        "N.ri Tel.": "0934 599289",
        "Insegna": "CIP SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC11231-006787,26SBLUF03243-006804,26SBLUH02065-006526,26SBLUH02541-007608,26SBLUN02129-007447,26SBLUP04334-007493,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUX02181-007104,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11231-006787"
    },
    "000826": {
        "Stato": "IT",
        "CAP": "24069",
        "Localit\u00e0": "TRESCORE BALNEARIO",
        "Indirizzo": "VIA RESISTENZA, 5/A",
        "N.ri Tel.": "035 940089",
        "Insegna": "PARIMBELLI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03101-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308"
    },
    "017384": {
        "Stato": "IT",
        "CAP": "07026",
        "Localit\u00e0": "OLBIA",
        "Indirizzo": "VIALE ALDO MORO, 219 - ANGOLO VIA VIGNOLA",
        "N.ri Tel.": "078958344",
        "Insegna": "GENTRY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK11162-007110,25WBLUC03233-007308,25WBLUC11083-007110"
    },
    "015319": {
        "Stato": "IT",
        "CAP": "89025",
        "Localit\u00e0": "ROSARNO",
        "Indirizzo": "VIA MARIA ZITA 4",
        "Insegna": "SP NEW IDEA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK01376-007378,25WBLDK03103-006047,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL01316-007012,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC03165-007455,26SBLDC11099-007462,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUH02068-007439,26SBLUH02300-007439,26SBLUT02294-006801,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "010137": {
        "Stato": "IT",
        "CAP": "12037",
        "Localit\u00e0": "SALUZZO",
        "Indirizzo": "CORSO ITALIA 58",
        "N.ri Tel.": "0175 41319",
        "Insegna": "LEI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110"
    },
    "017393": {
        "Stato": "IT",
        "CAP": "71036",
        "Localit\u00e0": "LUCERA",
        "Indirizzo": "VIA ZUPPETTA, 24",
        "N.ri Tel.": "0881 530513",
        "Insegna": "REBECCA FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047"
    },
    "017086": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286",
        "Stato": "IT",
        "CAP": "20833",
        "Localit\u00e0": "GIUSSANO",
        "Indirizzo": "VIA PREALPI 28",
        "N.ri Tel.": "0362 850179",
        "Insegna": "MASCHERONI"
    },
    "017739": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "37011",
        "Localit\u00e0": "BARDOLINO",
        "Indirizzo": "VICOLO VIRGILIO, 3/5",
        "N.ri Tel.": "340 3368660",
        "Insegna": "POP CORN"
    },
    "013976": {
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "RONCADELLE",
        "Indirizzo": "VIA LUIGI EINAUDI",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLDA05335-007349,25WBLDA05336-007349,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC01107-007101,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC03178-006719"
    },
    "001529": {
        "Stato": "IT",
        "CAP": "86045",
        "Localit\u00e0": "PORTOCANNONE",
        "Indirizzo": "VIA GARIBALDI, 15A",
        "N.ri Tel.": "0875 599247",
        "Insegna": "SIMONA FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03357-007294,25WBLDF08236-007301,25WBLDK01375-007378,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDP04294-007324,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,26SBLDC01098-007111,26SBLDC01217-007108,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDH02211-007439,26SBLDH02212-007439,26SBLDH02417-006845,26SBLDH03413-005707,26SBLDH03426-007509,26SBLDL02449-007522,26SBLDP01059-007441,26SBLDP02278-007475,26SBLDP05058-007441,26SBLDV05282-007475,26SBLDX02171-006648,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02066-006526,26SBLUH02237-007439,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUH02541-007608,26SBLUL02441-007515,26SBLUL02442-007515,26SBLUM01471-007529,26SBLUM01482-007167,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01098-007111"
    },
    "019250": {
        "Stato": "IT",
        "CAP": "72021",
        "Localit\u00e0": "FRANCAVILLA FONTANA",
        "Indirizzo": "VIALE LILLA 20",
        "N.ri Tel.": "0831 091415",
        "Insegna": "LILLA CIVICO 20",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDC04460-007475,26SBLDC11099-007462,26SBLDH02416-007507,26SBLDH02418-006845,26SBLUC04118-007452,26SBLUC11019-007110,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUP04332-007493,26SBLUT02290-006803,26SBLUT02297-006801,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC04460-007475"
    },
    "020448": {
        "Stato": "IT",
        "CAP": "94015",
        "Localit\u00e0": "PIAZZA ARMERINA",
        "Indirizzo": "VIALE GENERALE CIANCIO, 25",
        "N.ri Tel.": "0935 956084",
        "Insegna": "MANBITUS",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLGC02391-006648,25WBLKC02429-005958,25WBLKC11416-007110,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC02206-007459,26SBLDC04192-007474,26SBLDC11095-007110,26SBLUC01106-007101,26SBLUC11021-007111,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02290-006803,26SBLUT02297-006801,26SBLUT02321-007481,26SBLUX02181-007104,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "015513": {
        "Stato": "IT",
        "CAP": "87023",
        "Localit\u00e0": "DIAMANTE",
        "Indirizzo": "CORSO V.EMANUELE, 23",
        "Insegna": "MIRIADE DIAMANTE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02192-006648,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC02194-007476,26SBLDC03167-007455,26SBLDC03169-007455,26SBLDC11099-007462,26SBLGC01406-007462,26SBLGC02384-007476,26SBLGC03410-007455,26SBLGF02507-007557,26SBLGH02502-007558,26SBLGP01510-007557,26SBLKC02366-007104,26SBLKC03373-006719,26SBLKF02516-007557,26SBLKH02511-007558,26SBLKH02524-007558,26SBLKP05531-007557,26SBLKT02431-007440,26SBLKX02368-007104",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "020449": {
        "Stato": "IT",
        "CAP": "63074",
        "Localit\u00e0": "VIAREGGIO",
        "Indirizzo": "VIALE SECONDO MORETTI N\u00b0 84",
        "N.ri Tel.": "3395966527",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047"
    },
    "002900": {
        "Stato": "IT",
        "CAP": "00010",
        "Localit\u00e0": "FONTE NUOVA",
        "Indirizzo": "VIA NOMENTANA, 623",
        "N.ri Tel.": "348-8416514",
        "Insegna": "MARCO MASI FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUK03142-005480,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC02206-007459,26SBLDH02327-007483,26SBLDH03328-007483,26SBLDP05326-007484,26SBLUC04118-007452,26SBLUC04201-007124,26SBLUH02069-007439,26SBLUH02283-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUP01120-007452,26SBLUP04334-007493,26SBLUP05150-007448,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "008534": {
        "Stato": "IT",
        "CAP": "88049",
        "Localit\u00e0": "SOVERIA MANNELLI",
        "Indirizzo": "CORSO G.GARIBALDI, 214",
        "N.ri Tel.": "0968 662530",
        "Insegna": "SOTTOSOPRA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDK03103-006047,25WBLDK03495-006047,26SBLDC02172-007104,26SBLDC02174-006648,26SBLDC02281-007476,26SBLDC04192-007474,26SBLDF08323-007484,26SBLDH02327-007483,26SBLDH02415-007507,26SBLDH02416-007507,26SBLDK04249-007474,26SBLDS04343-007506,26SBLUC01200-007108,26SBLUC02179-007104,26SBLUC11231-006787,26SBLUF02034-007441,26SBLUH02284-007480,26SBLUH02541-007608,26SBLUM01471-007529,26SBLUM08479-006233,26SBLUP01331-007493,26SBLUS01128-007453,26SBLUT02288-007479,99CBLUP01002-007493",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "018845": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIALE CARDUCCI, 79",
        "N.ri Tel.": "3935299693",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047"
    },
    "012931": {
        "Stato": "ES",
        "CAP": "17220",
        "Localit\u00e0": "SANT FELIU DE GUIXOLS",
        "Indirizzo": "CALLE MAYOR 9",
        "N.ri Tel.": "+34972821112",
        "Insegna": "CLOVER",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355,26SBLDC01136-007110,26SBLDC01262-007101,26SBLDC03168-007455,26SBLDF01104-007441,26SBLUA04467-007527,26SBLUC11027-007462,26SBLUF01045-007465,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02283-007480,26SBLUH02285-007480,26SBLUH02299-007439,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02307-007132,26SBLUT02321-007481",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "002449": {
        "Stato": "IT",
        "CAP": "98061",
        "Localit\u00e0": "BROLO",
        "Indirizzo": "VIA UGO FOSCOLO S/N",
        "N.ri Tel.": "0941 561547",
        "Insegna": "LS CITY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,26SBLKH02511-007558,26SBLKH02512-007558,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP05531-007557,26SBLKT02431-007440,26SBLUC04118-007452,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUP02037-007441,26SBLUP04334-007493,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUX02181-007104,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04118-007452"
    },
    "012505": {
        "Stato": "IT",
        "CAP": "73029",
        "Localit\u00e0": "VERNOLE",
        "Indirizzo": "VIA MAZZINI, 40",
        "N.ri Tel.": "0832 892134",
        "Insegna": "KUBE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355"
    },
    "012917": {
        "Stato": "IT",
        "CAP": "70023",
        "Localit\u00e0": "GIOIA DEL COLLE",
        "Indirizzo": "VIA ORSINI, 3",
        "N.ri Tel.": "080/3432573",
        "Insegna": "ALEX",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDC03173-007307,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUL01316-007012,25WBLUX02081-005958,26SBLDC02173-007104,26SBLDC02194-007476,26SBLDC02206-007459,26SBLDC03167-007455,26SBLDL02446-007520,26SBLDM01483-007531,26SBLUC04118-007452,26SBLUC04131-007449,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUF03149-007448,26SBLUF08140-007448,26SBLUH02068-007439,26SBLUH02348-007495,26SBLUL02441-007515,26SBLUM01471-007529,26SBLUP01120-007452,26SBLUP01133-007448,26SBLUP04142-007448,26SBLUP04332-007493,26SBLUP04334-007493,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02290-006803,99CBLUP04003-007493,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "018348": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "SAVONA",
        "Indirizzo": "VIA ROMA, 2",
        "N.ri Tel.": "3804364649",
        "Insegna": "- "
    },
    "014070": {
        "Stato": "IT",
        "CAP": "80014",
        "Localit\u00e0": "GIULIANO IN CAMPANIA",
        "Indirizzo": "VIA SAN FRANCESCO A PATRIA C/C GRANDE SUD",
        "N.ri Tel.": "081 8953793",
        "Insegna": "GALIANO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01218-007108,26SBLDC11095-007110,26SBLUC02207-007459,26SBLUC04118-007452,26SBLUC11018-007110,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02299-007439,26SBLUS04360-007499,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "014021": {
        "Stato": "IT",
        "CAP": "09096",
        "Localit\u00e0": "SANTA GIUSTA",
        "Indirizzo": "STRADA PROVINCIALE PER ARBOREA KM. 0,400",
        "N.ri Tel.": "0783359046",
        "Insegna": "VESTIS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK11162-007110,25WBLGC02391-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC02173-007104,26SBLDC11099-007462,26SBLDX03166-007455,26SBLKC01403-007462,26SBLKF03528-007557,26SBLKF03529-007557,26SBLKF08530-007557,26SBLKH02513-007558,26SBLKH02523-007558,26SBLKH02524-007558,26SBLKH02525-007558,26SBLKP05519-007557,26SBLKP05526-007557,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC02180-007104,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUH02313-005695,26SBLUH02314-005695,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "015594": {
        "Stato": "IT",
        "CAP": "07047",
        "Localit\u00e0": "THIESI",
        "Indirizzo": "VIA ROMA, 107",
        "N.ri Tel.": "3939989664",
        "Insegna": "LINUS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUK03142-005480"
    },
    "010143": {
        "Stato": "IT",
        "CAP": "06049",
        "Localit\u00e0": "SPOLETO",
        "Indirizzo": "CORSO MAZZINI, 13",
        "N.ri Tel.": "0743 223331",
        "Insegna": "ZUCCHERO KANDISKY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK05019-007298,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLUB04119-007449,26SBLUC04201-007124,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02300-007439,26SBLUM01471-007529,26SBLUS01358-007499,26SBLUS04360-007499,26SBLUT02064-006526,26SBLUT02290-006803,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUB04119-007449"
    },
    "014096": {
        "Stato": "IT",
        "CAP": "06128",
        "Localit\u00e0": "PERUGIA",
        "Indirizzo": "VIA MARTIRI DEI LAGER 3",
        "N.ri Tel.": "075-5056161 paolo",
        "Insegna": "LUCERTINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDF08057-007441,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC04201-007124,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03242-006804,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUM01477-006233,26SBLUT02288-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "018602": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "GROTTE",
        "Indirizzo": "VIALE DELLA VITTORIA, 31",
        "N.ri Tel.": "0922838751",
        "Insegna": "LA MENDOLA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLUC02207-007459,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUF02240-006804,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUH02541-007608,26SBLUT02295-006801,26SBLUT02304-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02207-007459"
    },
    "006075": {
        "Stato": "IT",
        "CAP": "71019",
        "Localit\u00e0": "VIESTE",
        "Indirizzo": "VIA MADONNA DELLA LIBERA, 32-34",
        "N.ri Tel.": "0884 708992",
        "Insegna": "JOHANAN ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03173-007307,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLUC04139-007449,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUF08140-007448,26SBLUH02246-007457,26SBLUH02301-007439,26SBLUH02347-007495,26SBLUH04349-007495,26SBLUM01471-007529,26SBLUN01432-006581,26SBLUP03350-007496,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "012564": {
        "Stato": "IT",
        "CAP": "81131",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE DEGLI ASTRONAUTI 13,",
        "N.ri Tel.": "081 7413586",
        "Insegna": "LX MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDK02069-006648,25WBLDK02073-006648,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC08078-006355"
    },
    "022584": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "WOLLERSDORF",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "945150305",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03101-006047"
    },
    "016468": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,26SBLUC11027-007462,26SBLUC11028-007462,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUL02434-007520,26SBLUS01358-007499,26SBLUT02298-007440,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "54011",
        "Localit\u00e0": "AULLA",
        "Indirizzo": "VIA NAZIONALE, 44",
        "N.ri Tel.": "0187420786",
        "Insegna": "MILLENNIUM",
        "PRODUCT CODE KOOOMO": "26SBLUC11027-007462"
    },
    "019755": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "52011",
        "Localit\u00e0": "SOCI BIBBIENA",
        "Indirizzo": "VIA DEL LANIFICIO, 18",
        "N.ri Tel.": "0575561530",
        "Insegna": "CASA DEL BAMBINO"
    },
    "004495": {
        "Stato": "IT",
        "CAP": "10129",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA PIGAFETTA, 49/I",
        "N.ri Tel.": "011 591304",
        "Insegna": "BAUDINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUL02318-007340"
    },
    "010662": {
        "Stato": "IT",
        "CAP": "50019",
        "Localit\u00e0": "SESTO FIORENTINO",
        "Indirizzo": "PIAZZA VITTORIO VENETO, 13",
        "N.ri Tel.": "0554489997",
        "Insegna": "CHIOSTRI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958"
    },
    "019485": {
        "Stato": "IT",
        "CAP": "18018",
        "Localit\u00e0": "TAGGIA",
        "Indirizzo": "VIA QUEIROLO, 49",
        "N.ri Tel.": "393.2888859",
        "Insegna": "IN...SIEME",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDK03103-006047,26SBLUF02240-006804,26SBLUF03242-006804,26SBLUH02299-007439,26SBLUH02302-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUF02240-006804"
    },
    "000491": {
        "Stato": "IT",
        "CAP": "62100",
        "Localit\u00e0": "MACERATA",
        "Indirizzo": "VIA TOMMASO LAURI, 30",
        "N.ri Tel.": "0733 235908",
        "Insegna": "CHIARAMONI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,26SBLDC01220-007108,26SBLDC02172-007104,26SBLDC02175-007119,26SBLDF01104-007441,26SBLDH03224-007460,26SBLDP01059-007441,26SBLDX02171-006648,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02234-007457,26SBLUH02236-007439,26SBLUH02237-007439,26SBLUP04036-007441,26SBLUT02290-006803,26SBLUT02295-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    },
    "004968": {
        "Stato": "ES",
        "CAP": "08650",
        "Localit\u00e0": "SALLENT",
        "Indirizzo": "CALLE COS NUM. 16",
        "N.ri Tel.": "0034 687779071",
        "Insegna": "JORDI PADROS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01134-007131,26SBLDC01215-007131,26SBLDC01219-007108,26SBLDC01262-007101,26SBLDC03168-007455,26SBLDF03056-007441,26SBLDH02327-007483,26SBLDK11147-007111,26SBLDL02446-007520,26SBLDM02484-007531,26SBLDP05058-007441,26SBLDP05326-007484,26SBLDV03258-007464,26SBLUA04463-007525,26SBLUC04201-007124,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03149-007448,26SBLUH02065-006526,26SBLUH02233-007457,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02311-007132,26SBLUH02312-007132,26SBLUH02315-005695,26SBLUM06481-007167,26SBLUP05150-007448,26SBLUS01128-007453,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02291-006803",
        "PRODUCT CODE KOOOMO": "26SBLDC01134-007131"
    },
    "008915": {
        "Stato": "IT",
        "CAP": "80128",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA M. KERBAKER, 13",
        "N.ri Tel.": "081 2298348",
        "Insegna": "FREE MAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC11083-007110,26SBLUC04139-007449,26SBLUC11018-007110,26SBLUC11071-007462,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUT02288-007479,26SBLUT02297-006801,26SBLUT02298-007440,26SBLUT02307-007132,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC04139-007449"
    },
    "021095": {
        "Stato": "IT",
        "CAP": "89034",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA SS ANNUNZIATA, 3",
        "N.ri Tel.": "351-3556323",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC06082-005480"
    },
    "023339": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC11099-007462,26SBLDC11100-007462,26SBLDX02171-006648,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUF01239-006804,26SBLUF02240-006804,26SBLUH02284-007480,26SBLUH02287-007480,26SBLUH02302-007439,26SBLUH02306-007440,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "Stato": "IT",
        "CAP": "28883",
        "Localit\u00e0": "GRAVELLONA TOCE",
        "Indirizzo": "STRADA PRIVATA EDISON/CORSO MILANO 141",
        "N.ri Tel.": "0323 840351",
        "Insegna": "SPORTWAY KIDS",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "004840": {
        "Stato": "ES",
        "CAP": "08021",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "CALLE MUNTANER 339 - TIENDA",
        "N.ri Tel.": "0034 93 5907342",
        "Insegna": "NINO ALVAREZ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBLUB04226-007124,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUH02237-007439,26SBLUH02299-007439,26SBLUH02311-007132,26SBLUH02312-007132,26SBLUH02317-005695,26SBLUN02129-007447,26SBLUT02290-006803",
        "PRODUCT CODE KOOOMO": "26SBLUB04226-007124"
    },
    "014255": {
        "Stato": "IT",
        "CAP": "09044",
        "Localit\u00e0": "QUARTUCCIU",
        "Indirizzo": "VIA DELLE SERRE SNC",
        "N.ri Tel.": "070 8801251",
        "Insegna": "BACKSTAGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUX02081-005958,26SBLUC01199-007108,26SBLUC02180-007104,26SBLUC11028-007462,26SBLUH02065-006526,26SBLUH02068-007439,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02297-006801,26SBLUT02321-007481,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01199-007108"
    },
    "017006": {
        "Stato": "IT",
        "CAP": "70054",
        "Localit\u00e0": "GIOVINAZZO",
        "Indirizzo": "VIA AGOSTINO GIOIA 13 15",
        "N.ri Tel.": "3461356719",
        "Insegna": "DEPERGOLA DAL 1942",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480,26SBLDC02170-006648,26SBLDC11099-007462,26SBLUC02179-007104,26SBLUC11018-007110,26SBLUF01239-006804,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02302-007439,26SBLUH02312-007132,26SBLUP01245-006804,26SBLUP02037-007441,26SBLUT02289-007479,26SBLUT02290-006803,26SBLUT02294-006801,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02170-006648"
    },
    "007403": {
        "Stato": "IT",
        "CAP": "81055",
        "Localit\u00e0": "SANTA MARIA CAPUA VETERE",
        "Indirizzo": "CORSO ALDO MORO, 91",
        "N.ri Tel.": "0823 840550",
        "Insegna": "DEL RE WOMAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUH02068-007439,26SBLUH02283-007480,26SBLUH02284-007480,26SBLUH02299-007439,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC11021-007111"
    },
    "018301": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA ALIMENA SNC",
        "N.ri Tel.": "0968/750121",
        "Insegna": "MARVIN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,26SBLUC01106-007101,26SBLUC01200-007108,26SBLUC11027-007462,26SBLUC11231-006787,26SBLUF01239-006804,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUP04334-007493,26SBLUT02288-007479,26SBLUT02293-006801,26SBLUT02294-006801,26SBLUT02298-007440,26SBLUX02184-005958,99CBLUP04004-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "015240": {
        "Stato": "ES",
        "CAP": "17210",
        "Localit\u00e0": "CALELLA DE PALAFRUGELL",
        "Indirizzo": "CALLE BOFILL Y CODINA 23",
        "N.ri Tel.": "0034 972615357",
        "Insegna": "ALFER",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDF08236-007301,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC06082-005480,25WBLUC08078-006355,26SBLDC04077-007474,26SBLDF01104-007441,26SBLDF01322-007484,26SBLDH02327-007483,26SBLDH03328-007483,26SBLDH03413-005707,26SBLDP02399-007524,26SBLDP05326-007484,26SBLDS04392-007506,26SBLDV03258-007464,26SBLGF08505-007557,26SBLGH02501-007558,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKA04464-007525,26SBLKF02527-007557,26SBLKF03528-007557,26SBLKH02511-007558,26SBLKH02524-007558,26SBLKN02491-007542,26SBLKP05531-007557,26SBLKT02514-007559,26SBLUA04463-007525,26SBLUC04201-007124,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF01239-006804,26SBLUF03242-006804,26SBLUH02284-007480,26SBLUH02311-007132,26SBLUM06481-007167,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02296-006801,26SBLUT02307-007132",
        "PRODUCT CODE KOOOMO": "26SBLDC04077-007474"
    },
    "001493": {
        "Stato": "IT",
        "CAP": "36027",
        "Localit\u00e0": "ROSA'",
        "Indirizzo": "VIA MAZZINI, 65",
        "N.ri Tel.": "0424 582016",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,26SBLDC03167-007455,26SBLDC11099-007462,26SBLUC03197-006719,26SBLUF01032-007441,26SBLUH02305-007457,26SBLUN02490-007542,26SBLUP02037-007441,26SBLUP04036-007441,26SBLUT02288-007479",
        "PRODUCT CODE KOOOMO": "26SBLDC03167-007455"
    },
    "007331": {
        "Stato": "IT",
        "CAP": "00175",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DELL'AEROPORTO, 45-47",
        "N.ri Tel.": "06 76902690 amm.",
        "Insegna": "FRANCAVILLA MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03101-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUX02081-005958,26SBLDC02173-007104,26SBLDC02206-007459,26SBLDC02228-007119,26SBLDC03169-007455,26SBLDH02411-005707,26SBLDL02536-007515,26SBLDT02087-006526,26SBLDX02171-006648,26SBLUB04119-007449,26SBLUC02207-007459,26SBLUC03177-006719,26SBLUC04139-007449,26SBLUH02299-007439,26SBLUH02302-007439,26SBLUT02288-007479,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02173-007104"
    },
    "004864": {
        "Stato": "ES",
        "CAP": "33450",
        "Localit\u00e0": "Piedras Blancas, Asturias",
        "Indirizzo": "Av. Eysines, 20",
        "N.ri Tel.": "0034 985533577",
        "Insegna": "ARNALDO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286,26SBLUC01106-007101,26SBLUC01107-007101,26SBLUC02207-007459,26SBLUC11018-007110,26SBLUT02288-007479,26SBLUT02293-006801",
        "PRODUCT CODE KOOOMO": "26SBLUC01106-007101"
    },
    "010584": {
        "Stato": "IT",
        "CAP": "82020",
        "Localit\u00e0": "PIETRELCINA",
        "Indirizzo": "VIA NAZIONALE S.N.C, 1",
        "N.ri Tel.": "0824997395",
        "Insegna": "SOVISA",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047"
    },
    "009245": {
        "Stato": "IT",
        "CAP": "75100",
        "Localit\u00e0": "MATERA",
        "Indirizzo": "VIA LUCANA, 112",
        "N.ri Tel.": "3385693071",
        "Insegna": "SCANDIFFIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUK11140-007286"
    },
    "019816": {
        "Stato": "IT",
        "CAP": "93014",
        "Localit\u00e0": "MUSSOMELI",
        "Indirizzo": "CONTRADA MONTICELLI S.N.",
        "N.ri Tel.": "0934992527",
        "Insegna": "FASINO",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02177-007284,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUL01316-007012,26SBLDC02170-006648,26SBLDC02172-007104,26SBLDC02206-007459,26SBLDF01104-007441,26SBLUC02179-007104,26SBLUC02207-007459,26SBLUC03197-006719,26SBLUF02034-007441,26SBLUH02065-006526,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUT02064-006526,26SBLUT02288-007479,26SBLUT02295-006801,26SBLUT02297-006801,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02170-006648"
    },
    "016121": {
        "Stato": "IT",
        "CAP": "73024",
        "Localit\u00e0": "MAGLIE",
        "Indirizzo": "VIA ROMA,26",
        "N.ri Tel.": "328 4548830",
        "Insegna": "VIA ROMA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDK02069-006648,25WBLDP04294-007324,25WBLUA05299-006127,25WBLUA05301-006434,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,25WBLUX02081-005958,26SBLDC02206-007459,26SBLDC03169-007455,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDH02417-006845,26SBLDP01059-007441,26SBLDP01259-007464,26SBLDP03352-007496,26SBLDS02355-007501,26SBLDS02400-007464,26SBLDV03258-007464,26SBLDV05282-007475,26SBLUC04118-007452,26SBLUF01032-007441,26SBLUF03035-007441,26SBLUH02068-007439,26SBLUH02236-007439,26SBLUH02238-007439,26SBLUH02283-007480,26SBLUH02302-007439,26SBLUL02441-007515,26SBLUL02443-007514,26SBLUL02445-007516,26SBLUN01432-006581,26SBLUN02129-007447,26SBLUN02490-007542,26SBLUP01120-007452,26SBLUP02037-007441,26SBLUP03329-007496,26SBLUP04052-007503,26SBLUS01252-007464,26SBLUS02250-007464,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02206-007459"
    },
    "013695": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02153-007300",
        "Stato": "IT",
        "CAP": "10138",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA PALMIERI 47/P",
        "N.ri Tel.": "340 2728804",
        "Insegna": "- "
    },
    "019351": {
        "Stato": "IT",
        "CAP": "20037",
        "Localit\u00e0": "PADERNO DUGNANO",
        "Indirizzo": "STRADA STATALE DEI GIOVI, 35",
        "N.ri Tel.": "3387644591",
        "Insegna": "MARTINS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUX02081-005958,26SBLDC01217-007108,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDC03169-007455,26SBLDF03056-007441,26SBLDF08057-007441,26SBLDP01059-007441,26SBLUC01022-007110,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUC03177-006719,26SBLUC11028-007462,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "021184": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "85059",
        "Localit\u00e0": "VILLA D'AGRI DI MARSICOVETERE",
        "Indirizzo": "VIA VITTORIO EMANUELE II SN",
        "N.ri Tel.": "0975 354447",
        "Insegna": "COIRO FASHION TIME"
    },
    "022204": {
        "Stato": "IT",
        "CAP": "93012",
        "Localit\u00e0": "TRAVERSETOLO",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "911 236 444",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDK03103-006047,25WBLGC02391-006648"
    },
    "015940": {
        "Stato": "IT",
        "CAP": "50113",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE DELL'OCEANO PACIFICO, 83 - UNITA' T106  C/o  C.C. EUR ROMA 2",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUL02318-007340,26SBLUF01239-006804,26SBLUH02286-007480",
        "PRODUCT CODE KOOOMO": "26SBLUF01239-006804"
    },
    "006217": {
        "Stato": "IT",
        "CAP": "10136",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA VITTORIO EMANUELE, 76",
        "N.ri Tel.": "011 3292512",
        "Insegna": "NEW SALOON JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUK03142-005480,26SBLUF02240-006804,26SBLUH02068-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUT02321-007481,26SBLUX02184-005958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUF02240-006804"
    },
    "020091": {
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "28021",
        "Localit\u00e0": "BORGOMANERO",
        "Indirizzo": "CORSO ROMA, 100",
        "Insegna": "FATE E FOLLETTI"
    },
    "000377": {
        "Stato": "IT",
        "CAP": "15067",
        "Localit\u00e0": "NOVI LIGURE",
        "Indirizzo": "PIAZZA DELLE PIANE, 4",
        "N.ri Tel.": "388-5834586",
        "Insegna": "L'EQUATORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC05125-007283,25WBLUC11083-007110,26SBLDC02172-007104,26SBLDC02173-007104,26SBLDP03351-007496,26SBLUC02179-007104,26SBLUC02180-007104,26SBLUF01239-006804,26SBLUH02068-007439,26SBLUH02069-007439,26SBLUH02284-007480,26SBLUH02302-007439,26SBLUH02315-005695,26SBLUP01245-006804,26SBLUP03329-007494,26SBLUP03350-007496,26SBLUP04332-007493,26SBLUS01270-007502,26SBLUS01356-007500,26SBLUT02290-006803,26SBLUT02293-006801,26SBLUT02297-006801,99CBLUP04003-007493,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC02172-007104"
    },
    "016588": {
        "Stato": "ES",
        "CAP": "17800",
        "Localit\u00e0": "OLOT (GIRONA)",
        "Indirizzo": "C / FERRARONS N. 3-5",
        "N.ri Tel.": "034 972260831",
        "Insegna": "DOMENECHC",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC03400-007308,26SBLKF02527-007557,26SBLKH02522-007558,26SBLKH02523-007558,26SBLKN02491-007542,26SBLKP05526-007557",
        "PRODUCT CODE KOOOMO": "26SBLKF02527-007557"
    },
    "004791": {
        "Stato": "AD",
        "CAP": "500",
        "Localit\u00e0": "ANDORRA LA VELLA - PRINCIPAT D'ANDORRA",
        "Indirizzo": "C/ de l'Aigueta 14",
        "N.ri Tel.": "0037 376803140",
        "Insegna": "POLLYANNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLKC03400-007308,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480,26SBBXC02422-005958,26SBLDC01218-007108,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC02175-007119,26SBLDC02176-006648,26SBLDC03168-007455,26SBLDC03169-007455,26SBLGC02380-006648,26SBLGC03410-007455,26SBLKC02364-005958,26SBLKC03373-006719,26SBLKX02365-005958,26SBLUC01106-007101,26SBLUC01107-007101,26SBLUC03177-006719,26SBLUC03178-006719,26SBLUC11231-006787,26SBLUH02284-007480,26SBLUT02288-007479,26SBLUT02307-007132,99CBLDA09007-007795",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000531": {
        "Stato": "IT",
        "CAP": "09042",
        "Localit\u00e0": "MONSERRATO",
        "Indirizzo": "VIA GIULIO CESARE, 152",
        "N.ri Tel.": "070 572478",
        "Insegna": "PUSHAK",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC11083-007110"
    },
    "011278": {
        "Stato": "IT",
        "CAP": "63082",
        "Localit\u00e0": "CASTEL DI LAMA",
        "Indirizzo": "VIA SALARIA 222,",
        "N.ri Tel.": "0736/814195",
        "Insegna": "AMADIO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUA05299-006127,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,26SBLDC01217-007108,26SBLDC01220-007108,26SBLDC02206-007459,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDH02416-007507,26SBLDK11147-007111,26SBLDP01059-007441,26SBLUC02207-007459,26SBLUC04139-007449,26SBLUC11027-007462,26SBLUF02034-007441,26SBLUF03035-007441,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02299-007439,26SBLUP04036-007441,26SBLUT02288-007479,26SBLUT02304-007481,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01217-007108"
    },
    "001394": {
        "Stato": "IT",
        "CAP": "04019",
        "Localit\u00e0": "TERRACINA",
        "Indirizzo": "VIA ROMA, 134/136",
        "N.ri Tel.": "0773 705057",
        "Insegna": "CARMEN",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK02073-006648,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,26SBBXF02493-007570,26SBBXH02498-007558,26SBBXP01494-007570,26SBLDC01136-007110,26SBLDC11099-007462,26SBLDF01114-006804,26SBLDH03222-007460,26SBLDP01116-006804,26SBLDP02399-007524,26SBLDV02341-007526,26SBLGF08505-007557,26SBLGH02502-007558,26SBLGH03504-007561,26SBLGP05508-007557,26SBLKF03528-007557,26SBLKH02513-007558,26SBLKH02522-007558,26SBLKH02524-007558,26SBLKP01521-007557,26SBLKP05519-007557,26SBLKP05531-007557,26SBLKX02365-005958,26SBLUC01108-007101,26SBLUC04118-007452,26SBLUC11028-007462,26SBLUC11071-007462,26SBLUH02068-007439,26SBLUP01361-007504,26SBLUS01126-007453,26SBLUS01128-007453,26SBLUT02298-007440,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01136-007110"
    },
    "019843": {
        "Stato": "IT",
        "CAP": "62012",
        "Localit\u00e0": "CIVITANOVA MARCHE",
        "Indirizzo": "PIAZZA 20 SETTEMBRE, 43",
        "N.ri Tel.": "0733771748",
        "Insegna": "IL GALEONE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03098-006047,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,26SBLDC01218-007108,26SBLDC02172-007104,26SBLDL02536-007515,26SBLUC02180-007104,26SBLUC04201-007124,26SBLUC11028-007462,26SBLUL02441-007515,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01218-007108"
    },
    "000547": {
        "Stato": "IT",
        "CAP": "89018",
        "Localit\u00e0": "VILLA S. GIOVANNI",
        "Indirizzo": "VIALE ITALIA, 10/12",
        "N.ri Tel.": "0965 795060",
        "Insegna": "GIALLO OCRA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLKC02427-005958,25WBLKC03400-007308,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC08078-006355"
    },
    "016384": {
        "Stato": "DE",
        "CAP": "54516",
        "Localit\u00e0": "Wittlich",
        "Indirizzo": "Friedrichstrasse 59",
        "N.ri Tel.": "+49 6571 696440",
        "Insegna": "BUNGERT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02151-007287,25WBLUC03090-006719"
    },
    "001193": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480",
        "Stato": "IT",
        "CAP": "80121",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA DEI MILLE, 83",
        "N.ri Tel.": "081 5567392",
        "Insegna": "PASKAL"
    },
    "000604": {
        "Stato": "IT",
        "CAP": "37045",
        "Localit\u00e0": "LEGNAGO Loc. SAN PIETRO",
        "Indirizzo": "VIALE EUROPA, 38",
        "N.ri Tel.": "0442 629079",
        "Insegna": "PUNTO BLU ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03161-006719,25WBLDK11162-007110,25WBLGC02391-006648,25WBLKC02427-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,26SBLDC01219-007108,26SBLDC01220-007108,26SBLDC11095-007110,26SBLDF01104-007441,26SBLDF08057-007441,26SBLDH02411-005707,26SBLDK11145-007110,26SBLDP01059-007441,26SBLGC01389-007111,26SBLGC02385-007459,26SBLGH02501-007558,26SBLKC01403-007462,26SBLKC06372-007101,26SBLKF03528-007557,26SBLKF08530-007557,26SBLKH02523-007558,26SBLKP01521-007557,26SBLKP05526-007557,26SBLKX02365-005958,26SBLUB11112-006787,26SBLUC03177-006719,26SBLUC04201-007124,26SBLUC11018-007110,26SBLUC11021-007111,26SBLUC11028-007462,26SBLUC11231-006787,26SBLUF01032-007441,26SBLUF02034-007441,26SBLUH02287-007480,26SBLUM01477-006233,26SBLUP04036-007441,26SBLUT02289-007479,26SBLUX03232-006719,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDC01219-007108"
    },
    "001701": {
        "Stato": "IT",
        "CAP": "70031",
        "Localit\u00e0": "ANDRIA",
        "Indirizzo": "VIA REGINA MARGHERITA, 93 C-D",
        "N.ri Tel.": "0883 597570",
        "Insegna": "D'AVANZO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUK03142-005480,26SBLUC02179-007104,26SBLUC11018-007110,26SBLUH02300-007439,26SBLUH02302-007439,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLUC02179-007104"
    },
    "018613": {
        "Stato": "IT",
        "CAP": "89035",
        "Localit\u00e0": "BOVA MARINA",
        "Indirizzo": "CORSO UMBERTO I, 200/B",
        "N.ri Tel.": "0965760016",
        "Insegna": "GLAMOUR",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,26SBLDH02411-005707,26SBLDH02414-005707,26SBLDH02416-007507,26SBLDH02417-006845,26SBLDK04249-007474,26SBLDP01073-007474,26SBLDP05265-007474,26SBLDT02086-006526,26SBLUC11231-006787,26SBLUH02065-006526,26SBLUH02284-007480,26SBLUH02285-007480,26SBLUH02286-007480,26SBLUH02299-007439,26SBLUH02300-007439,26SBLUH02301-007439,26SBLUH02302-007439,26SBLUS01356-007500,26SBLUT02064-006526,26SBLUT02289-007479,26SBLUX02184-005958,26SBLUX02184-A05958,BLAP076-POP,BLAP078-POP",
        "PRODUCT CODE KOOOMO": "26SBLDH02411-005707"
    },
    "023430": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05338-006127,25WBLDC03100-006047",
        "Stato": "UA",
        "CAP": "82031",
        "Localit\u00e0": "Swadzim",
        "Indirizzo": "ZABOLOTNOGO 67/1",
        "N.ri Tel.": "974244948",
        "Insegna": "- "
    },
    "019109": {
        "Stato": "ES",
        "CAP": "49600",
        "Localit\u00e0": "ZAMORA",
        "Indirizzo": "CALLE RUA, 26",
        "N.ri Tel.": "980632076",
        "Insegna": "JAPPA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK03098-006047,25WBLDK03102-006047,26SBLDC01220-007108,26SBLDC01262-007101,26SBLDC02175-007119,26SBLDC02176-006648,26SBLDC03168-007455,26SBLDH02425-007495,26SBLDK11147-007111",
        "PRODUCT CODE KOOOMO": "26SBLDC01220-007108"
    }
};

(function() {
    var errorProd = document.querySelector('.error-prod-code');
    /*ERROR MESSAGE*/
    const error_message = document.getElementById("error_store");
    /*CONTAINER*/
	const containerStores = document.getElementById("container-stores");
	/* SELECTS*/
	const selectStato = document.getElementById("country_store");
	const selectLocalita = document.getElementById("city_store");
	/*INPUT*/
	const input_code = document.getElementById("prod_code");
	/* Selezioniamo il pulsante*/
	const cercaButton = document.getElementById('search-store');
    function checkAvailableSelection(){
        let str_code=input_code.value;
        let statoSelected = selectStato.options[selectStato.selectedIndex].value;
        if(str_code == ""){
            return false;  
        }
        if(str_code != "" || statoSelected != "0"){
            let _stato='';
            let _localita='';
            for (let key in stores_json) {
                if(  ( str_code == "" || stores_json[key]["CODICE PRODOTTO KOOOMO"].includes(str_code) ) && ( statoSelected == "0" || stores_json[key]["Stato"] == statoSelected ) ){
                    if(!_localita.includes(stores_json[key]['Localit\u00e0']))
                        _localita +=stores_json[key]['Localit\u00e0']+',';
                    if(!_stato.includes(stores_json[key]['Stato']))
                        _stato +=stores_json[key]['Stato']+',';
                }
            }
            if(str_code != "" ){
                for(var i = 0; i < selectStato.options.length; i++){
                    if(!_stato.includes(selectStato.options[i].value) && selectStato.options[i].value != "0" ){
                        selectStato.options[i].className="hidden";
                    }else{				
                        selectStato.options[i].className="";
                    }
                }
            }
            for(var i = 0; i < selectLocalita.options.length; i++){
                if(!_localita.includes(selectLocalita.options[i].textContent) && selectLocalita.options[i].value != "0"){
					selectLocalita.options[i].className="hidden";
				}else{				
					selectLocalita.options[i].className="";
				}
            }
        }else{
            selectStato.options[0].selected = true;
            selectLocalita.options[0].selected = true;
            /*active all COUNTRY*/
            for(var i = 0; i < selectStato.options.length; i++){
				selectStato.options[i].selected = false;
				selectStato.options[i].className="";
			}
			
            /*active all CITY*/
            for(var i = 0; i < selectLocalita.options.length; i++){
				selectLocalita.options[i].selected = false;
				selectLocalita.options[i].className="";
			}

			selectLocalita.options[0].selected = true;
            selectStato.options[0].selected = true;
        }
    }
    /*HIDE CONTRY AND CITY WHERE CODE IS NOT PLACED*/
    input_code.addEventListener('input', (event) => {
        checkAvailableSelection();       
    });
	/*SELECT COUNTRY*/
	selectStato.onchange = function() {
        for(var i = 0; i < selectLocalita.options.length; i++){
            selectLocalita.options[i].selected = false;
        }
        selectLocalita.options[0].selected = true;
        checkAvailableSelection();
	};
	/* CERCA*/
    let countStore=0;
	cercaButton.onclick = function() {
        countStore=0;
		let str_code=input_code.value;
        if(str_code == ""){
            errorProd.classList.add('error');
            return false;  
        }else{
            errorProd.classList.remove('error');
        }
		let statoSelected = selectStato.options[selectStato.selectedIndex].value;
		let localitaSelected = selectLocalita.options[selectLocalita.selectedIndex].value;
		if(localitaSelected != 0)
			localitaSelected = selectLocalita.options[selectLocalita.selectedIndex].textContent;

		containerStores.innerHTML="";
		/* cerco nel JSON quali store corrispondono*/
        
		for (let key in stores_json) {
			let is_it=true;
			if (stores_json.hasOwnProperty(key)) {
				if( ( str_code == '' || stores_json[key]["CODICE PRODOTTO KOOOMO"].includes(str_code) )){
					is_it = true;
				}else{
					is_it = false;

				}
				if( is_it && ( localitaSelected == '0' || stores_json[key]["Localit\u00e0"]==localitaSelected )){
					is_it = true;
				}else{
					is_it = false;
				}		
				if( is_it && ( statoSelected == '0' || stores_json[key]["Stato"]==statoSelected )){
					is_it = true;
				}else{
					is_it = false;
				}
				if(is_it){
                    let insegna =stores_json[key]['Insegna'];
                    if(insegna == "- "){
                        insegna="";
                    }
					let newElement = document.createElement('div');
                    let stringHTML="<div class='innerCard'>";
                    stringHTML+="<b class='store_insegna'>"+insegna.toLowerCase() +"</b>";                    
                    stringHTML+='<label class="store_indirizzo"><i class="fa fa-map"></i> '+stores_json[key]['Indirizzo'].toLowerCase()+', ' ;
                    stringHTML+=stores_json[key]['CAP'].toLowerCase()+'</label>' ;
                    stringHTML+='<label class="store_localita">'+stores_json[key]['Localit\u00e0'].toLowerCase() ;
                    stringHTML+=', ' + stores_json[key]['Stato']+'</label>' ;                    
                    stringHTML+='<label class="store_telefono"><i class="fa fa-phone"></i> '+stores_json[key]['N.ri Tel.']+'</label>';
                    stringHTML+='</div>';

					newElement.className="card";
					newElement.innerHTML = stringHTML;
					containerStores.appendChild(newElement);
                    countStore++;
				}
			}
		}
        if(countStore==0){
            error_message.className="";
        }else{
            error_message.className="hidden";
        }

	};

	/*CREO LE OPTION DELLE SELECT DAL JSON*/
	for (let key in stores_json) {
		if (stores_json.hasOwnProperty(key)) {
			let stato = stores_json[key].Stato;
			let localita = stores_json[key]['Localit\u00e0'];
			if(!selectHasValue('country_store',stato)){
				let optionStato = document.createElement('option');
				optionStato.value = stato.toUpperCase();
				optionStato.textContent = countries[stato].toUpperCase();
				selectStato.appendChild(optionStato);
			}
			if(!selectHasValueLocalita('city_store',localita)){
				let optionLocalita = document.createElement('option');
				optionLocalita.value = stato.toUpperCase();
				optionLocalita.textContent = localita.toUpperCase();
				selectLocalita.appendChild(optionLocalita);
			}
		}
	}

	function selectHasValue(selectId, value) {
		const select = document.getElementById(selectId);
		if (select !== null) {
			return select.innerHTML.indexOf('value="' + value.toUpperCase() + '"') > -1;
		} else {
			return false;
		}
	}
	function selectHasValueLocalita(selectId, value) {
		const select = document.getElementById(selectId);
		if (select !== null) {
			return select.innerHTML.indexOf('>' + value.toUpperCase() + '<') > -1;
		} else {
			return false;
		}
	}

	function sortSelect(selElem) {
		let tmpAry = [];
		for (let i = 0; i < selElem.options.length; i++) {
			tmpAry[i] = [selElem.options[i].text, selElem.options[i].value];
		}
		tmpAry.sort();

		while (selElem.options.length > 0) {
			selElem.options[0] = null;
		}
		for (let i = 0; i < tmpAry.length; i++) {
			if(tmpAry[i][1] == 0){				
				let op = new Option(tmpAry[i][0], tmpAry[i][1]);
				selElem.options[0] = op;
			}
		}
		let count=1;
		for (let i = 0; i < tmpAry.length; i++) {
			if(tmpAry[i][1] != 0){
				let op = new Option(tmpAry[i][0], tmpAry[i][1]);
				selElem.options[count] = op;
				count++;
			}
			
		}
		
	}
	sortSelect(selectStato);
	sortSelect(selectLocalita);
    if(input_code.value.length != 0){
        cercaButton.click();
    }
})();